/*! 4.37.0 / Consumer  */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.PubNub = t() : e.PubNub = t();
}(window, function () {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 31);
  }([function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    t.default = {
      PNTimeOperation: "PNTimeOperation",
      PNHistoryOperation: "PNHistoryOperation",
      PNDeleteMessagesOperation: "PNDeleteMessagesOperation",
      PNFetchMessagesOperation: "PNFetchMessagesOperation",
      PNMessageCounts: "PNMessageCountsOperation",
      PNSubscribeOperation: "PNSubscribeOperation",
      PNUnsubscribeOperation: "PNUnsubscribeOperation",
      PNPublishOperation: "PNPublishOperation",
      PNSignalOperation: "PNSignalOperation",
      PNAddMessageActionOperation: "PNAddActionOperation",
      PNRemoveMessageActionOperation: "PNRemoveMessageActionOperation",
      PNGetMessageActionsOperation: "PNGetMessageActionsOperation",
      PNCreateUserOperation: "PNCreateUserOperation",
      PNUpdateUserOperation: "PNUpdateUserOperation",
      PNDeleteUserOperation: "PNDeleteUserOperation",
      PNGetUserOperation: "PNGetUsersOperation",
      PNGetUsersOperation: "PNGetUsersOperation",
      PNCreateSpaceOperation: "PNCreateSpaceOperation",
      PNUpdateSpaceOperation: "PNUpdateSpaceOperation",
      PNDeleteSpaceOperation: "PNDeleteSpaceOperation",
      PNGetSpaceOperation: "PNGetSpacesOperation",
      PNGetSpacesOperation: "PNGetSpacesOperation",
      PNGetMembersOperation: "PNGetMembersOperation",
      PNUpdateMembersOperation: "PNUpdateMembersOperation",
      PNGetMembershipsOperation: "PNGetMembershipsOperation",
      PNUpdateMembershipsOperation: "PNUpdateMembershipsOperation",
      PNListFilesOperation: "PNListFilesOperation",
      PNGenerateUploadUrlOperation: "PNGenerateUploadUrlOperation",
      PNPublishFileOperation: "PNPublishFileOperation",
      PNGetFileUrlOperation: "PNGetFileUrlOperation",
      PNDownloadFileOperation: "PNDownloadFileOperation",
      PNGetAllUUIDMetadataOperation: "PNGetAllUUIDMetadataOperation",
      PNGetUUIDMetadataOperation: "PNGetUUIDMetadataOperation",
      PNSetUUIDMetadataOperation: "PNSetUUIDMetadataOperation",
      PNRemoveUUIDMetadataOperation: "PNRemoveUUIDMetadataOperation",
      PNGetAllChannelMetadataOperation: "PNGetAllChannelMetadataOperation",
      PNGetChannelMetadataOperation: "PNGetChannelMetadataOperation",
      PNSetChannelMetadataOperation: "PNSetChannelMetadataOperation",
      PNRemoveChannelMetadataOperation: "PNRemoveChannelMetadataOperation",
      PNSetMembersOperation: "PNSetMembersOperation",
      PNSetMembershipsOperation: "PNSetMembershipsOperation",
      PNPushNotificationEnabledChannelsOperation: "PNPushNotificationEnabledChannelsOperation",
      PNRemoveAllPushNotificationsOperation: "PNRemoveAllPushNotificationsOperation",
      PNWhereNowOperation: "PNWhereNowOperation",
      PNSetStateOperation: "PNSetStateOperation",
      PNHereNowOperation: "PNHereNowOperation",
      PNGetStateOperation: "PNGetStateOperation",
      PNHeartbeatOperation: "PNHeartbeatOperation",
      PNChannelGroupsOperation: "PNChannelGroupsOperation",
      PNRemoveGroupOperation: "PNRemoveGroupOperation",
      PNChannelsForGroupOperation: "PNChannelsForGroupOperation",
      PNAddChannelsToGroupOperation: "PNAddChannelsToGroupOperation",
      PNRemoveChannelsFromGroupOperation: "PNRemoveChannelsFromGroupOperation",
      PNAccessManagerGrant: "PNAccessManagerGrant",
      PNAccessManagerGrantToken: "PNAccessManagerGrantToken",
      PNAccessManagerAudit: "PNAccessManagerAudit",
      PNAccessManagerRevokeToken: "PNAccessManagerRevokeToken"
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    e.exports = {};
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function n(e) {
        return encodeURIComponent(e).replace(/[!~*'()]/g, function (e) {
          return "%".concat(e.charCodeAt(0).toString(16).toUpperCase());
        });
      }
      function r(e) {
        return function (e) {
          var t = [];
          return Object.keys(e).forEach(function (e) {
            return t.push(e);
          }), t;
        }(e).sort();
      }
      var i = "The Objects v1 API has been deprecated.\nYou can learn more about Objects v2 API at https://www.pubnub.com/docs/web-javascript/api-reference-objects.\nIf you have questions about the Objects v2 API or require additional help with migrating to the new data model, please contact PubNub Support at support@pubnub.com.";
      e.exports = {
        signPamFromParams: function signPamFromParams(e) {
          return r(e).map(function (t) {
            return "".concat(t, "=").concat(n(e[t]));
          }).join("&");
        },
        endsWith: function endsWith(e, t) {
          return -1 !== e.indexOf(t, this.length - t.length);
        },
        createPromise: function createPromise() {
          var e, t;
          return {
            promise: new Promise(function (n, r) {
              e = n, t = r;
            }),
            reject: t,
            fulfill: e
          };
        },
        encodeString: n,
        deprecated: function deprecated(e) {
          return function () {
            var n, r;
            void 0 !== t && "test" !== (null === (n = t) || void 0 === n || null === (r = n.env) || void 0 === r ? void 0 : "production") && console.warn(i);
            return e.apply(void 0, arguments);
          };
        }
      };
    }).call(this, n(42));
  }, function (e, t) {
    e.exports = function (e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    e.exports = function (e, t, r) {
      return t && n(e.prototype, t), r && n(e, r), e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    function n(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = n = function n(e) {
        return typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0), n(t);
    }
    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(6)),
      a = r(n(4)),
      u = r(n(17)),
      s = (n(2), function () {
        function e(t) {
          var n,
            r,
            o = t.setup,
            s = t.db;
          if ((0, i.default)(this, e), (0, a.default)(this, "_db", void 0), (0, a.default)(this, "subscribeKey", void 0), (0, a.default)(this, "publishKey", void 0), (0, a.default)(this, "secretKey", void 0), (0, a.default)(this, "cipherKey", void 0), (0, a.default)(this, "authKey", void 0), (0, a.default)(this, "UUID", void 0), (0, a.default)(this, "proxy", void 0), (0, a.default)(this, "instanceId", void 0), (0, a.default)(this, "sdkName", void 0), (0, a.default)(this, "sdkFamily", void 0), (0, a.default)(this, "partnerId", void 0), (0, a.default)(this, "filterExpression", void 0), (0, a.default)(this, "suppressLeaveEvents", void 0), (0, a.default)(this, "secure", void 0), (0, a.default)(this, "origin", void 0), (0, a.default)(this, "logVerbosity", void 0), (0, a.default)(this, "useInstanceId", void 0), (0, a.default)(this, "useRequestId", void 0), (0, a.default)(this, "keepAlive", void 0), (0, a.default)(this, "keepAliveSettings", void 0), (0, a.default)(this, "autoNetworkDetection", void 0), (0, a.default)(this, "announceSuccessfulHeartbeats", void 0), (0, a.default)(this, "announceFailedHeartbeats", void 0), (0, a.default)(this, "_presenceTimeout", void 0), (0, a.default)(this, "_heartbeatInterval", void 0), (0, a.default)(this, "_subscribeRequestTimeout", void 0), (0, a.default)(this, "_transactionalRequestTimeout", void 0), (0, a.default)(this, "_useSendBeacon", void 0), (0, a.default)(this, "_PNSDKSuffix", void 0), (0, a.default)(this, "requestMessageCountThreshold", void 0), (0, a.default)(this, "restore", void 0), (0, a.default)(this, "dedupeOnSubscribe", void 0), (0, a.default)(this, "maximumCacheSize", void 0), (0, a.default)(this, "customEncrypt", void 0), (0, a.default)(this, "customDecrypt", void 0), (0, a.default)(this, "fileUploadPublishRetryLimit", void 0), (0, a.default)(this, "useRandomIVs", void 0), this._PNSDKSuffix = {}, this._db = s, this.instanceId = "pn-".concat(u.default.createUUID()), this.secretKey = o.secretKey || o.secret_key, this.subscribeKey = o.subscribeKey || o.subscribe_key, this.publishKey = o.publishKey || o.publish_key, this.sdkName = o.sdkName, this.sdkFamily = o.sdkFamily, this.partnerId = o.partnerId, this.setAuthKey(o.authKey), this.setCipherKey(o.cipherKey), this.setFilterExpression(o.filterExpression), "string" != typeof o.origin && !Array.isArray(o.origin) && void 0 !== o.origin) throw new Error("Origin must be either undefined, a string or a list of strings.");
          this.origin = o.origin || Array.from({
            length: 20
          }, function (e, t) {
            return "ps".concat(t + 1, ".pndsn.com");
          }), this.secure = o.ssl || !1, this.restore = o.restore || !1, this.proxy = o.proxy, this.keepAlive = o.keepAlive, this.keepAliveSettings = o.keepAliveSettings, this.autoNetworkDetection = o.autoNetworkDetection || !1, this.dedupeOnSubscribe = o.dedupeOnSubscribe || !1, this.maximumCacheSize = o.maximumCacheSize || 100, this.customEncrypt = o.customEncrypt, this.customDecrypt = o.customDecrypt, this.fileUploadPublishRetryLimit = null !== (n = o.fileUploadPublishRetryLimit) && void 0 !== n ? n : 5, this.useRandomIVs = null === (r = o.useRandomIVs) || void 0 === r || r, "undefined" != typeof location && "https:" === location.protocol && (this.secure = !0), this.logVerbosity = o.logVerbosity || !1, this.suppressLeaveEvents = o.suppressLeaveEvents || !1, this.announceFailedHeartbeats = o.announceFailedHeartbeats || !0, this.announceSuccessfulHeartbeats = o.announceSuccessfulHeartbeats || !1, this.useInstanceId = o.useInstanceId || !1, this.useRequestId = o.useRequestId || !1, this.requestMessageCountThreshold = o.requestMessageCountThreshold, this.setTransactionTimeout(o.transactionalRequestTimeout || 15e3), this.setSubscribeTimeout(o.subscribeRequestTimeout || 31e4), this.setSendBeaconConfig(o.useSendBeacon || !0), o.presenceTimeout ? this.setPresenceTimeout(o.presenceTimeout) : this._presenceTimeout = 300, null != o.heartbeatInterval && this.setHeartbeatInterval(o.heartbeatInterval), this.setUUID(this._decideUUID(o.uuid));
        }
        return (0, o.default)(e, [{
          key: "getAuthKey",
          value: function value() {
            return this.authKey;
          }
        }, {
          key: "setAuthKey",
          value: function value(e) {
            return this.authKey = e, this;
          }
        }, {
          key: "setCipherKey",
          value: function value(e) {
            return this.cipherKey = e, this;
          }
        }, {
          key: "getUUID",
          value: function value() {
            return this.UUID;
          }
        }, {
          key: "setUUID",
          value: function value(e) {
            return this._db && this._db.set && this._db.set("".concat(this.subscribeKey, "uuid"), e), this.UUID = e, this;
          }
        }, {
          key: "getFilterExpression",
          value: function value() {
            return this.filterExpression;
          }
        }, {
          key: "setFilterExpression",
          value: function value(e) {
            return this.filterExpression = e, this;
          }
        }, {
          key: "getPresenceTimeout",
          value: function value() {
            return this._presenceTimeout;
          }
        }, {
          key: "setPresenceTimeout",
          value: function value(e) {
            return e >= 20 ? this._presenceTimeout = e : (this._presenceTimeout = 20, console.log("WARNING: Presence timeout is less than the minimum. Using minimum value: ", this._presenceTimeout)), this.setHeartbeatInterval(this._presenceTimeout / 2 - 1), this;
          }
        }, {
          key: "setProxy",
          value: function value(e) {
            this.proxy = e;
          }
        }, {
          key: "getHeartbeatInterval",
          value: function value() {
            return this._heartbeatInterval;
          }
        }, {
          key: "setHeartbeatInterval",
          value: function value(e) {
            return this._heartbeatInterval = e, this;
          }
        }, {
          key: "getSubscribeTimeout",
          value: function value() {
            return this._subscribeRequestTimeout;
          }
        }, {
          key: "setSubscribeTimeout",
          value: function value(e) {
            return this._subscribeRequestTimeout = e, this;
          }
        }, {
          key: "getTransactionTimeout",
          value: function value() {
            return this._transactionalRequestTimeout;
          }
        }, {
          key: "setTransactionTimeout",
          value: function value(e) {
            return this._transactionalRequestTimeout = e, this;
          }
        }, {
          key: "isSendBeaconEnabled",
          value: function value() {
            return this._useSendBeacon;
          }
        }, {
          key: "setSendBeaconConfig",
          value: function value(e) {
            return this._useSendBeacon = e, this;
          }
        }, {
          key: "getVersion",
          value: function value() {
            return "4.37.0";
          }
        }, {
          key: "_addPnsdkSuffix",
          value: function value(e, t) {
            this._PNSDKSuffix[e] = t;
          }
        }, {
          key: "_getPnsdkSuffix",
          value: function value(e) {
            var t = this;
            return Object.keys(this._PNSDKSuffix).reduce(function (n, r) {
              return n + e + t._PNSDKSuffix[r];
            }, "");
          }
        }, {
          key: "_decideUUID",
          value: function value(e) {
            return e || (this._db && this._db.get && this._db.get("".concat(this.subscribeKey, "uuid")) ? this._db.get("".concat(this.subscribeKey, "uuid")) : "pn-".concat(u.default.createUUID()));
          }
        }]), e;
      }());
    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    var r = n(80),
      i = n(81),
      o = n(82),
      a = n(84);
    e.exports = function (e, t) {
      return r(e) || i(e, t) || o(e, t) || a();
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    t.default = {
      PNNetworkUpCategory: "PNNetworkUpCategory",
      PNNetworkDownCategory: "PNNetworkDownCategory",
      PNNetworkIssuesCategory: "PNNetworkIssuesCategory",
      PNTimeoutCategory: "PNTimeoutCategory",
      PNBadRequestCategory: "PNBadRequestCategory",
      PNAccessDeniedCategory: "PNAccessDeniedCategory",
      PNUnknownCategory: "PNUnknownCategory",
      PNReconnectedCategory: "PNReconnectedCategory",
      PNConnectedCategory: "PNConnectedCategory",
      PNRequestMessageCountExceededCategory: "PNRequestMessageCountExceededCategory"
    }, e.exports = t.default;
  }, function (e, t, n) {
    e.exports = n(75);
  }, function (e, t) {
    function n(e, t, n, r, i, o, a) {
      try {
        var u = e[o](a),
          s = u.value;
      } catch (e) {
        return void n(e);
      }
      u.done ? t(s) : Promise.resolve(s).then(r, i);
    }
    e.exports = function (e) {
      return function () {
        var t = this,
          r = arguments;
        return new Promise(function (i, o) {
          var a = e.apply(t, r);
          function u(e) {
            n(a, i, o, u, s, "next", e);
          }
          function s(e) {
            n(a, i, o, u, s, "throw", e);
          }
          u(void 0);
        });
      };
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    function n(t) {
      return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, e.exports.default = e.exports, e.exports.__esModule = !0, n(t);
    }
    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(15);
    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && r(e, t);
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    function n(t, r) {
      return e.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0, n(t, r);
    }
    e.exports = n, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(7).default,
      i = n(22);
    e.exports = function (e, t) {
      if (t && ("object" === r(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return i(e);
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(34)),
      o = {
        createUUID: function createUUID() {
          return i.default.uuid ? i.default.uuid() : (0, i.default)();
        }
      };
    t.default = o, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PubNubError = void 0, t.createValidationError = b, t.default = function (e, t) {
      var n = e.networking,
        r = e.config,
        i = e.telemetryManager,
        o = e.tokenManager,
        a = l.default.createUUID(),
        u = null,
        s = null,
        c = {};
      t.getOperation() === d.default.PNTimeOperation || t.getOperation() === d.default.PNChannelGroupsOperation ? u = arguments.length <= 2 ? void 0 : arguments[2] : (c = arguments.length <= 2 ? void 0 : arguments[2], u = arguments.length <= 3 ? void 0 : arguments[3]);
      "undefined" == typeof Promise || u || (s = f.default.createPromise());
      var h = t.validateParams(e, c);
      if (h) return u ? u(b(h)) : s ? (s.reject(new v("Validation failed, check status for details", b(h))), s.promise) : void 0;
      var g,
        S = t.prepareParams(e, c),
        w = m(t, e, c),
        k = {
          url: w,
          operation: t.getOperation(),
          timeout: t.getRequestTimeout(e),
          headers: t.getRequestHeaders ? t.getRequestHeaders() : {},
          ignoreBody: "function" == typeof t.ignoreBody && t.ignoreBody(e),
          forceBuffered: "function" == typeof t.forceBuffered ? t.forceBuffered(e, c) : null
        };
      S.uuid = r.UUID, S.pnsdk = _(r);
      var T = i.operationsLatencyForRequest();
      Object.keys(T).length && (S = y(y({}, S), T));
      r.useInstanceId && (S.instanceid = r.instanceId);
      r.useRequestId && (S.requestid = a);
      if (t.isAuthSupported()) {
        var x = o.getToken() || r.getAuthKey();
        x && (S.auth = x);
      }
      r.secretKey && O(e, w, S, c, t);
      var A = function A(n, r) {
        var o;
        if (n.error) return t.handleError && t.handleError(e, c, n), void (u ? u(n) : s && s.reject(new v("PubNub call failed, check status for details", n)));
        i.stopLatencyMeasure(t.getOperation(), a);
        var l = t.handleResponse(e, r, c);
        "function" != typeof (null === (o = l) || void 0 === o ? void 0 : o.then) && (l = Promise.resolve(l)), l.then(function (e) {
          u ? u(n, e) : s && s.fulfill(e);
        }).catch(function (e) {
          if (u) {
            var n = e;
            t.getOperation() === d.default.PNSubscribeOperation && (n = {
              statusCode: 400,
              error: !0,
              operation: t.getOperation(),
              errorData: e,
              category: p.default.PNUnknownCategory
            }), u(n, null);
          } else s && s.reject(new v("PubNub call failed, check status for details", e));
        });
      };
      if (i.startLatencyMeasure(t.getOperation(), a), "POST" === P(e, t, c)) {
        var M = t.postPayload(e, c);
        g = n.POST(S, M, k, A);
      } else if ("PATCH" === P(e, t, c)) {
        var E = t.patchPayload(e, c);
        g = n.PATCH(S, E, k, A);
      } else g = "DELETE" === P(e, t, c) ? n.DELETE(S, k, A) : "GETFILE" === P(e, t, c) ? n.GETFILE(S, k, A) : n.GET(S, k, A);
      if (t.getOperation() === d.default.PNSubscribeOperation) return g;
      if (s) return s.promise;
    }, t.generatePNSDK = _, t.signRequest = O;
    var i = r(n(4)),
      o = r(n(5)),
      a = r(n(14)),
      u = r(n(16)),
      s = r(n(13)),
      c = r(n(48)),
      l = r(n(17)),
      f = (n(2), r(n(3))),
      d = (r(n(8)), r(n(1))),
      p = r(n(10));
    function h(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function y(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? h(Object(n), !0).forEach(function (t) {
          (0, i.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function g(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = (0, s.default)(e);
        if (t) {
          var i = (0, s.default)(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);
        return (0, u.default)(this, n);
      };
    }
    var v = function (e) {
      (0, a.default)(n, e);
      var t = g(n);
      function n(e, r) {
        var i;
        return (0, o.default)(this, n), (i = t.call(this, e)).name = i.constructor.name, i.status = r, i.message = e, i;
      }
      return n;
    }((0, c.default)(Error));
    function b(e) {
      return (t = {
        message: e
      }).type = "validationError", t.error = !0, t;
      var t;
    }
    function m(e, t, n) {
      return e.usePost && e.usePost(t, n) ? e.postURL(t, n) : e.usePatch && e.usePatch(t, n) ? e.patchURL(t, n) : e.useGetFile && e.useGetFile(t, n) ? e.getFileURL(t, n) : e.getURL(t, n);
    }
    function _(e) {
      if (e.sdkName) return e.sdkName;
      var t = "PubNub-JS-".concat(e.sdkFamily);
      e.partnerId && (t += "-".concat(e.partnerId)), t += "/".concat(e.getVersion());
      var n = e._getPnsdkSuffix(" ");
      return n.length > 0 && (t += n), t;
    }
    function P(e, t, n) {
      return t.usePost && t.usePost(e, n) ? "POST" : t.usePatch && t.usePatch(e, n) ? "PATCH" : t.useDelete && t.useDelete(e, n) ? "DELETE" : t.useGetFile && t.useGetFile(e, n) ? "GETFILE" : "GET";
    }
    function O(e, t, n, r, i) {
      var o = e.config,
        a = e.crypto,
        u = P(e, i, r);
      n.timestamp = Math.floor(new Date().getTime() / 1e3), "PNPublishOperation" === i.getOperation() && i.usePost && i.usePost(e, r) && (u = "GET"), "GETFILE" === u && (u = "GET");
      var s = "".concat(u, "\n").concat(o.publishKey, "\n").concat(t, "\n").concat(f.default.signPamFromParams(n), "\n");
      if ("POST" === u) {
        var c = i.postPayload(e, r);
        s += "string" == typeof c ? c : JSON.stringify(c);
      } else if ("PATCH" === u) {
        var l = i.patchPayload(e, r);
        s += "string" == typeof l ? l : JSON.stringify(l);
      }
      var d = "v2.".concat(a.HMACSHA256(s));
      d = (d = (d = d.replace(/\+/g, "-")).replace(/\//g, "_")).replace(/=+$/, ""), n.signature = d;
    }
    t.PubNubError = v;
  }, function (e, t, n) {
    "use strict";

    var r = SyntaxError,
      i = Function,
      o = TypeError,
      a = function a(e) {
        try {
          return i('"use strict"; return (' + e + ").constructor;")();
        } catch (e) {}
      },
      u = Object.getOwnPropertyDescriptor;
    if (u) try {
      u({}, "");
    } catch (e) {
      u = null;
    }
    var s = function s() {
        throw new o();
      },
      c = u ? function () {
        try {
          return s;
        } catch (e) {
          try {
            return u(arguments, "callee").get;
          } catch (e) {
            return s;
          }
        }
      }() : s,
      l = n(135)(),
      f = Object.getPrototypeOf || function (e) {
        return e.__proto__;
      },
      d = {},
      p = "undefined" == typeof Uint8Array ? void 0 : f(Uint8Array),
      h = {
        "%AggregateError%": "undefined" == typeof AggregateError ? void 0 : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
        "%ArrayIteratorPrototype%": l ? f([][Symbol.iterator]()) : void 0,
        "%AsyncFromSyncIteratorPrototype%": void 0,
        "%AsyncFunction%": d,
        "%AsyncGenerator%": d,
        "%AsyncGeneratorFunction%": d,
        "%AsyncIteratorPrototype%": d,
        "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
        "%BigInt%": "undefined" == typeof BigInt ? void 0 : BigInt,
        "%Boolean%": Boolean,
        "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": Error,
        "%eval%": eval,
        "%EvalError%": EvalError,
        "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
        "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
        "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
        "%Function%": i,
        "%GeneratorFunction%": d,
        "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
        "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
        "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": l ? f(f([][Symbol.iterator]())) : void 0,
        "%JSON%": "object" == typeof JSON ? JSON : void 0,
        "%Map%": "undefined" == typeof Map ? void 0 : Map,
        "%MapIteratorPrototype%": "undefined" != typeof Map && l ? f(new Map()[Symbol.iterator]()) : void 0,
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": Object,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
        "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
        "%RangeError%": RangeError,
        "%ReferenceError%": ReferenceError,
        "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
        "%RegExp%": RegExp,
        "%Set%": "undefined" == typeof Set ? void 0 : Set,
        "%SetIteratorPrototype%": "undefined" != typeof Set && l ? f(new Set()[Symbol.iterator]()) : void 0,
        "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": l ? f(""[Symbol.iterator]()) : void 0,
        "%Symbol%": l ? Symbol : void 0,
        "%SyntaxError%": r,
        "%ThrowTypeError%": c,
        "%TypedArray%": p,
        "%TypeError%": o,
        "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
        "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
        "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
        "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
        "%URIError%": URIError,
        "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
        "%WeakRef%": "undefined" == typeof WeakRef ? void 0 : WeakRef,
        "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet
      },
      y = {
        "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
        "%ArrayPrototype%": ["Array", "prototype"],
        "%ArrayProto_entries%": ["Array", "prototype", "entries"],
        "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
        "%ArrayProto_keys%": ["Array", "prototype", "keys"],
        "%ArrayProto_values%": ["Array", "prototype", "values"],
        "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
        "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
        "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
        "%BooleanPrototype%": ["Boolean", "prototype"],
        "%DataViewPrototype%": ["DataView", "prototype"],
        "%DatePrototype%": ["Date", "prototype"],
        "%ErrorPrototype%": ["Error", "prototype"],
        "%EvalErrorPrototype%": ["EvalError", "prototype"],
        "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
        "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
        "%FunctionPrototype%": ["Function", "prototype"],
        "%Generator%": ["GeneratorFunction", "prototype"],
        "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
        "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
        "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
        "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
        "%JSONParse%": ["JSON", "parse"],
        "%JSONStringify%": ["JSON", "stringify"],
        "%MapPrototype%": ["Map", "prototype"],
        "%NumberPrototype%": ["Number", "prototype"],
        "%ObjectPrototype%": ["Object", "prototype"],
        "%ObjProto_toString%": ["Object", "prototype", "toString"],
        "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
        "%PromisePrototype%": ["Promise", "prototype"],
        "%PromiseProto_then%": ["Promise", "prototype", "then"],
        "%Promise_all%": ["Promise", "all"],
        "%Promise_reject%": ["Promise", "reject"],
        "%Promise_resolve%": ["Promise", "resolve"],
        "%RangeErrorPrototype%": ["RangeError", "prototype"],
        "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
        "%RegExpPrototype%": ["RegExp", "prototype"],
        "%SetPrototype%": ["Set", "prototype"],
        "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
        "%StringPrototype%": ["String", "prototype"],
        "%SymbolPrototype%": ["Symbol", "prototype"],
        "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
        "%TypedArrayPrototype%": ["TypedArray", "prototype"],
        "%TypeErrorPrototype%": ["TypeError", "prototype"],
        "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
        "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
        "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
        "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
        "%URIErrorPrototype%": ["URIError", "prototype"],
        "%WeakMapPrototype%": ["WeakMap", "prototype"],
        "%WeakSetPrototype%": ["WeakSet", "prototype"]
      },
      g = n(20),
      v = n(138),
      b = g.call(Function.call, Array.prototype.concat),
      m = g.call(Function.apply, Array.prototype.splice),
      _ = g.call(Function.call, String.prototype.replace),
      P = g.call(Function.call, String.prototype.slice),
      O = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
      S = /\\(\\)?/g,
      w = function w(e) {
        var t = P(e, 0, 1),
          n = P(e, -1);
        if ("%" === t && "%" !== n) throw new r("invalid intrinsic syntax, expected closing `%`");
        if ("%" === n && "%" !== t) throw new r("invalid intrinsic syntax, expected opening `%`");
        var i = [];
        return _(e, O, function (e, t, n, r) {
          i[i.length] = n ? _(r, S, "$1") : t || e;
        }), i;
      },
      k = function k(e, t) {
        var n,
          i = e;
        if (v(y, i) && (i = "%" + (n = y[i])[0] + "%"), v(h, i)) {
          var u = h[i];
          if (u === d && (u = function e(t) {
            var n;
            if ("%AsyncFunction%" === t) n = a("async function () {}");else if ("%GeneratorFunction%" === t) n = a("function* () {}");else if ("%AsyncGeneratorFunction%" === t) n = a("async function* () {}");else if ("%AsyncGenerator%" === t) {
              var r = e("%AsyncGeneratorFunction%");
              r && (n = r.prototype);
            } else if ("%AsyncIteratorPrototype%" === t) {
              var i = e("%AsyncGenerator%");
              i && (n = f(i.prototype));
            }
            return h[t] = n, n;
          }(i)), void 0 === u && !t) throw new o("intrinsic " + e + " exists, but is not available. Please file an issue!");
          return {
            alias: n,
            name: i,
            value: u
          };
        }
        throw new r("intrinsic " + e + " does not exist!");
      };
    e.exports = function (e, t) {
      if ("string" != typeof e || 0 === e.length) throw new o("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof t) throw new o('"allowMissing" argument must be a boolean');
      var n = w(e),
        i = n.length > 0 ? n[0] : "",
        a = k("%" + i + "%", t),
        s = a.name,
        c = a.value,
        l = !1,
        f = a.alias;
      f && (i = f[0], m(n, b([0, 1], f)));
      for (var d = 1, p = !0; d < n.length; d += 1) {
        var y = n[d],
          g = P(y, 0, 1),
          _ = P(y, -1);
        if (('"' === g || "'" === g || "`" === g || '"' === _ || "'" === _ || "`" === _) && g !== _) throw new r("property names with quotes must have matching quotes");
        if ("constructor" !== y && p || (l = !0), v(h, s = "%" + (i += "." + y) + "%")) c = h[s];else if (null != c) {
          if (!(y in c)) {
            if (!t) throw new o("base intrinsic for " + e + " exists, but the property is not available.");
            return;
          }
          if (u && d + 1 >= n.length) {
            var O = u(c, y);
            c = (p = !!O) && "get" in O && !("originalValue" in O.get) ? O.get : c[y];
          } else p = v(c, y), c = c[y];
          p && !l && (h[s] = c);
        }
      }
      return c;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(137);
    e.exports = Function.prototype.bind || r;
  }, function (e, t, n) {
    "use strict";

    var r = String.prototype.replace,
      i = /%20/g,
      o = "RFC1738",
      a = "RFC3986";
    e.exports = {
      default: a,
      formatters: {
        RFC1738: function RFC1738(e) {
          return r.call(e, i, "+");
        },
        RFC3986: function RFC3986(e) {
          return String(e);
        }
      },
      RFC1738: o,
      RFC3986: a
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    (function (r) {
      var i = n(0);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = i(n(5)),
        a = i(n(6)),
        u = i(n(4)),
        s = (i(n(8)), i(n(25)));
      function c(e) {
        var t,
          n = [];
        for (t = 0; t < e.length; t += 1) {
          n[t / 4 | 0] |= e[t] << 24 - 8 * t;
        }
        return s.default.lib.WordArray.create(n, e.length);
      }
      var l = function () {
        function e(t) {
          var n = t.config;
          (0, o.default)(this, e), (0, u.default)(this, "_config", void 0), (0, u.default)(this, "_iv", void 0), (0, u.default)(this, "_allowedKeyEncodings", void 0), (0, u.default)(this, "_allowedKeyLengths", void 0), (0, u.default)(this, "_allowedModes", void 0), (0, u.default)(this, "_defaultOptions", void 0), this._config = n, this._iv = "0123456789012345", this._allowedKeyEncodings = ["hex", "utf8", "base64", "binary"], this._allowedKeyLengths = [128, 256], this._allowedModes = ["ecb", "cbc"], this._defaultOptions = {
            encryptKey: !0,
            keyEncoding: "utf8",
            keyLength: 256,
            mode: "cbc"
          };
        }
        return (0, a.default)(e, [{
          key: "HMACSHA256",
          value: function value(e) {
            return s.default.HmacSHA256(e, this._config.secretKey).toString(s.default.enc.Base64);
          }
        }, {
          key: "SHA256",
          value: function value(e) {
            return s.default.SHA256(e).toString(s.default.enc.Hex);
          }
        }, {
          key: "_parseOptions",
          value: function value(e) {
            var t = e || {};
            return t.hasOwnProperty("encryptKey") || (t.encryptKey = this._defaultOptions.encryptKey), t.hasOwnProperty("keyEncoding") || (t.keyEncoding = this._defaultOptions.keyEncoding), t.hasOwnProperty("keyLength") || (t.keyLength = this._defaultOptions.keyLength), t.hasOwnProperty("mode") || (t.mode = this._defaultOptions.mode), -1 === this._allowedKeyEncodings.indexOf(t.keyEncoding.toLowerCase()) && (t.keyEncoding = this._defaultOptions.keyEncoding), -1 === this._allowedKeyLengths.indexOf(parseInt(t.keyLength, 10)) && (t.keyLength = this._defaultOptions.keyLength), -1 === this._allowedModes.indexOf(t.mode.toLowerCase()) && (t.mode = this._defaultOptions.mode), t;
          }
        }, {
          key: "_decodeKey",
          value: function value(e, t) {
            return "base64" === t.keyEncoding ? s.default.enc.Base64.parse(e) : "hex" === t.keyEncoding ? s.default.enc.Hex.parse(e) : e;
          }
        }, {
          key: "_getPaddedKey",
          value: function value(e, t) {
            return e = this._decodeKey(e, t), t.encryptKey ? s.default.enc.Utf8.parse(this.SHA256(e).slice(0, 32)) : e;
          }
        }, {
          key: "_getMode",
          value: function value(e) {
            return "ecb" === e.mode ? s.default.mode.ECB : s.default.mode.CBC;
          }
        }, {
          key: "_getIV",
          value: function value(e) {
            return "cbc" === e.mode ? s.default.enc.Utf8.parse(this._iv) : null;
          }
        }, {
          key: "_getRandomIV",
          value: function value() {
            return s.default.lib.WordArray.random(16);
          }
        }, {
          key: "encrypt",
          value: function value(e, t, n) {
            return this._config.customEncrypt ? this._config.customEncrypt(e) : this.pnEncrypt(e, t, n);
          }
        }, {
          key: "decrypt",
          value: function value(e, t, n) {
            return this._config.customDecrypt ? this._config.customDecrypt(e) : this.pnDecrypt(e, t, n);
          }
        }, {
          key: "pnEncrypt",
          value: function value(e, t, n) {
            if (!t && !this._config.cipherKey) return e;
            n = this._parseOptions(n);
            var r = this._getMode(n),
              i = this._getPaddedKey(t || this._config.cipherKey, n);
            if (this._config.useRandomIVs) {
              var o = this._getRandomIV(),
                a = s.default.AES.encrypt(e, i, {
                  iv: o,
                  mode: r
                }).ciphertext;
              return o.clone().concat(a.clone()).toString(s.default.enc.Base64);
            }
            var u = this._getIV(n);
            return s.default.AES.encrypt(e, i, {
              iv: u,
              mode: r
            }).ciphertext.toString(s.default.enc.Base64) || e;
          }
        }, {
          key: "pnDecrypt",
          value: function value(e, t, n) {
            if (!t && !this._config.cipherKey) return e;
            n = this._parseOptions(n);
            var i = this._getMode(n),
              o = this._getPaddedKey(t || this._config.cipherKey, n);
            if (this._config.useRandomIVs) {
              var a = r.from(e, "base64"),
                u = c(a.slice(0, 16)),
                l = c(a.slice(16));
              try {
                var f = s.default.AES.decrypt({
                  ciphertext: l
                }, o, {
                  iv: u,
                  mode: i
                }).toString(s.default.enc.Utf8);
                return JSON.parse(f);
              } catch (e) {
                return null;
              }
            } else {
              var d = this._getIV(n);
              try {
                var p = s.default.enc.Base64.parse(e),
                  h = s.default.AES.decrypt({
                    ciphertext: p
                  }, o, {
                    iv: d,
                    mode: i
                  }).toString(s.default.enc.Utf8);
                return JSON.parse(h);
              } catch (e) {
                return null;
              }
            }
          }
        }]), e;
      }();
      t.default = l, e.exports = t.default;
    }).call(this, n(24).Buffer);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var r = n(36),
        i = n(37),
        o = n(38);
      function a() {
        return s.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }
      function u(e, t) {
        if (a() < t) throw new RangeError("Invalid typed array length");
        return s.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = s.prototype : (null === e && (e = new s(t)), e.length = t), e;
      }
      function s(e, t, n) {
        if (!(s.TYPED_ARRAY_SUPPORT || this instanceof s)) return new s(e, t, n);
        if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
          return f(this, e);
        }
        return c(this, e, t, n);
      }
      function c(e, t, n, r) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
          if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
          if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
          t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
          s.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = s.prototype : e = d(e, t);
          return e;
        }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
          "string" == typeof n && "" !== n || (n = "utf8");
          if (!s.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
          var r = 0 | h(t, n),
            i = (e = u(e, r)).write(t, n);
          i !== r && (e = e.slice(0, i));
          return e;
        }(e, t, n) : function (e, t) {
          if (s.isBuffer(t)) {
            var n = 0 | p(t.length);
            return 0 === (e = u(e, n)).length || t.copy(e, 0, 0, n), e;
          }
          if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? u(e, 0) : d(e, t);
            if ("Buffer" === t.type && o(t.data)) return d(e, t.data);
          }
          var r;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }
      function l(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative');
      }
      function f(e, t) {
        if (l(t), e = u(e, t < 0 ? 0 : 0 | p(t)), !s.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) {
          e[n] = 0;
        }
        return e;
      }
      function d(e, t) {
        var n = t.length < 0 ? 0 : 0 | p(t.length);
        e = u(e, n);
        for (var r = 0; r < n; r += 1) {
          e[r] = 255 & t[r];
        }
        return e;
      }
      function p(e) {
        if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | e;
      }
      function h(e, t) {
        if (s.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var n = e.length;
        if (0 === n) return 0;
        for (var r = !1;;) {
          switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;
            case "utf8":
            case "utf-8":
            case void 0:
              return K(e).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;
            case "hex":
              return n >>> 1;
            case "base64":
              return B(e).length;
            default:
              if (r) return K(e).length;
              t = ("" + t).toLowerCase(), r = !0;
          }
        }
      }
      function y(e, t, n) {
        var r = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if ((n >>>= 0) <= (t >>>= 0)) return "";
        for (e || (e = "utf8");;) {
          switch (e) {
            case "hex":
              return M(this, t, n);
            case "utf8":
            case "utf-8":
              return T(this, t, n);
            case "ascii":
              return x(this, t, n);
            case "latin1":
            case "binary":
              return A(this, t, n);
            case "base64":
              return k(this, t, n);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return E(this, t, n);
            default:
              if (r) throw new TypeError("Unknown encoding: " + e);
              e = (e + "").toLowerCase(), r = !0;
          }
        }
      }
      function g(e, t, n) {
        var r = e[t];
        e[t] = e[n], e[n] = r;
      }
      function v(e, t, n, r, i) {
        if (0 === e.length) return -1;
        if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
          if (i) return -1;
          n = e.length - 1;
        } else if (n < 0) {
          if (!i) return -1;
          n = 0;
        }
        if ("string" == typeof t && (t = s.from(t, r)), s.isBuffer(t)) return 0 === t.length ? -1 : b(e, t, n, r, i);
        if ("number" == typeof t) return t &= 255, s.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : b(e, [t], n, r, i);
        throw new TypeError("val must be string, number or Buffer");
      }
      function b(e, t, n, r, i) {
        var o,
          a = 1,
          u = e.length,
          s = t.length;
        if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
          if (e.length < 2 || t.length < 2) return -1;
          a = 2, u /= 2, s /= 2, n /= 2;
        }
        function c(e, t) {
          return 1 === a ? e[t] : e.readUInt16BE(t * a);
        }
        if (i) {
          var l = -1;
          for (o = n; o < u; o++) {
            if (c(e, o) === c(t, -1 === l ? 0 : o - l)) {
              if (-1 === l && (l = o), o - l + 1 === s) return l * a;
            } else -1 !== l && (o -= o - l), l = -1;
          }
        } else for (n + s > u && (n = u - s), o = n; o >= 0; o--) {
          for (var f = !0, d = 0; d < s; d++) {
            if (c(e, o + d) !== c(t, d)) {
              f = !1;
              break;
            }
          }
          if (f) return o;
        }
        return -1;
      }
      function m(e, t, n, r) {
        n = Number(n) || 0;
        var i = e.length - n;
        r ? (r = Number(r)) > i && (r = i) : r = i;
        var o = t.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        r > o / 2 && (r = o / 2);
        for (var a = 0; a < r; ++a) {
          var u = parseInt(t.substr(2 * a, 2), 16);
          if (isNaN(u)) return a;
          e[n + a] = u;
        }
        return a;
      }
      function _(e, t, n, r) {
        return G(K(t, e.length - n), e, n, r);
      }
      function P(e, t, n, r) {
        return G(function (e) {
          for (var t = [], n = 0; n < e.length; ++n) {
            t.push(255 & e.charCodeAt(n));
          }
          return t;
        }(t), e, n, r);
      }
      function O(e, t, n, r) {
        return P(e, t, n, r);
      }
      function S(e, t, n, r) {
        return G(B(t), e, n, r);
      }
      function w(e, t, n, r) {
        return G(function (e, t) {
          for (var n, r, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
            n = e.charCodeAt(a), r = n >> 8, i = n % 256, o.push(i), o.push(r);
          }
          return o;
        }(t, e.length - n), e, n, r);
      }
      function k(e, t, n) {
        return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
      }
      function T(e, t, n) {
        n = Math.min(e.length, n);
        for (var r = [], i = t; i < n;) {
          var o,
            a,
            u,
            s,
            c = e[i],
            l = null,
            f = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (i + f <= n) switch (f) {
            case 1:
              c < 128 && (l = c);
              break;
            case 2:
              128 == (192 & (o = e[i + 1])) && (s = (31 & c) << 6 | 63 & o) > 127 && (l = s);
              break;
            case 3:
              o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (s = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (s < 55296 || s > 57343) && (l = s);
              break;
            case 4:
              o = e[i + 1], a = e[i + 2], u = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & u) && (s = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & u) > 65535 && s < 1114112 && (l = s);
          }
          null === l ? (l = 65533, f = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), i += f;
        }
        return function (e) {
          var t = e.length;
          if (t <= 4096) return String.fromCharCode.apply(String, e);
          var n = "",
            r = 0;
          for (; r < t;) {
            n += String.fromCharCode.apply(String, e.slice(r, r += 4096));
          }
          return n;
        }(r);
      }
      t.Buffer = s, t.SlowBuffer = function (e) {
        +e != e && (e = 0);
        return s.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, s.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);
          return e.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = a(), s.poolSize = 8192, s._augment = function (e) {
        return e.__proto__ = s.prototype, e;
      }, s.from = function (e, t, n) {
        return c(null, e, t, n);
      }, s.TYPED_ARRAY_SUPPORT && (s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
        value: null,
        configurable: !0
      })), s.alloc = function (e, t, n) {
        return function (e, t, n, r) {
          return l(t), t <= 0 ? u(e, t) : void 0 !== n ? "string" == typeof r ? u(e, t).fill(n, r) : u(e, t).fill(n) : u(e, t);
        }(null, e, t, n);
      }, s.allocUnsafe = function (e) {
        return f(null, e);
      }, s.allocUnsafeSlow = function (e) {
        return f(null, e);
      }, s.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, s.compare = function (e, t) {
        if (!s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;
        for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) {
          if (e[i] !== t[i]) {
            n = e[i], r = t[i];
            break;
          }
        }
        return n < r ? -1 : r < n ? 1 : 0;
      }, s.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;
          default:
            return !1;
        }
      }, s.concat = function (e, t) {
        if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return s.alloc(0);
        var n;
        if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) {
          t += e[n].length;
        }
        var r = s.allocUnsafe(t),
          i = 0;
        for (n = 0; n < e.length; ++n) {
          var a = e[n];
          if (!s.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(r, i), i += a.length;
        }
        return r;
      }, s.byteLength = h, s.prototype._isBuffer = !0, s.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (var t = 0; t < e; t += 2) {
          g(this, t, t + 1);
        }
        return this;
      }, s.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (var t = 0; t < e; t += 4) {
          g(this, t, t + 3), g(this, t + 1, t + 2);
        }
        return this;
      }, s.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (var t = 0; t < e; t += 8) {
          g(this, t, t + 7), g(this, t + 1, t + 6), g(this, t + 2, t + 5), g(this, t + 3, t + 4);
        }
        return this;
      }, s.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? T(this, 0, e) : y.apply(this, arguments);
      }, s.prototype.equals = function (e) {
        if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === s.compare(this, e);
      }, s.prototype.inspect = function () {
        var e = "",
          n = t.INSPECT_MAX_BYTES;
        return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
      }, s.prototype.compare = function (e, t, n, r, i) {
        if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
        if (r >= i && t >= n) return 0;
        if (r >= i) return -1;
        if (t >= n) return 1;
        if (this === e) return 0;
        for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), u = Math.min(o, a), c = this.slice(r, i), l = e.slice(t, n), f = 0; f < u; ++f) {
          if (c[f] !== l[f]) {
            o = c[f], a = l[f];
            break;
          }
        }
        return o < a ? -1 : a < o ? 1 : 0;
      }, s.prototype.includes = function (e, t, n) {
        return -1 !== this.indexOf(e, t, n);
      }, s.prototype.indexOf = function (e, t, n) {
        return v(this, e, t, n, !0);
      }, s.prototype.lastIndexOf = function (e, t, n) {
        return v(this, e, t, n, !1);
      }, s.prototype.write = function (e, t, n, r) {
        if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
        }
        var i = this.length - t;
        if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        r || (r = "utf8");
        for (var o = !1;;) {
          switch (r) {
            case "hex":
              return m(this, e, t, n);
            case "utf8":
            case "utf-8":
              return _(this, e, t, n);
            case "ascii":
              return P(this, e, t, n);
            case "latin1":
            case "binary":
              return O(this, e, t, n);
            case "base64":
              return S(this, e, t, n);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return w(this, e, t, n);
            default:
              if (o) throw new TypeError("Unknown encoding: " + r);
              r = ("" + r).toLowerCase(), o = !0;
          }
        }
      }, s.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      function x(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);
        for (var i = t; i < n; ++i) {
          r += String.fromCharCode(127 & e[i]);
        }
        return r;
      }
      function A(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);
        for (var i = t; i < n; ++i) {
          r += String.fromCharCode(e[i]);
        }
        return r;
      }
      function M(e, t, n) {
        var r = e.length;
        (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
        for (var i = "", o = t; o < n; ++o) {
          i += L(e[o]);
        }
        return i;
      }
      function E(e, t, n) {
        for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) {
          i += String.fromCharCode(r[o] + 256 * r[o + 1]);
        }
        return i;
      }
      function j(e, t, n) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
      }
      function R(e, t, n, r, i, o) {
        if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
        if (n + r > e.length) throw new RangeError("Index out of range");
      }
      function N(e, t, n, r) {
        t < 0 && (t = 65535 + t + 1);
        for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) {
          e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
        }
      }
      function C(e, t, n, r) {
        t < 0 && (t = 4294967295 + t + 1);
        for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) {
          e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
        }
      }
      function U(e, t, n, r, i, o) {
        if (n + r > e.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range");
      }
      function I(e, t, n, r, o) {
        return o || U(e, 0, n, 4), i.write(e, t, n, r, 23, 4), n + 4;
      }
      function D(e, t, n, r, o) {
        return o || U(e, 0, n, 8), i.write(e, t, n, r, 52, 8), n + 8;
      }
      s.prototype.slice = function (e, t) {
        var n,
          r = this.length;
        if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), s.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = s.prototype;else {
          var i = t - e;
          n = new s(i, void 0);
          for (var o = 0; o < i; ++o) {
            n[o] = this[o + e];
          }
        }
        return n;
      }, s.prototype.readUIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || j(e, t, this.length);
        for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          r += this[e + o] * i;
        }
        return r;
      }, s.prototype.readUIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || j(e, t, this.length);
        for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) {
          r += this[e + --t] * i;
        }
        return r;
      }, s.prototype.readUInt8 = function (e, t) {
        return t || j(e, 1, this.length), this[e];
      }, s.prototype.readUInt16LE = function (e, t) {
        return t || j(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, s.prototype.readUInt16BE = function (e, t) {
        return t || j(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, s.prototype.readUInt32LE = function (e, t) {
        return t || j(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, s.prototype.readUInt32BE = function (e, t) {
        return t || j(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, s.prototype.readIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || j(e, t, this.length);
        for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          r += this[e + o] * i;
        }
        return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
      }, s.prototype.readIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || j(e, t, this.length);
        for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) {
          o += this[e + --r] * i;
        }
        return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
      }, s.prototype.readInt8 = function (e, t) {
        return t || j(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, s.prototype.readInt16LE = function (e, t) {
        t || j(e, 2, this.length);
        var n = this[e] | this[e + 1] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, s.prototype.readInt16BE = function (e, t) {
        t || j(e, 2, this.length);
        var n = this[e + 1] | this[e] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, s.prototype.readInt32LE = function (e, t) {
        return t || j(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, s.prototype.readInt32BE = function (e, t) {
        return t || j(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, s.prototype.readFloatLE = function (e, t) {
        return t || j(e, 4, this.length), i.read(this, e, !0, 23, 4);
      }, s.prototype.readFloatBE = function (e, t) {
        return t || j(e, 4, this.length), i.read(this, e, !1, 23, 4);
      }, s.prototype.readDoubleLE = function (e, t) {
        return t || j(e, 8, this.length), i.read(this, e, !0, 52, 8);
      }, s.prototype.readDoubleBE = function (e, t) {
        return t || j(e, 8, this.length), i.read(this, e, !1, 52, 8);
      }, s.prototype.writeUIntLE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || R(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var i = 1,
          o = 0;
        for (this[t] = 255 & e; ++o < n && (i *= 256);) {
          this[t + o] = e / i & 255;
        }
        return t + n;
      }, s.prototype.writeUIntBE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || R(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var i = n - 1,
          o = 1;
        for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
          this[t + i] = e / o & 255;
        }
        return t + n;
      }, s.prototype.writeUInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 1, 255, 0), s.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, s.prototype.writeUInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : N(this, e, t, !0), t + 2;
      }, s.prototype.writeUInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : N(this, e, t, !1), t + 2;
      }, s.prototype.writeUInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : C(this, e, t, !0), t + 4;
      }, s.prototype.writeUInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : C(this, e, t, !1), t + 4;
      }, s.prototype.writeIntLE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          R(this, e, t, n, i - 1, -i);
        }
        var o = 0,
          a = 1,
          u = 0;
        for (this[t] = 255 & e; ++o < n && (a *= 256);) {
          e < 0 && 0 === u && 0 !== this[t + o - 1] && (u = 1), this[t + o] = (e / a >> 0) - u & 255;
        }
        return t + n;
      }, s.prototype.writeIntBE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          R(this, e, t, n, i - 1, -i);
        }
        var o = n - 1,
          a = 1,
          u = 0;
        for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) {
          e < 0 && 0 === u && 0 !== this[t + o + 1] && (u = 1), this[t + o] = (e / a >> 0) - u & 255;
        }
        return t + n;
      }, s.prototype.writeInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 1, 127, -128), s.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, s.prototype.writeInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : N(this, e, t, !0), t + 2;
      }, s.prototype.writeInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : N(this, e, t, !1), t + 2;
      }, s.prototype.writeInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 4, 2147483647, -2147483648), s.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : C(this, e, t, !0), t + 4;
      }, s.prototype.writeInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || R(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : C(this, e, t, !1), t + 4;
      }, s.prototype.writeFloatLE = function (e, t, n) {
        return I(this, e, t, !0, n);
      }, s.prototype.writeFloatBE = function (e, t, n) {
        return I(this, e, t, !1, n);
      }, s.prototype.writeDoubleLE = function (e, t, n) {
        return D(this, e, t, !0, n);
      }, s.prototype.writeDoubleBE = function (e, t, n) {
        return D(this, e, t, !1, n);
      }, s.prototype.copy = function (e, t, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (r < 0) throw new RangeError("sourceEnd out of bounds");
        r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
        var i,
          o = r - n;
        if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) {
          e[i + t] = this[i + n];
        } else if (o < 1e3 || !s.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          e[i + t] = this[i + n];
        } else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
        return o;
      }, s.prototype.fill = function (e, t, n, r) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
            var i = e.charCodeAt(0);
            i < 256 && (e = i);
          }
          if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
          if ("string" == typeof r && !s.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
        } else "number" == typeof e && (e &= 255);
        if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
        if (n <= t) return this;
        var o;
        if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) {
          this[o] = e;
        } else {
          var a = s.isBuffer(e) ? e : K(new s(e, r).toString()),
            u = a.length;
          for (o = 0; o < n - t; ++o) {
            this[o + t] = a[o % u];
          }
        }
        return this;
      };
      var F = /[^+\/0-9A-Za-z-_]/g;
      function L(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }
      function K(e, t) {
        var n;
        t = t || 1 / 0;
        for (var r = e.length, i = null, o = [], a = 0; a < r; ++a) {
          if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
            if (!i) {
              if (n > 56319) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }
              if (a + 1 === r) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }
              i = n;
              continue;
            }
            if (n < 56320) {
              (t -= 3) > -1 && o.push(239, 191, 189), i = n;
              continue;
            }
            n = 65536 + (i - 55296 << 10 | n - 56320);
          } else i && (t -= 3) > -1 && o.push(239, 191, 189);
          if (i = null, n < 128) {
            if ((t -= 1) < 0) break;
            o.push(n);
          } else if (n < 2048) {
            if ((t -= 2) < 0) break;
            o.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((t -= 3) < 0) break;
            o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");
            if ((t -= 4) < 0) break;
            o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }
        return o;
      }
      function B(e) {
        return r.toByteArray(function (e) {
          if ((e = function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(F, "")).length < 2) return "";
          for (; e.length % 4 != 0;) {
            e += "=";
          }
          return e;
        }(e));
      }
      function G(e, t, n, r) {
        for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) {
          t[i + n] = e[i];
        }
        return i;
      }
    }).call(this, n(35));
  }, function (e, t, n) {
    "use strict";

    var r,
      i,
      o,
      a,
      u,
      s = s || function (e, t) {
        var n = {},
          r = n.lib = {},
          i = function i() {},
          o = r.Base = {
            extend: function extend(e) {
              i.prototype = this;
              var t = new i();
              return e && t.mixIn(e), t.hasOwnProperty("init") || (t.init = function () {
                t.$super.init.apply(this, arguments);
              }), t.init.prototype = t, t.$super = this, t;
            },
            create: function create() {
              var e = this.extend();
              return e.init.apply(e, arguments), e;
            },
            init: function init() {},
            mixIn: function mixIn(e) {
              for (var t in e) {
                e.hasOwnProperty(t) && (this[t] = e[t]);
              }
              e.hasOwnProperty("toString") && (this.toString = e.toString);
            },
            clone: function clone() {
              return this.init.prototype.extend(this);
            }
          },
          a = r.WordArray = o.extend({
            init: function init(e, t) {
              e = this.words = e || [], this.sigBytes = null != t ? t : 4 * e.length;
            },
            toString: function toString(e) {
              return (e || s).stringify(this);
            },
            concat: function concat(e) {
              var t = this.words,
                n = e.words,
                r = this.sigBytes;
              if (e = e.sigBytes, this.clamp(), r % 4) for (var i = 0; i < e; i++) {
                t[r + i >>> 2] |= (n[i >>> 2] >>> 24 - i % 4 * 8 & 255) << 24 - (r + i) % 4 * 8;
              } else if (65535 < n.length) for (i = 0; i < e; i += 4) {
                t[r + i >>> 2] = n[i >>> 2];
              } else t.push.apply(t, n);
              return this.sigBytes += e, this;
            },
            clamp: function clamp() {
              var t = this.words,
                n = this.sigBytes;
              t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = e.ceil(n / 4);
            },
            clone: function clone() {
              var e = o.clone.call(this);
              return e.words = this.words.slice(0), e;
            },
            random: function random(t) {
              for (var n = [], r = 0; r < t; r += 4) {
                n.push(4294967296 * e.random() | 0);
              }
              return new a.init(n, t);
            }
          }),
          u = n.enc = {},
          s = u.Hex = {
            stringify: function stringify(e) {
              var t = e.words;
              e = e.sigBytes;
              for (var n = [], r = 0; r < e; r++) {
                var i = t[r >>> 2] >>> 24 - r % 4 * 8 & 255;
                n.push((i >>> 4).toString(16)), n.push((15 & i).toString(16));
              }
              return n.join("");
            },
            parse: function parse(e) {
              for (var t = e.length, n = [], r = 0; r < t; r += 2) {
                n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
              }
              return new a.init(n, t / 2);
            }
          },
          c = u.Latin1 = {
            stringify: function stringify(e) {
              var t = e.words;
              e = e.sigBytes;
              for (var n = [], r = 0; r < e; r++) {
                n.push(String.fromCharCode(t[r >>> 2] >>> 24 - r % 4 * 8 & 255));
              }
              return n.join("");
            },
            parse: function parse(e) {
              for (var t = e.length, n = [], r = 0; r < t; r++) {
                n[r >>> 2] |= (255 & e.charCodeAt(r)) << 24 - r % 4 * 8;
              }
              return new a.init(n, t);
            }
          },
          l = u.Utf8 = {
            stringify: function stringify(e) {
              try {
                return decodeURIComponent(escape(c.stringify(e)));
              } catch (e) {
                throw Error("Malformed UTF-8 data");
              }
            },
            parse: function parse(e) {
              return c.parse(unescape(encodeURIComponent(e)));
            }
          },
          f = r.BufferedBlockAlgorithm = o.extend({
            reset: function reset() {
              this._data = new a.init(), this._nDataBytes = 0;
            },
            _append: function _append(e) {
              "string" == typeof e && (e = l.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes;
            },
            _process: function _process(t) {
              var n = this._data,
                r = n.words,
                i = n.sigBytes,
                o = this.blockSize,
                u = i / (4 * o);
              if (t = (u = t ? e.ceil(u) : e.max((0 | u) - this._minBufferSize, 0)) * o, i = e.min(4 * t, i), t) {
                for (var s = 0; s < t; s += o) {
                  this._doProcessBlock(r, s);
                }
                s = r.splice(0, t), n.sigBytes -= i;
              }
              return new a.init(s, i);
            },
            clone: function clone() {
              var e = o.clone.call(this);
              return e._data = this._data.clone(), e;
            },
            _minBufferSize: 0
          });
        r.Hasher = f.extend({
          cfg: o.extend(),
          init: function init(e) {
            this.cfg = this.cfg.extend(e), this.reset();
          },
          reset: function reset() {
            f.reset.call(this), this._doReset();
          },
          update: function update(e) {
            return this._append(e), this._process(), this;
          },
          finalize: function finalize(e) {
            return e && this._append(e), this._doFinalize();
          },
          blockSize: 16,
          _createHelper: function _createHelper(e) {
            return function (t, n) {
              return new e.init(n).finalize(t);
            };
          },
          _createHmacHelper: function _createHmacHelper(e) {
            return function (t, n) {
              return new d.HMAC.init(e, n).finalize(t);
            };
          }
        });
        var d = n.algo = {};
        return n;
      }(Math);
    !function (e) {
      for (var t = s, n = (i = t.lib).WordArray, r = i.Hasher, i = t.algo, o = [], a = [], u = function u(e) {
          return 4294967296 * (e - (0 | e)) | 0;
        }, c = 2, l = 0; 64 > l;) {
        var f;
        e: {
          f = c;
          for (var d = e.sqrt(f), p = 2; p <= d; p++) {
            if (!(f % p)) {
              f = !1;
              break e;
            }
          }
          f = !0;
        }
        f && (8 > l && (o[l] = u(e.pow(c, .5))), a[l] = u(e.pow(c, 1 / 3)), l++), c++;
      }
      var h = [];
      i = i.SHA256 = r.extend({
        _doReset: function _doReset() {
          this._hash = new n.init(o.slice(0));
        },
        _doProcessBlock: function _doProcessBlock(e, t) {
          for (var n = this._hash.words, r = n[0], i = n[1], o = n[2], u = n[3], s = n[4], c = n[5], l = n[6], f = n[7], d = 0; 64 > d; d++) {
            if (16 > d) h[d] = 0 | e[t + d];else {
              var p = h[d - 15],
                y = h[d - 2];
              h[d] = ((p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3) + h[d - 7] + ((y << 15 | y >>> 17) ^ (y << 13 | y >>> 19) ^ y >>> 10) + h[d - 16];
            }
            p = f + ((s << 26 | s >>> 6) ^ (s << 21 | s >>> 11) ^ (s << 7 | s >>> 25)) + (s & c ^ ~s & l) + a[d] + h[d], y = ((r << 30 | r >>> 2) ^ (r << 19 | r >>> 13) ^ (r << 10 | r >>> 22)) + (r & i ^ r & o ^ i & o), f = l, l = c, c = s, s = u + p | 0, u = o, o = i, i = r, r = p + y | 0;
          }
          n[0] = n[0] + r | 0, n[1] = n[1] + i | 0, n[2] = n[2] + o | 0, n[3] = n[3] + u | 0, n[4] = n[4] + s | 0, n[5] = n[5] + c | 0, n[6] = n[6] + l | 0, n[7] = n[7] + f | 0;
        },
        _doFinalize: function _doFinalize() {
          var t = this._data,
            n = t.words,
            r = 8 * this._nDataBytes,
            i = 8 * t.sigBytes;
          return n[i >>> 5] |= 128 << 24 - i % 32, n[14 + (i + 64 >>> 9 << 4)] = e.floor(r / 4294967296), n[15 + (i + 64 >>> 9 << 4)] = r, t.sigBytes = 4 * n.length, this._process(), this._hash;
        },
        clone: function clone() {
          var e = r.clone.call(this);
          return e._hash = this._hash.clone(), e;
        }
      });
      t.SHA256 = r._createHelper(i), t.HmacSHA256 = r._createHmacHelper(i);
    }(Math), i = (r = s).enc.Utf8, r.algo.HMAC = r.lib.Base.extend({
      init: function init(e, t) {
        e = this._hasher = new e.init(), "string" == typeof t && (t = i.parse(t));
        var n = e.blockSize,
          r = 4 * n;
        t.sigBytes > r && (t = e.finalize(t)), t.clamp();
        for (var o = this._oKey = t.clone(), a = this._iKey = t.clone(), u = o.words, s = a.words, c = 0; c < n; c++) {
          u[c] ^= 1549556828, s[c] ^= 909522486;
        }
        o.sigBytes = a.sigBytes = r, this.reset();
      },
      reset: function reset() {
        var e = this._hasher;
        e.reset(), e.update(this._iKey);
      },
      update: function update(e) {
        return this._hasher.update(e), this;
      },
      finalize: function finalize(e) {
        var t = this._hasher;
        return e = t.finalize(e), t.reset(), t.finalize(this._oKey.clone().concat(e));
      }
    }), a = (o = s).lib.WordArray, o.enc.Base64 = {
      stringify: function stringify(e) {
        var t = e.words,
          n = e.sigBytes,
          r = this._map;
        e.clamp(), e = [];
        for (var i = 0; i < n; i += 3) {
          for (var o = (t[i >>> 2] >>> 24 - i % 4 * 8 & 255) << 16 | (t[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255) << 8 | t[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255, a = 0; 4 > a && i + .75 * a < n; a++) {
            e.push(r.charAt(o >>> 6 * (3 - a) & 63));
          }
        }
        if (t = r.charAt(64)) for (; e.length % 4;) {
          e.push(t);
        }
        return e.join("");
      },
      parse: function parse(e) {
        var t = e.length,
          n = this._map;
        (r = n.charAt(64)) && -1 != (r = e.indexOf(r)) && (t = r);
        for (var r = [], i = 0, o = 0; o < t; o++) {
          if (o % 4) {
            var u = n.indexOf(e.charAt(o - 1)) << o % 4 * 2,
              s = n.indexOf(e.charAt(o)) >>> 6 - o % 4 * 2;
            r[i >>> 2] |= (u | s) << 24 - i % 4 * 8, i++;
          }
        }
        return a.create(r, i);
      },
      _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }, function (e) {
      function t(e, t, n, r, i, o, a) {
        return ((e = e + (t & n | ~t & r) + i + a) << o | e >>> 32 - o) + t;
      }
      function n(e, t, n, r, i, o, a) {
        return ((e = e + (t & r | n & ~r) + i + a) << o | e >>> 32 - o) + t;
      }
      function r(e, t, n, r, i, o, a) {
        return ((e = e + (t ^ n ^ r) + i + a) << o | e >>> 32 - o) + t;
      }
      function i(e, t, n, r, i, o, a) {
        return ((e = e + (n ^ (t | ~r)) + i + a) << o | e >>> 32 - o) + t;
      }
      for (var o = s, a = (c = o.lib).WordArray, u = c.Hasher, c = o.algo, l = [], f = 0; 64 > f; f++) {
        l[f] = 4294967296 * e.abs(e.sin(f + 1)) | 0;
      }
      c = c.MD5 = u.extend({
        _doReset: function _doReset() {
          this._hash = new a.init([1732584193, 4023233417, 2562383102, 271733878]);
        },
        _doProcessBlock: function _doProcessBlock(e, o) {
          for (var a = 0; 16 > a; a++) {
            var u = e[s = o + a];
            e[s] = 16711935 & (u << 8 | u >>> 24) | 4278255360 & (u << 24 | u >>> 8);
          }
          a = this._hash.words;
          var s = e[o + 0],
            c = (u = e[o + 1], e[o + 2]),
            f = e[o + 3],
            d = e[o + 4],
            p = e[o + 5],
            h = e[o + 6],
            y = e[o + 7],
            g = e[o + 8],
            v = e[o + 9],
            b = e[o + 10],
            m = e[o + 11],
            _ = e[o + 12],
            P = e[o + 13],
            O = e[o + 14],
            S = e[o + 15],
            w = t(w = a[0], x = a[1], T = a[2], k = a[3], s, 7, l[0]),
            k = t(k, w, x, T, u, 12, l[1]),
            T = t(T, k, w, x, c, 17, l[2]),
            x = t(x, T, k, w, f, 22, l[3]);
          w = t(w, x, T, k, d, 7, l[4]), k = t(k, w, x, T, p, 12, l[5]), T = t(T, k, w, x, h, 17, l[6]), x = t(x, T, k, w, y, 22, l[7]), w = t(w, x, T, k, g, 7, l[8]), k = t(k, w, x, T, v, 12, l[9]), T = t(T, k, w, x, b, 17, l[10]), x = t(x, T, k, w, m, 22, l[11]), w = t(w, x, T, k, _, 7, l[12]), k = t(k, w, x, T, P, 12, l[13]), T = t(T, k, w, x, O, 17, l[14]), w = n(w, x = t(x, T, k, w, S, 22, l[15]), T, k, u, 5, l[16]), k = n(k, w, x, T, h, 9, l[17]), T = n(T, k, w, x, m, 14, l[18]), x = n(x, T, k, w, s, 20, l[19]), w = n(w, x, T, k, p, 5, l[20]), k = n(k, w, x, T, b, 9, l[21]), T = n(T, k, w, x, S, 14, l[22]), x = n(x, T, k, w, d, 20, l[23]), w = n(w, x, T, k, v, 5, l[24]), k = n(k, w, x, T, O, 9, l[25]), T = n(T, k, w, x, f, 14, l[26]), x = n(x, T, k, w, g, 20, l[27]), w = n(w, x, T, k, P, 5, l[28]), k = n(k, w, x, T, c, 9, l[29]), T = n(T, k, w, x, y, 14, l[30]), w = r(w, x = n(x, T, k, w, _, 20, l[31]), T, k, p, 4, l[32]), k = r(k, w, x, T, g, 11, l[33]), T = r(T, k, w, x, m, 16, l[34]), x = r(x, T, k, w, O, 23, l[35]), w = r(w, x, T, k, u, 4, l[36]), k = r(k, w, x, T, d, 11, l[37]), T = r(T, k, w, x, y, 16, l[38]), x = r(x, T, k, w, b, 23, l[39]), w = r(w, x, T, k, P, 4, l[40]), k = r(k, w, x, T, s, 11, l[41]), T = r(T, k, w, x, f, 16, l[42]), x = r(x, T, k, w, h, 23, l[43]), w = r(w, x, T, k, v, 4, l[44]), k = r(k, w, x, T, _, 11, l[45]), T = r(T, k, w, x, S, 16, l[46]), w = i(w, x = r(x, T, k, w, c, 23, l[47]), T, k, s, 6, l[48]), k = i(k, w, x, T, y, 10, l[49]), T = i(T, k, w, x, O, 15, l[50]), x = i(x, T, k, w, p, 21, l[51]), w = i(w, x, T, k, _, 6, l[52]), k = i(k, w, x, T, f, 10, l[53]), T = i(T, k, w, x, b, 15, l[54]), x = i(x, T, k, w, u, 21, l[55]), w = i(w, x, T, k, g, 6, l[56]), k = i(k, w, x, T, S, 10, l[57]), T = i(T, k, w, x, h, 15, l[58]), x = i(x, T, k, w, P, 21, l[59]), w = i(w, x, T, k, d, 6, l[60]), k = i(k, w, x, T, m, 10, l[61]), T = i(T, k, w, x, c, 15, l[62]), x = i(x, T, k, w, v, 21, l[63]);
          a[0] = a[0] + w | 0, a[1] = a[1] + x | 0, a[2] = a[2] + T | 0, a[3] = a[3] + k | 0;
        },
        _doFinalize: function _doFinalize() {
          var t = this._data,
            n = t.words,
            r = 8 * this._nDataBytes,
            i = 8 * t.sigBytes;
          n[i >>> 5] |= 128 << 24 - i % 32;
          var o = e.floor(r / 4294967296);
          for (n[15 + (i + 64 >>> 9 << 4)] = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8), n[14 + (i + 64 >>> 9 << 4)] = 16711935 & (r << 8 | r >>> 24) | 4278255360 & (r << 24 | r >>> 8), t.sigBytes = 4 * (n.length + 1), this._process(), n = (t = this._hash).words, r = 0; 4 > r; r++) {
            i = n[r], n[r] = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8);
          }
          return t;
        },
        clone: function clone() {
          var e = u.clone.call(this);
          return e._hash = this._hash.clone(), e;
        }
      }), o.MD5 = u._createHelper(c), o.HmacMD5 = u._createHmacHelper(c);
    }(Math), function () {
      var e,
        t = s,
        n = (e = t.lib).Base,
        r = e.WordArray,
        i = (e = t.algo).EvpKDF = n.extend({
          cfg: n.extend({
            keySize: 4,
            hasher: e.MD5,
            iterations: 1
          }),
          init: function init(e) {
            this.cfg = this.cfg.extend(e);
          },
          compute: function compute(e, t) {
            for (var n = (u = this.cfg).hasher.create(), i = r.create(), o = i.words, a = u.keySize, u = u.iterations; o.length < a;) {
              s && n.update(s);
              var s = n.update(e).finalize(t);
              n.reset();
              for (var c = 1; c < u; c++) {
                s = n.finalize(s), n.reset();
              }
              i.concat(s);
            }
            return i.sigBytes = 4 * a, i;
          }
        });
      t.EvpKDF = function (e, t, n) {
        return i.create(n).compute(e, t);
      };
    }(), s.lib.Cipher || function (e) {
      var t = (h = s).lib,
        n = t.Base,
        r = t.WordArray,
        i = t.BufferedBlockAlgorithm,
        o = h.enc.Base64,
        a = h.algo.EvpKDF,
        u = t.Cipher = i.extend({
          cfg: n.extend(),
          createEncryptor: function createEncryptor(e, t) {
            return this.create(this._ENC_XFORM_MODE, e, t);
          },
          createDecryptor: function createDecryptor(e, t) {
            return this.create(this._DEC_XFORM_MODE, e, t);
          },
          init: function init(e, t, n) {
            this.cfg = this.cfg.extend(n), this._xformMode = e, this._key = t, this.reset();
          },
          reset: function reset() {
            i.reset.call(this), this._doReset();
          },
          process: function process(e) {
            return this._append(e), this._process();
          },
          finalize: function finalize(e) {
            return e && this._append(e), this._doFinalize();
          },
          keySize: 4,
          ivSize: 4,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          _createHelper: function _createHelper(e) {
            return {
              encrypt: function encrypt(t, n, r) {
                return ("string" == typeof n ? y : p).encrypt(e, t, n, r);
              },
              decrypt: function decrypt(t, n, r) {
                return ("string" == typeof n ? y : p).decrypt(e, t, n, r);
              }
            };
          }
        });
      t.StreamCipher = u.extend({
        _doFinalize: function _doFinalize() {
          return this._process(!0);
        },
        blockSize: 1
      });
      var c = h.mode = {},
        l = function l(e, t, n) {
          var r = this._iv;
          r ? this._iv = void 0 : r = this._prevBlock;
          for (var i = 0; i < n; i++) {
            e[t + i] ^= r[i];
          }
        },
        f = (t.BlockCipherMode = n.extend({
          createEncryptor: function createEncryptor(e, t) {
            return this.Encryptor.create(e, t);
          },
          createDecryptor: function createDecryptor(e, t) {
            return this.Decryptor.create(e, t);
          },
          init: function init(e, t) {
            this._cipher = e, this._iv = t;
          }
        })).extend();
      f.Encryptor = f.extend({
        processBlock: function processBlock(e, t) {
          var n = this._cipher,
            r = n.blockSize;
          l.call(this, e, t, r), n.encryptBlock(e, t), this._prevBlock = e.slice(t, t + r);
        }
      }), f.Decryptor = f.extend({
        processBlock: function processBlock(e, t) {
          var n = this._cipher,
            r = n.blockSize,
            i = e.slice(t, t + r);
          n.decryptBlock(e, t), l.call(this, e, t, r), this._prevBlock = i;
        }
      }), c = c.CBC = f, f = (h.pad = {}).Pkcs7 = {
        pad: function pad(e, t) {
          for (var n, i = (n = (n = 4 * t) - e.sigBytes % n) << 24 | n << 16 | n << 8 | n, o = [], a = 0; a < n; a += 4) {
            o.push(i);
          }
          n = r.create(o, n), e.concat(n);
        },
        unpad: function unpad(e) {
          e.sigBytes -= 255 & e.words[e.sigBytes - 1 >>> 2];
        }
      }, t.BlockCipher = u.extend({
        cfg: u.cfg.extend({
          mode: c,
          padding: f
        }),
        reset: function reset() {
          u.reset.call(this);
          var e = (t = this.cfg).iv,
            t = t.mode;
          if (this._xformMode == this._ENC_XFORM_MODE) var n = t.createEncryptor;else n = t.createDecryptor, this._minBufferSize = 1;
          this._mode = n.call(t, this, e && e.words);
        },
        _doProcessBlock: function _doProcessBlock(e, t) {
          this._mode.processBlock(e, t);
        },
        _doFinalize: function _doFinalize() {
          var e = this.cfg.padding;
          if (this._xformMode == this._ENC_XFORM_MODE) {
            e.pad(this._data, this.blockSize);
            var t = this._process(!0);
          } else t = this._process(!0), e.unpad(t);
          return t;
        },
        blockSize: 4
      });
      var d = t.CipherParams = n.extend({
          init: function init(e) {
            this.mixIn(e);
          },
          toString: function toString(e) {
            return (e || this.formatter).stringify(this);
          }
        }),
        p = (c = (h.format = {}).OpenSSL = {
          stringify: function stringify(e) {
            var t = e.ciphertext;
            return ((e = e.salt) ? r.create([1398893684, 1701076831]).concat(e).concat(t) : t).toString(o);
          },
          parse: function parse(e) {
            var t = (e = o.parse(e)).words;
            if (1398893684 == t[0] && 1701076831 == t[1]) {
              var n = r.create(t.slice(2, 4));
              t.splice(0, 4), e.sigBytes -= 16;
            }
            return d.create({
              ciphertext: e,
              salt: n
            });
          }
        }, t.SerializableCipher = n.extend({
          cfg: n.extend({
            format: c
          }),
          encrypt: function encrypt(e, t, n, r) {
            r = this.cfg.extend(r);
            var i = e.createEncryptor(n, r);
            return t = i.finalize(t), i = i.cfg, d.create({
              ciphertext: t,
              key: n,
              iv: i.iv,
              algorithm: e,
              mode: i.mode,
              padding: i.padding,
              blockSize: e.blockSize,
              formatter: r.format
            });
          },
          decrypt: function decrypt(e, t, n, r) {
            return r = this.cfg.extend(r), t = this._parse(t, r.format), e.createDecryptor(n, r).finalize(t.ciphertext);
          },
          _parse: function _parse(e, t) {
            return "string" == typeof e ? t.parse(e, this) : e;
          }
        })),
        h = (h.kdf = {}).OpenSSL = {
          execute: function execute(e, t, n, i) {
            return i || (i = r.random(8)), e = a.create({
              keySize: t + n
            }).compute(e, i), n = r.create(e.words.slice(t), 4 * n), e.sigBytes = 4 * t, d.create({
              key: e,
              iv: n,
              salt: i
            });
          }
        },
        y = t.PasswordBasedCipher = p.extend({
          cfg: p.cfg.extend({
            kdf: h
          }),
          encrypt: function encrypt(e, t, n, r) {
            return n = (r = this.cfg.extend(r)).kdf.execute(n, e.keySize, e.ivSize), r.iv = n.iv, (e = p.encrypt.call(this, e, t, n.key, r)).mixIn(n), e;
          },
          decrypt: function decrypt(e, t, n, r) {
            return r = this.cfg.extend(r), t = this._parse(t, r.format), n = r.kdf.execute(n, e.keySize, e.ivSize, t.salt), r.iv = n.iv, p.decrypt.call(this, e, t, n.key, r);
          }
        });
    }(), function () {
      for (var e = s, t = e.lib.BlockCipher, n = e.algo, r = [], i = [], o = [], a = [], u = [], c = [], l = [], f = [], d = [], p = [], h = [], y = 0; 256 > y; y++) {
        h[y] = 128 > y ? y << 1 : y << 1 ^ 283;
      }
      var g = 0,
        v = 0;
      for (y = 0; 256 > y; y++) {
        var b = (b = v ^ v << 1 ^ v << 2 ^ v << 3 ^ v << 4) >>> 8 ^ 255 & b ^ 99;
        r[g] = b, i[b] = g;
        var m = h[g],
          _ = h[m],
          P = h[_],
          O = 257 * h[b] ^ 16843008 * b;
        o[g] = O << 24 | O >>> 8, a[g] = O << 16 | O >>> 16, u[g] = O << 8 | O >>> 24, c[g] = O, O = 16843009 * P ^ 65537 * _ ^ 257 * m ^ 16843008 * g, l[b] = O << 24 | O >>> 8, f[b] = O << 16 | O >>> 16, d[b] = O << 8 | O >>> 24, p[b] = O, g ? (g = m ^ h[h[h[P ^ m]]], v ^= h[h[v]]) : g = v = 1;
      }
      var S = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
      n = n.AES = t.extend({
        _doReset: function _doReset() {
          for (var e = (n = this._key).words, t = n.sigBytes / 4, n = 4 * ((this._nRounds = t + 6) + 1), i = this._keySchedule = [], o = 0; o < n; o++) {
            if (o < t) i[o] = e[o];else {
              var a = i[o - 1];
              o % t ? 6 < t && 4 == o % t && (a = r[a >>> 24] << 24 | r[a >>> 16 & 255] << 16 | r[a >>> 8 & 255] << 8 | r[255 & a]) : (a = r[(a = a << 8 | a >>> 24) >>> 24] << 24 | r[a >>> 16 & 255] << 16 | r[a >>> 8 & 255] << 8 | r[255 & a], a ^= S[o / t | 0] << 24), i[o] = i[o - t] ^ a;
            }
          }
          for (e = this._invKeySchedule = [], t = 0; t < n; t++) {
            o = n - t, a = t % 4 ? i[o] : i[o - 4], e[t] = 4 > t || 4 >= o ? a : l[r[a >>> 24]] ^ f[r[a >>> 16 & 255]] ^ d[r[a >>> 8 & 255]] ^ p[r[255 & a]];
          }
        },
        encryptBlock: function encryptBlock(e, t) {
          this._doCryptBlock(e, t, this._keySchedule, o, a, u, c, r);
        },
        decryptBlock: function decryptBlock(e, t) {
          var n = e[t + 1];
          e[t + 1] = e[t + 3], e[t + 3] = n, this._doCryptBlock(e, t, this._invKeySchedule, l, f, d, p, i), n = e[t + 1], e[t + 1] = e[t + 3], e[t + 3] = n;
        },
        _doCryptBlock: function _doCryptBlock(e, t, n, r, i, o, a, u) {
          for (var s = this._nRounds, c = e[t] ^ n[0], l = e[t + 1] ^ n[1], f = e[t + 2] ^ n[2], d = e[t + 3] ^ n[3], p = 4, h = 1; h < s; h++) {
            var y = r[c >>> 24] ^ i[l >>> 16 & 255] ^ o[f >>> 8 & 255] ^ a[255 & d] ^ n[p++],
              g = r[l >>> 24] ^ i[f >>> 16 & 255] ^ o[d >>> 8 & 255] ^ a[255 & c] ^ n[p++],
              v = r[f >>> 24] ^ i[d >>> 16 & 255] ^ o[c >>> 8 & 255] ^ a[255 & l] ^ n[p++];
            d = r[d >>> 24] ^ i[c >>> 16 & 255] ^ o[l >>> 8 & 255] ^ a[255 & f] ^ n[p++], c = y, l = g, f = v;
          }
          y = (u[c >>> 24] << 24 | u[l >>> 16 & 255] << 16 | u[f >>> 8 & 255] << 8 | u[255 & d]) ^ n[p++], g = (u[l >>> 24] << 24 | u[f >>> 16 & 255] << 16 | u[d >>> 8 & 255] << 8 | u[255 & c]) ^ n[p++], v = (u[f >>> 24] << 24 | u[d >>> 16 & 255] << 16 | u[c >>> 8 & 255] << 8 | u[255 & l]) ^ n[p++], d = (u[d >>> 24] << 24 | u[c >>> 16 & 255] << 16 | u[l >>> 8 & 255] << 8 | u[255 & f]) ^ n[p++], e[t] = y, e[t + 1] = g, e[t + 2] = v, e[t + 3] = d;
        },
        keySize: 8
      });
      e.AES = t._createHelper(n);
    }(), s.mode.ECB = ((u = s.lib.BlockCipherMode.extend()).Encryptor = u.extend({
      processBlock: function processBlock(e, t) {
        this._cipher.encryptBlock(e, t);
      }
    }), u.Decryptor = u.extend({
      processBlock: function processBlock(e, t) {
        this._cipher.decryptBlock(e, t);
      }
    }), u), e.exports = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(6)),
      a = r(n(4)),
      u = (n(2), r(n(10))),
      s = function () {
        function e() {
          (0, i.default)(this, e), (0, a.default)(this, "_listeners", void 0), this._listeners = [];
        }
        return (0, o.default)(e, [{
          key: "addListener",
          value: function value(e) {
            this._listeners.push(e);
          }
        }, {
          key: "removeListener",
          value: function value(e) {
            var t = [];
            this._listeners.forEach(function (n) {
              n !== e && t.push(n);
            }), this._listeners = t;
          }
        }, {
          key: "removeAllListeners",
          value: function value() {
            this._listeners = [];
          }
        }, {
          key: "announcePresence",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.presence && t.presence(e);
            });
          }
        }, {
          key: "announceStatus",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.status && t.status(e);
            });
          }
        }, {
          key: "announceMessage",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.message && t.message(e);
            });
          }
        }, {
          key: "announceSignal",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.signal && t.signal(e);
            });
          }
        }, {
          key: "announceMessageAction",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.messageAction && t.messageAction(e);
            });
          }
        }, {
          key: "announceFile",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.file && t.file(e);
            });
          }
        }, {
          key: "announceObjects",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.objects && t.objects(e);
            });
          }
        }, {
          key: "announceUser",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.user && t.user(e);
            });
          }
        }, {
          key: "announceSpace",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.space && t.space(e);
            });
          }
        }, {
          key: "announceMembership",
          value: function value(e) {
            this._listeners.forEach(function (t) {
              t.membership && t.membership(e);
            });
          }
        }, {
          key: "announceNetworkUp",
          value: function value() {
            var e = {};
            e.category = u.default.PNNetworkUpCategory, this.announceStatus(e);
          }
        }, {
          key: "announceNetworkDown",
          value: function value() {
            var e = {};
            e.category = u.default.PNNetworkDownCategory, this.announceStatus(e);
          }
        }]), e;
      }();
    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNTimeOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function () {
      return "/time/0";
    }, t.handleResponse = function (e, t) {
      return {
        timetoken: t[0]
      };
    }, t.isAuthSupported = function () {
      return !1;
    }, t.prepareParams = function () {
      return {};
    }, t.validateParams = function () {};
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    var r = n(21),
      i = Object.prototype.hasOwnProperty,
      o = Array.isArray,
      a = function () {
        for (var e = [], t = 0; t < 256; ++t) {
          e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
        }
        return e;
      }(),
      u = function u(e, t) {
        for (var n = t && t.plainObjects ? Object.create(null) : {}, r = 0; r < e.length; ++r) {
          void 0 !== e[r] && (n[r] = e[r]);
        }
        return n;
      };
    e.exports = {
      arrayToObject: u,
      assign: function assign(e, t) {
        return Object.keys(t).reduce(function (e, n) {
          return e[n] = t[n], e;
        }, e);
      },
      combine: function combine(e, t) {
        return [].concat(e, t);
      },
      compact: function compact(e) {
        for (var t = [{
            obj: {
              o: e
            },
            prop: "o"
          }], n = [], r = 0; r < t.length; ++r) {
          for (var i = t[r], a = i.obj[i.prop], u = Object.keys(a), s = 0; s < u.length; ++s) {
            var c = u[s],
              l = a[c];
            "object" == typeof l && null !== l && -1 === n.indexOf(l) && (t.push({
              obj: a,
              prop: c
            }), n.push(l));
          }
        }
        return function (e) {
          for (; e.length > 1;) {
            var t = e.pop(),
              n = t.obj[t.prop];
            if (o(n)) {
              for (var r = [], i = 0; i < n.length; ++i) {
                void 0 !== n[i] && r.push(n[i]);
              }
              t.obj[t.prop] = r;
            }
          }
        }(t), e;
      },
      decode: function decode(e, t, n) {
        var r = e.replace(/\+/g, " ");
        if ("iso-8859-1" === n) return r.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
          return decodeURIComponent(r);
        } catch (e) {
          return r;
        }
      },
      encode: function encode(e, t, n, i, o) {
        if (0 === e.length) return e;
        var u = e;
        if ("symbol" == typeof e ? u = Symbol.prototype.toString.call(e) : "string" != typeof e && (u = String(e)), "iso-8859-1" === n) return escape(u).replace(/%u[0-9a-f]{4}/gi, function (e) {
          return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
        });
        for (var s = "", c = 0; c < u.length; ++c) {
          var l = u.charCodeAt(c);
          45 === l || 46 === l || 95 === l || 126 === l || l >= 48 && l <= 57 || l >= 65 && l <= 90 || l >= 97 && l <= 122 || o === r.RFC1738 && (40 === l || 41 === l) ? s += u.charAt(c) : l < 128 ? s += a[l] : l < 2048 ? s += a[192 | l >> 6] + a[128 | 63 & l] : l < 55296 || l >= 57344 ? s += a[224 | l >> 12] + a[128 | l >> 6 & 63] + a[128 | 63 & l] : (c += 1, l = 65536 + ((1023 & l) << 10 | 1023 & u.charCodeAt(c)), s += a[240 | l >> 18] + a[128 | l >> 12 & 63] + a[128 | l >> 6 & 63] + a[128 | 63 & l]);
        }
        return s;
      },
      isBuffer: function isBuffer(e) {
        return !(!e || "object" != typeof e) && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
      },
      isRegExp: function isRegExp(e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      },
      maybeMap: function maybeMap(e, t) {
        if (o(e)) {
          for (var n = [], r = 0; r < e.length; r += 1) {
            n.push(t(e[r]));
          }
          return n;
        }
        return t(e);
      },
      merge: function e(t, n, r) {
        if (!n) return t;
        if ("object" != typeof n) {
          if (o(t)) t.push(n);else {
            if (!t || "object" != typeof t) return [t, n];
            (r && (r.plainObjects || r.allowPrototypes) || !i.call(Object.prototype, n)) && (t[n] = !0);
          }
          return t;
        }
        if (!t || "object" != typeof t) return [t].concat(n);
        var a = t;
        return o(t) && !o(n) && (a = u(t, r)), o(t) && o(n) ? (n.forEach(function (n, o) {
          if (i.call(t, o)) {
            var a = t[o];
            a && "object" == typeof a && n && "object" == typeof n ? t[o] = e(a, n, r) : t.push(n);
          } else t[o] = n;
        }), t) : Object.keys(n).reduce(function (t, o) {
          var a = n[o];
          return i.call(t, o) ? t[o] = e(t[o], a, r) : t[o] = a, t;
        }, a);
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    e.exports = function (e) {
      return null !== e && "object" === r(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(14)),
      a = r(n(16)),
      u = r(n(13)),
      s = r(n(7)),
      c = r(n(32)),
      l = r(n(33)),
      f = r(n(125)),
      d = r(n(25)),
      p = r(n(126)),
      h = r(n(127)),
      y = n(128),
      g = (n(2), r(n(148))),
      v = r(n(149));
    function b(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = (0, u.default)(e);
        if (t) {
          var i = (0, u.default)(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);
        return (0, a.default)(this, n);
      };
    }
    function m(e) {
      if (!navigator || !navigator.sendBeacon) return !1;
      navigator.sendBeacon(e);
    }
    function _(e) {
      for (var t = d.default.enc.Base64.parse(e).words, n = new ArrayBuffer(4 * t.length), r = new Uint8Array(n), i = 0, o = 0, a = 0; a < t.length; a += 1) {
        var u = t[a];
        r[o = 4 * a] = (4278190080 & u) >> 24, r[o + 1] = (16711680 & u) >> 16, r[o + 2] = (65280 & u) >> 8, r[o + 3] = 255 & u;
      }
      for (var s = o + 3; s >= o; s -= 1) {
        0 === r[s] && (i += 1);
      }
      return i > 0 ? r.buffer.slice(0, r.byteLength - i) : r.buffer;
    }
    function P(e) {
      var t = function t(e) {
        return e && "object" === (0, s.default)(e) && e.constructor === Object;
      };
      if (!t(e)) return e;
      var n = {};
      return Object.keys(e).forEach(function (r) {
        var i = function (e) {
            return "string" == typeof e || e instanceof String;
          }(r),
          o = r,
          a = e[r];
        Array.isArray(r) || i && r.indexOf(",") >= 0 ? o = (i ? r.split(",") : r).reduce(function (e, t) {
          return e += String.fromCharCode(t);
        }, "") : (function (e) {
          return "number" == typeof e && isFinite(e);
        }(r) || i && !isNaN(r)) && (o = String.fromCharCode(i ? parseInt(r, 10) : 10));
        n[o] = t(a) ? P(a) : a;
      }), n;
    }
    var O = function (e) {
      (0, o.default)(n, e);
      var t = b(n);
      function n(e) {
        var r;
        (0, i.default)(this, n);
        var o = e.listenToBrowserNetworkEvents,
          a = void 0 === o || o;
        return e.db = p.default, e.sdkFamily = "Web", e.networking = new f.default({
          del: y.del,
          get: y.get,
          post: y.post,
          patch: y.patch,
          sendBeacon: m,
          getfile: y.getfile,
          postfile: y.postfile
        }), e.cbor = new h.default(function (e) {
          return P(c.default.decode(e));
        }, _), e.PubNubFile = v.default, e.cryptography = new g.default(), r = t.call(this, e), a && (window.addEventListener("offline", function () {
          r.networkDownDetected();
        }), window.addEventListener("online", function () {
          r.networkUpDetected();
        })), r;
      }
      return n;
    }(l.default);
    t.default = O, e.exports = t.default;
  }, function (e, t, n) {
    var r, i;
    !function (o, a) {
      "use strict";

      var u = Math.pow(2, -24),
        s = Math.pow(2, 32),
        c = Math.pow(2, 53);
      void 0 === (i = "function" == typeof (r = {
        encode: function encode(e) {
          var t,
            n = new ArrayBuffer(256),
            r = new DataView(n),
            i = 0;
          function o(e) {
            for (var o = n.byteLength, a = i + e; o < a;) {
              o *= 2;
            }
            if (o !== n.byteLength) {
              var u = r;
              n = new ArrayBuffer(o), r = new DataView(n);
              for (var s = i + 3 >> 2, c = 0; c < s; ++c) {
                r.setUint32(4 * c, u.getUint32(4 * c));
              }
            }
            return t = e, r;
          }
          function a() {
            i += t;
          }
          function u(e) {
            a(o(1).setUint8(i, e));
          }
          function l(e) {
            for (var t = o(e.length), n = 0; n < e.length; ++n) {
              t.setUint8(i + n, e[n]);
            }
            a();
          }
          function f(e, t) {
            t < 24 ? u(e << 5 | t) : t < 256 ? (u(e << 5 | 24), u(t)) : t < 65536 ? (u(e << 5 | 25), function (e) {
              a(o(2).setUint16(i, e));
            }(t)) : t < 4294967296 ? (u(e << 5 | 26), function (e) {
              a(o(4).setUint32(i, e));
            }(t)) : (u(e << 5 | 27), function (e) {
              var t = e % s,
                n = (e - t) / s,
                r = o(8);
              r.setUint32(i, n), r.setUint32(i + 4, t), a();
            }(t));
          }
          if (function e(t) {
            var n;
            if (!1 === t) return u(244);
            if (!0 === t) return u(245);
            if (null === t) return u(246);
            if (void 0 === t) return u(247);
            switch (typeof t) {
              case "number":
                if (Math.floor(t) === t) {
                  if (0 <= t && t <= c) return f(0, t);
                  if (-c <= t && t < 0) return f(1, -(t + 1));
                }
                return u(251), function (e) {
                  a(o(8).setFloat64(i, e));
                }(t);
              case "string":
                var r = [];
                for (n = 0; n < t.length; ++n) {
                  var s = t.charCodeAt(n);
                  s < 128 ? r.push(s) : s < 2048 ? (r.push(192 | s >> 6), r.push(128 | 63 & s)) : s < 55296 ? (r.push(224 | s >> 12), r.push(128 | s >> 6 & 63), r.push(128 | 63 & s)) : (s = (1023 & s) << 10, s |= 1023 & t.charCodeAt(++n), s += 65536, r.push(240 | s >> 18), r.push(128 | s >> 12 & 63), r.push(128 | s >> 6 & 63), r.push(128 | 63 & s));
                }
                return f(3, r.length), l(r);
              default:
                var d;
                if (Array.isArray(t)) for (f(4, d = t.length), n = 0; n < d; ++n) {
                  e(t[n]);
                } else if (t instanceof Uint8Array) f(2, t.length), l(t);else {
                  var p = Object.keys(t);
                  for (f(5, d = p.length), n = 0; n < d; ++n) {
                    var h = p[n];
                    e(h), e(t[h]);
                  }
                }
            }
          }(e), "slice" in n) return n.slice(0, i);
          for (var d = new ArrayBuffer(i), p = new DataView(d), h = 0; h < i; ++h) {
            p.setUint8(h, r.getUint8(h));
          }
          return d;
        },
        decode: function decode(e, t, n) {
          var r = new DataView(e),
            i = 0;
          function o(e, t) {
            return i += t, e;
          }
          function a(t) {
            return o(new Uint8Array(e, i, t), t);
          }
          function c() {
            return o(r.getUint8(i), 1);
          }
          function l() {
            return o(r.getUint16(i), 2);
          }
          function f() {
            return o(r.getUint32(i), 4);
          }
          function d() {
            return 255 === r.getUint8(i) && (i += 1, !0);
          }
          function p(e) {
            if (e < 24) return e;
            if (24 === e) return c();
            if (25 === e) return l();
            if (26 === e) return f();
            if (27 === e) return f() * s + f();
            if (31 === e) return -1;
            throw "Invalid length encoding";
          }
          function h(e) {
            var t = c();
            if (255 === t) return -1;
            var n = p(31 & t);
            if (n < 0 || t >> 5 !== e) throw "Invalid indefinite length element";
            return n;
          }
          function y(e, t) {
            for (var n = 0; n < t; ++n) {
              var r = c();
              128 & r && (r < 224 ? (r = (31 & r) << 6 | 63 & c(), t -= 1) : r < 240 ? (r = (15 & r) << 12 | (63 & c()) << 6 | 63 & c(), t -= 2) : (r = (15 & r) << 18 | (63 & c()) << 12 | (63 & c()) << 6 | 63 & c(), t -= 3)), r < 65536 ? e.push(r) : (r -= 65536, e.push(55296 | r >> 10), e.push(56320 | 1023 & r));
            }
          }
          "function" != typeof t && (t = function t(e) {
            return e;
          }), "function" != typeof n && (n = function n() {});
          var g = function e() {
            var s,
              f,
              g = c(),
              v = g >> 5,
              b = 31 & g;
            if (7 === v) switch (b) {
              case 25:
                return function () {
                  var e = new ArrayBuffer(4),
                    t = new DataView(e),
                    n = l(),
                    r = 32768 & n,
                    i = 31744 & n,
                    o = 1023 & n;
                  if (31744 === i) i = 261120;else if (0 !== i) i += 114688;else if (0 !== o) return o * u;
                  return t.setUint32(0, r << 16 | i << 13 | o << 13), t.getFloat32(0);
                }();
              case 26:
                return o(r.getFloat32(i), 4);
              case 27:
                return o(r.getFloat64(i), 8);
            }
            if ((f = p(b)) < 0 && (v < 2 || 6 < v)) throw "Invalid length";
            switch (v) {
              case 0:
                return f;
              case 1:
                return -1 - f;
              case 2:
                if (f < 0) {
                  for (var m = [], _ = 0; (f = h(v)) >= 0;) {
                    _ += f, m.push(a(f));
                  }
                  var P = new Uint8Array(_),
                    O = 0;
                  for (s = 0; s < m.length; ++s) {
                    P.set(m[s], O), O += m[s].length;
                  }
                  return P;
                }
                return a(f);
              case 3:
                var S = [];
                if (f < 0) for (; (f = h(v)) >= 0;) {
                  y(S, f);
                } else y(S, f);
                return String.fromCharCode.apply(null, S);
              case 4:
                var w;
                if (f < 0) for (w = []; !d();) {
                  w.push(e());
                } else for (w = new Array(f), s = 0; s < f; ++s) {
                  w[s] = e();
                }
                return w;
              case 5:
                var k = {};
                for (s = 0; s < f || f < 0 && !d(); ++s) {
                  k[e()] = e();
                }
                return k;
              case 6:
                return t(e(), f);
              case 7:
                switch (f) {
                  case 20:
                    return !1;
                  case 21:
                    return !0;
                  case 22:
                    return null;
                  case 23:
                    return;
                  default:
                    return n(f);
                }
            }
          }();
          if (i !== e.byteLength) throw "Remaining bytes";
          return g;
        }
      }) ? r.call(t, n, t, e) : r) || (e.exports = i);
    }();
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
      i = n(7);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(5)),
      a = r(n(6)),
      u = r(n(4)),
      s = r(n(8)),
      c = r(n(23)),
      l = r(n(39)),
      f = r(n(43)),
      d = r(n(44)),
      p = r(n(26)),
      h = r(n(47)),
      y = r(n(18)),
      g = n(3),
      v = Ce(n(52)),
      b = Ce(n(53)),
      m = Ce(n(54)),
      _ = Ce(n(55)),
      P = Ce(n(56)),
      O = Ce(n(57)),
      S = Ce(n(58)),
      w = Ce(n(59)),
      k = Ce(n(60)),
      T = Ce(n(61)),
      x = Ce(n(62)),
      A = Ce(n(63)),
      M = Ce(n(64)),
      E = Ce(n(65)),
      j = Ce(n(66)),
      R = Ce(n(67)),
      N = Ce(n(68)),
      C = Ce(n(69)),
      U = (n(28), Ce(n(70)), r(n(71))),
      I = r(n(72)),
      D = r(n(73)),
      F = r(n(74)),
      L = r(n(76)),
      K = r(n(77)),
      B = r(n(78)),
      G = r(n(79)),
      q = r(n(85)),
      H = r(n(86)),
      z = r(n(87)),
      W = r(n(88)),
      V = r(n(89)),
      Y = r(n(90)),
      J = r(n(91)),
      $ = r(n(92)),
      X = r(n(93)),
      Q = r(n(94)),
      Z = r(n(95)),
      ee = Ce(n(96)),
      te = Ce(n(97)),
      ne = Ce(n(98)),
      re = Ce(n(99)),
      ie = Ce(n(100)),
      oe = Ce(n(101)),
      ae = Ce(n(102)),
      ue = Ce(n(103)),
      se = Ce(n(104)),
      ce = Ce(n(105)),
      le = Ce(n(106)),
      fe = Ce(n(107)),
      de = Ce(n(108)),
      pe = Ce(n(109)),
      he = Ce(n(110)),
      ye = Ce(n(111)),
      ge = Ce(n(112)),
      ve = Ce(n(113)),
      be = Ce(n(114)),
      me = Ce(n(115)),
      _e = Ce(n(116)),
      Pe = r(n(117)),
      Oe = Ce(n(118)),
      Se = Ce(n(119)),
      we = Ce(n(120)),
      ke = Ce(n(121)),
      Te = Ce(n(122)),
      xe = Ce(n(123)),
      Ae = Ce(n(27)),
      Me = Ce(n(124)),
      Ee = r(n(1)),
      je = r(n(10)),
      Re = (n(2), r(n(17)));
    function Ne(e) {
      if ("function" != typeof WeakMap) return null;
      var t = new WeakMap(),
        n = new WeakMap();
      return (Ne = function Ne(e) {
        return e ? n : t;
      })(e);
    }
    function Ce(e, t) {
      if (!t && e && e.__esModule) return e;
      if (null === e || "object" !== i(e) && "function" != typeof e) return {
        default: e
      };
      var n = Ne(t);
      if (n && n.has(e)) return n.get(e);
      var r = {},
        o = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var a in e) {
        if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
          var u = o ? Object.getOwnPropertyDescriptor(e, a) : null;
          u && (u.get || u.set) ? Object.defineProperty(r, a, u) : r[a] = e[a];
        }
      }
      return r.default = e, n && n.set(e, r), r;
    }
    function Ue(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Ie(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ue(Object(n), !0).forEach(function (t) {
          (0, u.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ue(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    var De = function () {
      function e(t) {
        var n = this;
        (0, o.default)(this, e), (0, u.default)(this, "_config", void 0), (0, u.default)(this, "_telemetryManager", void 0), (0, u.default)(this, "_listenerManager", void 0), (0, u.default)(this, "_tokenManager", void 0), (0, u.default)(this, "time", void 0), (0, u.default)(this, "publish", void 0), (0, u.default)(this, "fire", void 0), (0, u.default)(this, "history", void 0), (0, u.default)(this, "deleteMessages", void 0), (0, u.default)(this, "messageCounts", void 0), (0, u.default)(this, "fetchMessages", void 0), (0, u.default)(this, "channelGroups", void 0), (0, u.default)(this, "push", void 0), (0, u.default)(this, "hereNow", void 0), (0, u.default)(this, "whereNow", void 0), (0, u.default)(this, "getState", void 0), (0, u.default)(this, "setState", void 0), (0, u.default)(this, "grant", void 0), (0, u.default)(this, "grantToken", void 0), (0, u.default)(this, "audit", void 0), (0, u.default)(this, "revokeToken", void 0), (0, u.default)(this, "subscribe", void 0), (0, u.default)(this, "signal", void 0), (0, u.default)(this, "presence", void 0), (0, u.default)(this, "unsubscribe", void 0), (0, u.default)(this, "unsubscribeAll", void 0), (0, u.default)(this, "addMessageAction", void 0), (0, u.default)(this, "removeMessageAction", void 0), (0, u.default)(this, "getMessageActions", void 0), (0, u.default)(this, "File", void 0), (0, u.default)(this, "encryptFile", void 0), (0, u.default)(this, "decryptFile", void 0), (0, u.default)(this, "listFiles", void 0), (0, u.default)(this, "sendFile", void 0), (0, u.default)(this, "downloadFile", void 0), (0, u.default)(this, "getFileUrl", void 0), (0, u.default)(this, "deleteFile", void 0), (0, u.default)(this, "publishFile", void 0), (0, u.default)(this, "objects", void 0), (0, u.default)(this, "createUser", void 0), (0, u.default)(this, "updateUser", void 0), (0, u.default)(this, "deleteUser", void 0), (0, u.default)(this, "getUser", void 0), (0, u.default)(this, "getUsers", void 0), (0, u.default)(this, "createSpace", void 0), (0, u.default)(this, "updateSpace", void 0), (0, u.default)(this, "deleteSpace", void 0), (0, u.default)(this, "getSpaces", void 0), (0, u.default)(this, "getSpace", void 0), (0, u.default)(this, "getMembers", void 0), (0, u.default)(this, "addMembers", void 0), (0, u.default)(this, "updateMembers", void 0), (0, u.default)(this, "removeMembers", void 0), (0, u.default)(this, "getMemberships", void 0), (0, u.default)(this, "joinSpaces", void 0), (0, u.default)(this, "updateMemberships", void 0), (0, u.default)(this, "leaveSpaces", void 0), (0, u.default)(this, "disconnect", void 0), (0, u.default)(this, "reconnect", void 0), (0, u.default)(this, "destroy", void 0), (0, u.default)(this, "stop", void 0), (0, u.default)(this, "getSubscribedChannels", void 0), (0, u.default)(this, "getSubscribedChannelGroups", void 0), (0, u.default)(this, "addListener", void 0), (0, u.default)(this, "removeListener", void 0), (0, u.default)(this, "removeAllListeners", void 0), (0, u.default)(this, "parseToken", void 0), (0, u.default)(this, "setToken", void 0), (0, u.default)(this, "getToken", void 0), (0, u.default)(this, "getAuthKey", void 0), (0, u.default)(this, "setAuthKey", void 0), (0, u.default)(this, "setCipherKey", void 0), (0, u.default)(this, "setUUID", void 0), (0, u.default)(this, "getUUID", void 0), (0, u.default)(this, "getFilterExpression", void 0), (0, u.default)(this, "setFilterExpression", void 0), (0, u.default)(this, "setHeartbeatInterval", void 0), (0, u.default)(this, "setProxy", void 0), (0, u.default)(this, "encrypt", void 0), (0, u.default)(this, "decrypt", void 0);
        var r = t.db,
          i = t.networking,
          a = t.cbor,
          d = this._config = new s.default({
            setup: t,
            db: r
          }),
          Ee = new c.default({
            config: d
          }),
          je = t.cryptography;
        i.init(d);
        var Re = this._tokenManager = new h.default(d, a),
          Ne = this._telemetryManager = new f.default({
            maximumSamplesCount: 6e4
          }),
          Ce = {
            config: d,
            networking: i,
            crypto: Ee,
            cryptography: je,
            tokenManager: Re,
            telemetryManager: Ne,
            PubNubFile: t.PubNubFile
          };
        this.File = t.PubNubFile, this.encryptFile = function (e, t) {
          return je.encryptFile(e, t, n.File);
        }, this.decryptFile = function (e, t) {
          return je.decryptFile(e, t, n.File);
        };
        var Ue = y.default.bind(this, Ce, Ae),
          De = y.default.bind(this, Ce, T),
          Fe = y.default.bind(this, Ce, A),
          Le = y.default.bind(this, Ce, E),
          Ke = y.default.bind(this, Ce, Me),
          Be = this._listenerManager = new p.default(),
          Ge = new l.default({
            timeEndpoint: Ue,
            leaveEndpoint: De,
            heartbeatEndpoint: Fe,
            setStateEndpoint: Le,
            subscribeEndpoint: Ke,
            crypto: Ce.crypto,
            config: Ce.config,
            listenerManager: Be,
            getFileUrl: function getFileUrl(e) {
              return (0, L.default)(Ce, e);
            }
          });
        this.addListener = Be.addListener.bind(Be), this.removeListener = Be.removeListener.bind(Be), this.removeAllListeners = Be.removeAllListeners.bind(Be), this.parseToken = Re.parseToken.bind(Re), this.setToken = Re.setToken.bind(Re), this.getToken = Re.getToken.bind(Re), this.channelGroups = {
          listGroups: y.default.bind(this, Ce, _),
          listChannels: y.default.bind(this, Ce, P),
          addChannels: y.default.bind(this, Ce, v),
          removeChannels: y.default.bind(this, Ce, b),
          deleteGroup: y.default.bind(this, Ce, m)
        }, this.push = {
          addChannels: y.default.bind(this, Ce, O),
          removeChannels: y.default.bind(this, Ce, S),
          deleteDevice: y.default.bind(this, Ce, k),
          listChannels: y.default.bind(this, Ce, w)
        }, this.hereNow = y.default.bind(this, Ce, j), this.whereNow = y.default.bind(this, Ce, x), this.getState = y.default.bind(this, Ce, M), this.setState = Ge.adaptStateChange.bind(Ge), this.grant = y.default.bind(this, Ce, me), this.grantToken = y.default.bind(this, Ce, _e), this.audit = y.default.bind(this, Ce, be), this.revokeToken = y.default.bind(this, Ce, Pe.default), this.publish = y.default.bind(this, Ce, Oe), this.fire = function (e, t) {
          return e.replicate = !1, e.storeInHistory = !1, n.publish(e, t);
        }, this.signal = y.default.bind(this, Ce, Se), this.history = y.default.bind(this, Ce, we), this.deleteMessages = y.default.bind(this, Ce, ke), this.messageCounts = y.default.bind(this, Ce, Te), this.fetchMessages = y.default.bind(this, Ce, xe), this.addMessageAction = y.default.bind(this, Ce, R), this.removeMessageAction = y.default.bind(this, Ce, N), this.getMessageActions = y.default.bind(this, Ce, C), this.listFiles = y.default.bind(this, Ce, U.default);
        var qe = y.default.bind(this, Ce, I.default);
        this.publishFile = y.default.bind(this, Ce, D.default), this.sendFile = (0, F.default)({
          generateUploadUrl: qe,
          publishFile: this.publishFile,
          modules: Ce
        }), this.getFileUrl = function (e) {
          return (0, L.default)(Ce, e);
        }, this.downloadFile = y.default.bind(this, Ce, K.default), this.deleteFile = y.default.bind(this, Ce, B.default), this.objects = {
          getAllUUIDMetadata: y.default.bind(this, Ce, G.default),
          getUUIDMetadata: y.default.bind(this, Ce, q.default),
          setUUIDMetadata: y.default.bind(this, Ce, H.default),
          removeUUIDMetadata: y.default.bind(this, Ce, z.default),
          getAllChannelMetadata: y.default.bind(this, Ce, W.default),
          getChannelMetadata: y.default.bind(this, Ce, V.default),
          setChannelMetadata: y.default.bind(this, Ce, Y.default),
          removeChannelMetadata: y.default.bind(this, Ce, J.default),
          getChannelMembers: y.default.bind(this, Ce, $.default),
          setChannelMembers: function setChannelMembers(e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              r[i - 1] = arguments[i];
            }
            return y.default.call.apply(y.default, [n, Ce, X.default, Ie({
              type: "set"
            }, e)].concat(r));
          },
          removeChannelMembers: function removeChannelMembers(e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              r[i - 1] = arguments[i];
            }
            return y.default.call.apply(y.default, [n, Ce, X.default, Ie({
              type: "delete"
            }, e)].concat(r));
          },
          getMemberships: y.default.bind(this, Ce, Q.default),
          setMemberships: function setMemberships(e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              r[i - 1] = arguments[i];
            }
            return y.default.call.apply(y.default, [n, Ce, Z.default, Ie({
              type: "set"
            }, e)].concat(r));
          },
          removeMemberships: function removeMemberships(e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              r[i - 1] = arguments[i];
            }
            return y.default.call.apply(y.default, [n, Ce, Z.default, Ie({
              type: "delete"
            }, e)].concat(r));
          }
        }, this.createUser = (0, g.deprecated)(y.default.bind(this, Ce, ee)), this.updateUser = (0, g.deprecated)(y.default.bind(this, Ce, te)), this.deleteUser = (0, g.deprecated)(y.default.bind(this, Ce, ne)), this.getUser = (0, g.deprecated)(y.default.bind(this, Ce, re)), this.getUsers = (0, g.deprecated)(y.default.bind(this, Ce, ie)), this.createSpace = (0, g.deprecated)(y.default.bind(this, Ce, oe)), this.updateSpace = (0, g.deprecated)(y.default.bind(this, Ce, ae)), this.deleteSpace = (0, g.deprecated)(y.default.bind(this, Ce, ue)), this.getSpaces = (0, g.deprecated)(y.default.bind(this, Ce, se)), this.getSpace = (0, g.deprecated)(y.default.bind(this, Ce, ce)), this.addMembers = (0, g.deprecated)(y.default.bind(this, Ce, fe)), this.updateMembers = (0, g.deprecated)(y.default.bind(this, Ce, de)), this.removeMembers = (0, g.deprecated)(y.default.bind(this, Ce, pe)), this.getMembers = (0, g.deprecated)(y.default.bind(this, Ce, le)), this.getMemberships = (0, g.deprecated)(y.default.bind(this, Ce, he)), this.joinSpaces = (0, g.deprecated)(y.default.bind(this, Ce, ge)), this.updateMemberships = (0, g.deprecated)(y.default.bind(this, Ce, ye)), this.leaveSpaces = (0, g.deprecated)(y.default.bind(this, Ce, ve)), this.time = Ue, this.subscribe = Ge.adaptSubscribeChange.bind(Ge), this.presence = Ge.adaptPresenceChange.bind(Ge), this.unsubscribe = Ge.adaptUnsubscribeChange.bind(Ge), this.disconnect = Ge.disconnect.bind(Ge), this.reconnect = Ge.reconnect.bind(Ge), this.destroy = function (e) {
          Ge.unsubscribeAll(e), Ge.disconnect();
        }, this.stop = this.destroy, this.unsubscribeAll = Ge.unsubscribeAll.bind(Ge), this.getSubscribedChannels = Ge.getSubscribedChannels.bind(Ge), this.getSubscribedChannelGroups = Ge.getSubscribedChannelGroups.bind(Ge), this.encrypt = Ee.encrypt.bind(Ee), this.decrypt = Ee.decrypt.bind(Ee), this.getAuthKey = Ce.config.getAuthKey.bind(Ce.config), this.setAuthKey = Ce.config.setAuthKey.bind(Ce.config), this.setCipherKey = Ce.config.setCipherKey.bind(Ce.config), this.getUUID = Ce.config.getUUID.bind(Ce.config), this.setUUID = Ce.config.setUUID.bind(Ce.config), this.getFilterExpression = Ce.config.getFilterExpression.bind(Ce.config), this.setFilterExpression = Ce.config.setFilterExpression.bind(Ce.config), this.setHeartbeatInterval = Ce.config.setHeartbeatInterval.bind(Ce.config), i.hasModule("proxy") && (this.setProxy = function (e) {
          Ce.config.setProxy(e), n.reconnect();
        });
      }
      return (0, a.default)(e, [{
        key: "getVersion",
        value: function value() {
          return this._config.getVersion();
        }
      }, {
        key: "_addPnsdkSuffix",
        value: function value(e, t) {
          this._config._addPnsdkSuffix(e, t);
        }
      }, {
        key: "networkDownDetected",
        value: function value() {
          this._listenerManager.announceNetworkDown(), this._config.restore ? this.disconnect() : this.destroy(!0);
        }
      }, {
        key: "networkUpDetected",
        value: function value() {
          this._listenerManager.announceNetworkUp(), this.reconnect();
        }
      }], [{
        key: "notificationPayload",
        value: function value(e, t) {
          return new d.default(e, t);
        }
      }, {
        key: "generateUUID",
        value: function value() {
          return Re.default.createUUID();
        }
      }]), e;
    }();
    t.default = De, (0, u.default)(De, "OPERATIONS", Ee.default), (0, u.default)(De, "CATEGORIES", je.default), e.exports = t.default;
  }, function (e, t, n) {
    var r, i, o; /*! lil-uuid - v0.1 - MIT License - https://github.com/lil-js/uuid */
    i = [t], void 0 === (o = "function" == typeof (r = function r(e) {
      var t = {
        3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
        4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
        5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
        all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
      };
      function n() {
        var e,
          t,
          n = "";
        for (e = 0; e < 32; e++) {
          t = 16 * Math.random() | 0, 8 !== e && 12 !== e && 16 !== e && 20 !== e || (n += "-"), n += (12 === e ? 4 : 16 === e ? 3 & t | 8 : t).toString(16);
        }
        return n;
      }
      function r(e, n) {
        var r = t[n || "all"];
        return r && r.test(e) || !1;
      }
      n.isUUID = r, n.VERSION = "0.1.0", e.uuid = n, e.isUUID = r;
    }) ? r.apply(t, i) : r) || (e.exports = o);
  }, function (e, t) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    t.byteLength = function (e) {
      var t = c(e),
        n = t[0],
        r = t[1];
      return 3 * (n + r) / 4 - r;
    }, t.toByteArray = function (e) {
      var t,
        n,
        r = c(e),
        a = r[0],
        u = r[1],
        s = new o(function (e, t, n) {
          return 3 * (t + n) / 4 - n;
        }(0, a, u)),
        l = 0,
        f = u > 0 ? a - 4 : a;
      for (n = 0; n < f; n += 4) {
        t = i[e.charCodeAt(n)] << 18 | i[e.charCodeAt(n + 1)] << 12 | i[e.charCodeAt(n + 2)] << 6 | i[e.charCodeAt(n + 3)], s[l++] = t >> 16 & 255, s[l++] = t >> 8 & 255, s[l++] = 255 & t;
      }
      2 === u && (t = i[e.charCodeAt(n)] << 2 | i[e.charCodeAt(n + 1)] >> 4, s[l++] = 255 & t);
      1 === u && (t = i[e.charCodeAt(n)] << 10 | i[e.charCodeAt(n + 1)] << 4 | i[e.charCodeAt(n + 2)] >> 2, s[l++] = t >> 8 & 255, s[l++] = 255 & t);
      return s;
    }, t.fromByteArray = function (e) {
      for (var t, n = e.length, i = n % 3, o = [], a = 0, u = n - i; a < u; a += 16383) {
        o.push(l(e, a, a + 16383 > u ? u : a + 16383));
      }
      1 === i ? (t = e[n - 1], o.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === i && (t = (e[n - 2] << 8) + e[n - 1], o.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));
      return o.join("");
    };
    for (var r = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", u = 0, s = a.length; u < s; ++u) {
      r[u] = a[u], i[a.charCodeAt(u)] = u;
    }
    function c(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var n = e.indexOf("=");
      return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
    }
    function l(e, t, n) {
      for (var i, o, a = [], u = t; u < n; u += 3) {
        i = (e[u] << 16 & 16711680) + (e[u + 1] << 8 & 65280) + (255 & e[u + 2]), a.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
      }
      return a.join("");
    }
    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (e, t) {
    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
    t.read = function (e, t, n, r, i) {
      var o,
        a,
        u = 8 * i - r - 1,
        s = (1 << u) - 1,
        c = s >> 1,
        l = -7,
        f = n ? i - 1 : 0,
        d = n ? -1 : 1,
        p = e[t + f];
      for (f += d, o = p & (1 << -l) - 1, p >>= -l, l += u; l > 0; o = 256 * o + e[t + f], f += d, l -= 8) {
        ;
      }
      for (a = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; a = 256 * a + e[t + f], f += d, l -= 8) {
        ;
      }
      if (0 === o) o = 1 - c;else {
        if (o === s) return a ? NaN : 1 / 0 * (p ? -1 : 1);
        a += Math.pow(2, r), o -= c;
      }
      return (p ? -1 : 1) * a * Math.pow(2, o - r);
    }, t.write = function (e, t, n, r, i, o) {
      var a,
        u,
        s,
        c = 8 * o - i - 1,
        l = (1 << c) - 1,
        f = l >> 1,
        d = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        p = r ? 0 : o - 1,
        h = r ? 1 : -1,
        y = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (u = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (s = Math.pow(2, -a)) < 1 && (a--, s *= 2), (t += a + f >= 1 ? d / s : d * Math.pow(2, 1 - f)) * s >= 2 && (a++, s /= 2), a + f >= l ? (u = 0, a = l) : a + f >= 1 ? (u = (t * s - 1) * Math.pow(2, i), a += f) : (u = t * Math.pow(2, f - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + p] = 255 & u, p += h, u /= 256, i -= 8) {
        ;
      }
      for (a = a << i | u, c += i; c > 0; e[n + p] = 255 & a, p += h, a /= 256, c -= 8) {
        ;
      }
      e[n + p - h] |= 128 * y;
    };
  }, function (e, t) {
    var n = {}.toString;
    e.exports = Array.isArray || function (e) {
      return "[object Array]" == n.call(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(7)),
      o = r(n(5)),
      a = r(n(6)),
      u = r(n(4)),
      s = (r(n(23)), r(n(8)), r(n(26)), r(n(40))),
      c = r(n(41)),
      l = r(n(3)),
      f = (n(2), r(n(10))),
      d = function () {
        function e(t) {
          var n = t.subscribeEndpoint,
            r = t.leaveEndpoint,
            i = t.heartbeatEndpoint,
            a = t.setStateEndpoint,
            l = t.timeEndpoint,
            f = t.getFileUrl,
            d = t.config,
            p = t.crypto,
            h = t.listenerManager;
          (0, o.default)(this, e), (0, u.default)(this, "_crypto", void 0), (0, u.default)(this, "_config", void 0), (0, u.default)(this, "_listenerManager", void 0), (0, u.default)(this, "_reconnectionManager", void 0), (0, u.default)(this, "_leaveEndpoint", void 0), (0, u.default)(this, "_heartbeatEndpoint", void 0), (0, u.default)(this, "_setStateEndpoint", void 0), (0, u.default)(this, "_subscribeEndpoint", void 0), (0, u.default)(this, "_getFileUrl", void 0), (0, u.default)(this, "_channels", void 0), (0, u.default)(this, "_presenceChannels", void 0), (0, u.default)(this, "_heartbeatChannels", void 0), (0, u.default)(this, "_heartbeatChannelGroups", void 0), (0, u.default)(this, "_channelGroups", void 0), (0, u.default)(this, "_presenceChannelGroups", void 0), (0, u.default)(this, "_currentTimetoken", void 0), (0, u.default)(this, "_lastTimetoken", void 0), (0, u.default)(this, "_storedTimetoken", void 0), (0, u.default)(this, "_region", void 0), (0, u.default)(this, "_subscribeCall", void 0), (0, u.default)(this, "_heartbeatTimer", void 0), (0, u.default)(this, "_subscriptionStatusAnnounced", void 0), (0, u.default)(this, "_autoNetworkDetection", void 0), (0, u.default)(this, "_isOnline", void 0), (0, u.default)(this, "_pendingChannelSubscriptions", void 0), (0, u.default)(this, "_pendingChannelGroupSubscriptions", void 0), (0, u.default)(this, "_dedupingManager", void 0), this._listenerManager = h, this._config = d, this._leaveEndpoint = r, this._heartbeatEndpoint = i, this._setStateEndpoint = a, this._subscribeEndpoint = n, this._getFileUrl = f, this._crypto = p, this._channels = {}, this._presenceChannels = {}, this._heartbeatChannels = {}, this._heartbeatChannelGroups = {}, this._channelGroups = {}, this._presenceChannelGroups = {}, this._pendingChannelSubscriptions = [], this._pendingChannelGroupSubscriptions = [], this._currentTimetoken = 0, this._lastTimetoken = 0, this._storedTimetoken = null, this._subscriptionStatusAnnounced = !1, this._isOnline = !0, this._reconnectionManager = new s.default({
            timeEndpoint: l
          }), this._dedupingManager = new c.default({
            config: d
          });
        }
        return (0, a.default)(e, [{
          key: "adaptStateChange",
          value: function value(e, t) {
            var n = this,
              r = e.state,
              i = e.channels,
              o = void 0 === i ? [] : i,
              a = e.channelGroups,
              u = void 0 === a ? [] : a;
            return o.forEach(function (e) {
              e in n._channels && (n._channels[e].state = r);
            }), u.forEach(function (e) {
              e in n._channelGroups && (n._channelGroups[e].state = r);
            }), this._setStateEndpoint({
              state: r,
              channels: o,
              channelGroups: u
            }, t);
          }
        }, {
          key: "adaptPresenceChange",
          value: function value(e) {
            var t = this,
              n = e.connected,
              r = e.channels,
              i = void 0 === r ? [] : r,
              o = e.channelGroups,
              a = void 0 === o ? [] : o;
            n ? (i.forEach(function (e) {
              t._heartbeatChannels[e] = {
                state: {}
              };
            }), a.forEach(function (e) {
              t._heartbeatChannelGroups[e] = {
                state: {}
              };
            })) : (i.forEach(function (e) {
              e in t._heartbeatChannels && delete t._heartbeatChannels[e];
            }), a.forEach(function (e) {
              e in t._heartbeatChannelGroups && delete t._heartbeatChannelGroups[e];
            }), !1 === this._config.suppressLeaveEvents && this._leaveEndpoint({
              channels: i,
              channelGroups: a
            }, function (e) {
              t._listenerManager.announceStatus(e);
            })), this.reconnect();
          }
        }, {
          key: "adaptSubscribeChange",
          value: function value(e) {
            var t = this,
              n = e.timetoken,
              r = e.channels,
              i = void 0 === r ? [] : r,
              o = e.channelGroups,
              a = void 0 === o ? [] : o,
              u = e.withPresence,
              s = void 0 !== u && u,
              c = e.withHeartbeats,
              l = void 0 !== c && c;
            this._config.subscribeKey && "" !== this._config.subscribeKey ? (n && (this._lastTimetoken = this._currentTimetoken, this._currentTimetoken = n), "0" !== this._currentTimetoken && 0 !== this._currentTimetoken && (this._storedTimetoken = this._currentTimetoken, this._currentTimetoken = 0), i.forEach(function (e) {
              t._channels[e] = {
                state: {}
              }, s && (t._presenceChannels[e] = {}), (l || t._config.getHeartbeatInterval()) && (t._heartbeatChannels[e] = {}), t._pendingChannelSubscriptions.push(e);
            }), a.forEach(function (e) {
              t._channelGroups[e] = {
                state: {}
              }, s && (t._presenceChannelGroups[e] = {}), (l || t._config.getHeartbeatInterval()) && (t._heartbeatChannelGroups[e] = {}), t._pendingChannelGroupSubscriptions.push(e);
            }), this._subscriptionStatusAnnounced = !1, this.reconnect()) : console && console.log && console.log("subscribe key missing; aborting subscribe");
          }
        }, {
          key: "adaptUnsubscribeChange",
          value: function value(e, t) {
            var n = this,
              r = e.channels,
              i = void 0 === r ? [] : r,
              o = e.channelGroups,
              a = void 0 === o ? [] : o,
              u = [],
              s = [];
            i.forEach(function (e) {
              e in n._channels && (delete n._channels[e], u.push(e), e in n._heartbeatChannels && delete n._heartbeatChannels[e]), e in n._presenceChannels && (delete n._presenceChannels[e], u.push(e));
            }), a.forEach(function (e) {
              e in n._channelGroups && (delete n._channelGroups[e], s.push(e), e in n._heartbeatChannelGroups && delete n._heartbeatChannelGroups[e]), e in n._presenceChannelGroups && (delete n._channelGroups[e], s.push(e));
            }), 0 === u.length && 0 === s.length || (!1 !== this._config.suppressLeaveEvents || t || this._leaveEndpoint({
              channels: u,
              channelGroups: s
            }, function (e) {
              e.affectedChannels = u, e.affectedChannelGroups = s, e.currentTimetoken = n._currentTimetoken, e.lastTimetoken = n._lastTimetoken, n._listenerManager.announceStatus(e);
            }), 0 === Object.keys(this._channels).length && 0 === Object.keys(this._presenceChannels).length && 0 === Object.keys(this._channelGroups).length && 0 === Object.keys(this._presenceChannelGroups).length && (this._lastTimetoken = 0, this._currentTimetoken = 0, this._storedTimetoken = null, this._region = null, this._reconnectionManager.stopPolling()), this.reconnect());
          }
        }, {
          key: "unsubscribeAll",
          value: function value(e) {
            this.adaptUnsubscribeChange({
              channels: this.getSubscribedChannels(),
              channelGroups: this.getSubscribedChannelGroups()
            }, e);
          }
        }, {
          key: "getHeartbeatChannels",
          value: function value() {
            return Object.keys(this._heartbeatChannels);
          }
        }, {
          key: "getHeartbeatChannelGroups",
          value: function value() {
            return Object.keys(this._heartbeatChannelGroups);
          }
        }, {
          key: "getSubscribedChannels",
          value: function value() {
            return Object.keys(this._channels);
          }
        }, {
          key: "getSubscribedChannelGroups",
          value: function value() {
            return Object.keys(this._channelGroups);
          }
        }, {
          key: "reconnect",
          value: function value() {
            this._startSubscribeLoop(), this._registerHeartbeatTimer();
          }
        }, {
          key: "disconnect",
          value: function value() {
            this._stopSubscribeLoop(), this._stopHeartbeatTimer(), this._reconnectionManager.stopPolling();
          }
        }, {
          key: "_registerHeartbeatTimer",
          value: function value() {
            this._stopHeartbeatTimer(), 0 !== this._config.getHeartbeatInterval() && void 0 !== this._config.getHeartbeatInterval() && (this._performHeartbeatLoop(), this._heartbeatTimer = setInterval(this._performHeartbeatLoop.bind(this), 1e3 * this._config.getHeartbeatInterval()));
          }
        }, {
          key: "_stopHeartbeatTimer",
          value: function value() {
            this._heartbeatTimer && (clearInterval(this._heartbeatTimer), this._heartbeatTimer = null);
          }
        }, {
          key: "_performHeartbeatLoop",
          value: function value() {
            var e = this,
              t = this.getHeartbeatChannels(),
              n = this.getHeartbeatChannelGroups(),
              r = {};
            if (0 !== t.length || 0 !== n.length) {
              this.getSubscribedChannels().forEach(function (t) {
                var n = e._channels[t].state;
                Object.keys(n).length && (r[t] = n);
              }), this.getSubscribedChannelGroups().forEach(function (t) {
                var n = e._channelGroups[t].state;
                Object.keys(n).length && (r[t] = n);
              });
              this._heartbeatEndpoint({
                channels: t,
                channelGroups: n,
                state: r
              }, function (t) {
                t.error && e._config.announceFailedHeartbeats && e._listenerManager.announceStatus(t), t.error && e._config.autoNetworkDetection && e._isOnline && (e._isOnline = !1, e.disconnect(), e._listenerManager.announceNetworkDown(), e.reconnect()), !t.error && e._config.announceSuccessfulHeartbeats && e._listenerManager.announceStatus(t);
              }.bind(this));
            }
          }
        }, {
          key: "_startSubscribeLoop",
          value: function value() {
            var e = this;
            this._stopSubscribeLoop();
            var t = {},
              n = [],
              r = [];
            if (Object.keys(this._channels).forEach(function (r) {
              var i = e._channels[r].state;
              Object.keys(i).length && (t[r] = i), n.push(r);
            }), Object.keys(this._presenceChannels).forEach(function (e) {
              n.push("".concat(e, "-pnpres"));
            }), Object.keys(this._channelGroups).forEach(function (n) {
              var i = e._channelGroups[n].state;
              Object.keys(i).length && (t[n] = i), r.push(n);
            }), Object.keys(this._presenceChannelGroups).forEach(function (e) {
              r.push("".concat(e, "-pnpres"));
            }), 0 !== n.length || 0 !== r.length) {
              var i = {
                channels: n,
                channelGroups: r,
                state: t,
                timetoken: this._currentTimetoken,
                filterExpression: this._config.filterExpression,
                region: this._region
              };
              this._subscribeCall = this._subscribeEndpoint(i, this._processSubscribeResponse.bind(this));
            }
          }
        }, {
          key: "_processSubscribeResponse",
          value: function value(e, t) {
            var n = this;
            if (e.error) e.category === f.default.PNTimeoutCategory ? this._startSubscribeLoop() : e.category === f.default.PNNetworkIssuesCategory ? (this.disconnect(), e.error && this._config.autoNetworkDetection && this._isOnline && (this._isOnline = !1, this._listenerManager.announceNetworkDown()), this._reconnectionManager.onReconnection(function () {
              n._config.autoNetworkDetection && !n._isOnline && (n._isOnline = !0, n._listenerManager.announceNetworkUp()), n.reconnect(), n._subscriptionStatusAnnounced = !0;
              var t = {
                category: f.default.PNReconnectedCategory,
                operation: e.operation,
                lastTimetoken: n._lastTimetoken,
                currentTimetoken: n._currentTimetoken
              };
              n._listenerManager.announceStatus(t);
            }), this._reconnectionManager.startPolling(), this._listenerManager.announceStatus(e)) : e.category === f.default.PNBadRequestCategory ? (this._stopHeartbeatTimer(), this._listenerManager.announceStatus(e)) : this._listenerManager.announceStatus(e);else {
              if (this._storedTimetoken ? (this._currentTimetoken = this._storedTimetoken, this._storedTimetoken = null) : (this._lastTimetoken = this._currentTimetoken, this._currentTimetoken = t.metadata.timetoken), !this._subscriptionStatusAnnounced) {
                var r = {};
                r.category = f.default.PNConnectedCategory, r.operation = e.operation, r.affectedChannels = this._pendingChannelSubscriptions, r.subscribedChannels = this.getSubscribedChannels(), r.affectedChannelGroups = this._pendingChannelGroupSubscriptions, r.lastTimetoken = this._lastTimetoken, r.currentTimetoken = this._currentTimetoken, this._subscriptionStatusAnnounced = !0, this._listenerManager.announceStatus(r), this._pendingChannelSubscriptions = [], this._pendingChannelGroupSubscriptions = [];
              }
              var o = t.messages || [],
                a = this._config,
                u = a.requestMessageCountThreshold,
                s = a.dedupeOnSubscribe;
              if (u && o.length >= u) {
                var c = {};
                c.category = f.default.PNRequestMessageCountExceededCategory, c.operation = e.operation, this._listenerManager.announceStatus(c);
              }
              o.forEach(function (e) {
                var t = e.channel,
                  r = e.subscriptionMatch,
                  o = e.publishMetaData;
                if (t === r && (r = null), s) {
                  if (n._dedupingManager.isDuplicate(e)) return;
                  n._dedupingManager.addEntry(e);
                }
                if (l.default.endsWith(e.channel, "-pnpres")) {
                  var a = {
                    channel: null,
                    subscription: null
                  };
                  a.actualChannel = null != r ? t : null, a.subscribedChannel = null != r ? r : t, t && (a.channel = t.substring(0, t.lastIndexOf("-pnpres"))), r && (a.subscription = r.substring(0, r.lastIndexOf("-pnpres"))), a.action = e.payload.action, a.state = e.payload.data, a.timetoken = o.publishTimetoken, a.occupancy = e.payload.occupancy, a.uuid = e.payload.uuid, a.timestamp = e.payload.timestamp, e.payload.join && (a.join = e.payload.join), e.payload.leave && (a.leave = e.payload.leave), e.payload.timeout && (a.timeout = e.payload.timeout), n._listenerManager.announcePresence(a);
                } else if (1 === e.messageType) {
                  var u = {
                    channel: null,
                    subscription: null
                  };
                  u.channel = t, u.subscription = r, u.timetoken = o.publishTimetoken, u.publisher = e.issuingClientId, e.userMetadata && (u.userMetadata = e.userMetadata), u.message = e.payload, n._listenerManager.announceSignal(u);
                } else if (2 === e.messageType) {
                  var c = {
                    channel: null,
                    subscription: null
                  };
                  c.channel = t, c.subscription = r, c.timetoken = o.publishTimetoken, c.publisher = e.issuingClientId, e.userMetadata && (c.userMetadata = e.userMetadata), c.message = {
                    event: e.payload.event,
                    type: e.payload.type,
                    data: e.payload.data
                  }, n._listenerManager.announceObjects(c), "user" === e.payload.type ? n._listenerManager.announceUser(c) : "space" === e.payload.type ? n._listenerManager.announceSpace(c) : "membership" === e.payload.type && n._listenerManager.announceMembership(c);
                } else if (3 === e.messageType) {
                  var f = {};
                  f.channel = t, f.subscription = r, f.timetoken = o.publishTimetoken, f.publisher = e.issuingClientId, f.data = {
                    messageTimetoken: e.payload.data.messageTimetoken,
                    actionTimetoken: e.payload.data.actionTimetoken,
                    type: e.payload.data.type,
                    uuid: e.issuingClientId,
                    value: e.payload.data.value
                  }, f.event = e.payload.event, n._listenerManager.announceMessageAction(f);
                } else if (4 === e.messageType) {
                  var d = {};
                  d.channel = t, d.subscription = r, d.timetoken = o.publishTimetoken, d.publisher = e.issuingClientId;
                  var p = e.payload;
                  if (n._config.cipherKey) {
                    var h = n._crypto.decrypt(e.payload);
                    "object" === (0, i.default)(h) && null !== h && (p = h);
                  }
                  e.userMetadata && (d.userMetadata = e.userMetadata), d.message = p.message, d.file = {
                    id: p.file.id,
                    name: p.file.name,
                    url: n._getFileUrl({
                      id: p.file.id,
                      name: p.file.name,
                      channel: t
                    })
                  }, n._listenerManager.announceFile(d);
                } else {
                  var y = {
                    channel: null,
                    subscription: null
                  };
                  y.actualChannel = null != r ? t : null, y.subscribedChannel = null != r ? r : t, y.channel = t, y.subscription = r, y.timetoken = o.publishTimetoken, y.publisher = e.issuingClientId, e.userMetadata && (y.userMetadata = e.userMetadata), n._config.cipherKey ? y.message = n._crypto.decrypt(e.payload) : y.message = e.payload, n._listenerManager.announceMessage(y);
                }
              }), this._region = t.metadata.region, this._startSubscribeLoop();
            }
          }
        }, {
          key: "_stopSubscribeLoop",
          value: function value() {
            this._subscribeCall && ("function" == typeof this._subscribeCall.abort && this._subscribeCall.abort(), this._subscribeCall = null);
          }
        }]), e;
      }();
    t.default = d, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(6)),
      a = r(n(4)),
      u = (r(n(27)), n(2), function () {
        function e(t) {
          var n = t.timeEndpoint;
          (0, i.default)(this, e), (0, a.default)(this, "_reconnectionCallback", void 0), (0, a.default)(this, "_timeEndpoint", void 0), (0, a.default)(this, "_timeTimer", void 0), this._timeEndpoint = n;
        }
        return (0, o.default)(e, [{
          key: "onReconnection",
          value: function value(e) {
            this._reconnectionCallback = e;
          }
        }, {
          key: "startPolling",
          value: function value() {
            this._timeTimer = setInterval(this._performTimeLoop.bind(this), 3e3);
          }
        }, {
          key: "stopPolling",
          value: function value() {
            clearInterval(this._timeTimer);
          }
        }, {
          key: "_performTimeLoop",
          value: function value() {
            var e = this;
            this._timeEndpoint(function (t) {
              t.error || (clearInterval(e._timeTimer), e._reconnectionCallback());
            });
          }
        }]), e;
      }());
    t.default = u, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(6)),
      a = r(n(4)),
      u = (r(n(8)), n(2), function () {
        function e(t) {
          var n = t.config;
          (0, i.default)(this, e), (0, a.default)(this, "_config", void 0), (0, a.default)(this, "hashHistory", void 0), this.hashHistory = [], this._config = n;
        }
        return (0, o.default)(e, [{
          key: "getKey",
          value: function value(e) {
            var t = function (e) {
                var t = 0;
                if (0 === e.length) return t;
                for (var n = 0; n < e.length; n += 1) {
                  t = (t << 5) - t + e.charCodeAt(n), t &= t;
                }
                return t;
              }(JSON.stringify(e.payload)).toString(),
              n = e.publishMetaData.publishTimetoken;
            return "".concat(n, "-").concat(t);
          }
        }, {
          key: "isDuplicate",
          value: function value(e) {
            return this.hashHistory.includes(this.getKey(e));
          }
        }, {
          key: "addEntry",
          value: function value(e) {
            this.hashHistory.length >= this._config.maximumCacheSize && this.hashHistory.shift(), this.hashHistory.push(this.getKey(e));
          }
        }, {
          key: "clearHistory",
          value: function value() {
            this.hashHistory = [];
          }
        }]), e;
      }());
    t.default = u, e.exports = t.default;
  }, function (e, t) {
    var n,
      r,
      i = e.exports = {};
    function o() {
      throw new Error("setTimeout has not been defined");
    }
    function a() {
      throw new Error("clearTimeout has not been defined");
    }
    function u(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }
    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        n = o;
      }
      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        r = a;
      }
    }();
    var s,
      c = [],
      l = !1,
      f = -1;
    function d() {
      l && s && (l = !1, s.length ? c = s.concat(c) : f = -1, c.length && p());
    }
    function p() {
      if (!l) {
        var e = u(d);
        l = !0;
        for (var t = c.length; t;) {
          for (s = c, c = []; ++f < t;) {
            s && s[f].run();
          }
          f = -1, t = c.length;
        }
        s = null, l = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }
    function h(e, t) {
      this.fun = e, this.array = t;
    }
    function y() {}
    i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      c.push(new h(e, t)), 1 !== c.length || l || u(p);
    }, h.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = y, i.addListener = y, i.once = y, i.off = y, i.removeListener = y, i.removeAllListeners = y, i.emit = y, i.prependListener = y, i.prependOnceListener = y, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(6)),
      a = r(n(4)),
      u = r(n(1)),
      s = function () {
        function e(t) {
          (0, i.default)(this, e), (0, a.default)(this, "_maximumSamplesCount", 100), (0, a.default)(this, "_trackedLatencies", {}), (0, a.default)(this, "_latencies", {}), this._maximumSamplesCount = t.maximumSamplesCount || this._maximumSamplesCount;
        }
        return (0, o.default)(e, [{
          key: "operationsLatencyForRequest",
          value: function value() {
            var e = this,
              t = {};
            return Object.keys(this._latencies).forEach(function (n) {
              var r = e._latencies[n],
                i = e._averageLatency(r);
              i > 0 && (t["l_".concat(n)] = i);
            }), t;
          }
        }, {
          key: "startLatencyMeasure",
          value: function value(e, t) {
            e !== u.default.PNSubscribeOperation && t && (this._trackedLatencies[t] = Date.now());
          }
        }, {
          key: "stopLatencyMeasure",
          value: function value(e, t) {
            if (e !== u.default.PNSubscribeOperation && t) {
              var n = this._endpointName(e),
                r = this._latencies[n],
                i = this._trackedLatencies[t];
              r || (r = this._latencies[n] = []), r.push(Date.now() - i), r.length > this._maximumSamplesCount && r.splice(0, r.length - this._maximumSamplesCount), delete this._trackedLatencies[t];
            }
          }
        }, {
          key: "_averageLatency",
          value: function value(e) {
            return Math.floor(e.reduce(function (e, t) {
              return e + t;
            }, 0) / e.length);
          }
        }, {
          key: "_endpointName",
          value: function value(e) {
            var t = null;
            switch (e) {
              case u.default.PNPublishOperation:
                t = "pub";
                break;
              case u.default.PNSignalOperation:
                t = "sig";
                break;
              case u.default.PNHistoryOperation:
              case u.default.PNFetchMessagesOperation:
              case u.default.PNDeleteMessagesOperation:
              case u.default.PNMessageCounts:
                t = "hist";
                break;
              case u.default.PNUnsubscribeOperation:
              case u.default.PNWhereNowOperation:
              case u.default.PNHereNowOperation:
              case u.default.PNHeartbeatOperation:
              case u.default.PNSetStateOperation:
              case u.default.PNGetStateOperation:
                t = "pres";
                break;
              case u.default.PNAddChannelsToGroupOperation:
              case u.default.PNRemoveChannelsFromGroupOperation:
              case u.default.PNChannelGroupsOperation:
              case u.default.PNRemoveGroupOperation:
              case u.default.PNChannelsForGroupOperation:
                t = "cg";
                break;
              case u.default.PNPushNotificationEnabledChannelsOperation:
              case u.default.PNRemoveAllPushNotificationsOperation:
                t = "push";
                break;
              case u.default.PNCreateUserOperation:
              case u.default.PNUpdateUserOperation:
              case u.default.PNDeleteUserOperation:
              case u.default.PNGetUserOperation:
              case u.default.PNGetUsersOperation:
              case u.default.PNCreateSpaceOperation:
              case u.default.PNUpdateSpaceOperation:
              case u.default.PNDeleteSpaceOperation:
              case u.default.PNGetSpaceOperation:
              case u.default.PNGetSpacesOperation:
              case u.default.PNGetMembersOperation:
              case u.default.PNUpdateMembersOperation:
              case u.default.PNGetMembershipsOperation:
              case u.default.PNUpdateMembershipsOperation:
                t = "obj";
                break;
              case u.default.PNAddMessageActionOperation:
              case u.default.PNRemoveMessageActionOperation:
              case u.default.PNGetMessageActionsOperation:
                t = "msga";
                break;
              case u.default.PNAccessManagerGrant:
              case u.default.PNAccessManagerAudit:
                t = "pam";
                break;
              case u.default.PNAccessManagerGrantToken:
              case u.default.PNAccessManagerRevokeToken:
                t = "pamv3";
                break;
              default:
                t = "time";
            }
            return t;
          }
        }]), e;
      }();
    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.MPNSNotificationPayload = t.FCMNotificationPayload = t.APNSNotificationPayload = void 0;
    var i = r(n(45)),
      o = r(n(22)),
      a = r(n(14)),
      u = r(n(16)),
      s = r(n(13)),
      c = r(n(5)),
      l = r(n(6)),
      f = r(n(4)),
      d = (n(2), ["notification", "data"]);
    function p(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function h(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? p(Object(n), !0).forEach(function (t) {
          (0, f.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function y(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var n,
          r = (0, s.default)(e);
        if (t) {
          var i = (0, s.default)(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);
        return (0, u.default)(this, n);
      };
    }
    var g = function () {
        function e(t, n, r) {
          (0, c.default)(this, e), (0, f.default)(this, "_subtitle", void 0), (0, f.default)(this, "_payload", void 0), (0, f.default)(this, "_badge", void 0), (0, f.default)(this, "_sound", void 0), (0, f.default)(this, "_title", void 0), (0, f.default)(this, "_body", void 0), this._payload = t, this._setDefaultPayloadStructure(), this.title = n, this.body = r;
        }
        return (0, l.default)(e, [{
          key: "payload",
          get: function get() {
            return this._payload;
          }
        }, {
          key: "title",
          set: function set(e) {
            this._title = e;
          }
        }, {
          key: "subtitle",
          set: function set(e) {
            this._subtitle = e;
          }
        }, {
          key: "body",
          set: function set(e) {
            this._body = e;
          }
        }, {
          key: "badge",
          set: function set(e) {
            this._badge = e;
          }
        }, {
          key: "sound",
          set: function set(e) {
            this._sound = e;
          }
        }, {
          key: "_setDefaultPayloadStructure",
          value: function value() {}
        }, {
          key: "toObject",
          value: function value() {
            return {};
          }
        }]), e;
      }(),
      v = function (e) {
        (0, a.default)(n, e);
        var t = y(n);
        function n() {
          var e;
          (0, c.default)(this, n);
          for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
            i[a] = arguments[a];
          }
          return e = t.call.apply(t, [this].concat(i)), (0, f.default)((0, o.default)(e), "_configurations", void 0), (0, f.default)((0, o.default)(e), "_apnsPushType", void 0), (0, f.default)((0, o.default)(e), "_isSilent", void 0), e;
        }
        return (0, l.default)(n, [{
          key: "configurations",
          set: function set(e) {
            e && e.length && (this._configurations = e);
          }
        }, {
          key: "notification",
          get: function get() {
            return this._payload.aps;
          }
        }, {
          key: "title",
          get: function get() {
            return this._title;
          },
          set: function set(e) {
            e && e.length && (this._payload.aps.alert.title = e, this._title = e);
          }
        }, {
          key: "subtitle",
          get: function get() {
            return this._subtitle;
          },
          set: function set(e) {
            e && e.length && (this._payload.aps.alert.subtitle = e, this._subtitle = e);
          }
        }, {
          key: "body",
          get: function get() {
            return this._body;
          },
          set: function set(e) {
            e && e.length && (this._payload.aps.alert.body = e, this._body = e);
          }
        }, {
          key: "badge",
          get: function get() {
            return this._badge;
          },
          set: function set(e) {
            null != e && (this._payload.aps.badge = e, this._badge = e);
          }
        }, {
          key: "sound",
          get: function get() {
            return this._sound;
          },
          set: function set(e) {
            e && e.length && (this._payload.aps.sound = e, this._sound = e);
          }
        }, {
          key: "silent",
          set: function set(e) {
            this._isSilent = e;
          }
        }, {
          key: "_setDefaultPayloadStructure",
          value: function value() {
            this._payload.aps = {
              alert: {}
            };
          }
        }, {
          key: "toObject",
          value: function value() {
            var e = this,
              t = h({}, this._payload),
              n = t.aps,
              r = n.alert;
            if (this._isSilent && (n["content-available"] = 1), "apns2" === this._apnsPushType) {
              if (!this._configurations || !this._configurations.length) throw new ReferenceError("APNS2 configuration is missing");
              var i = [];
              this._configurations.forEach(function (t) {
                i.push(e._objectFromAPNS2Configuration(t));
              }), i.length && (t.pn_push = i);
            }
            return r && Object.keys(r).length || delete n.alert, this._isSilent && (delete n.alert, delete n.badge, delete n.sound, r = {}), this._isSilent || Object.keys(r).length ? t : null;
          }
        }, {
          key: "_objectFromAPNS2Configuration",
          value: function value(e) {
            var t = this;
            if (!e.targets || !e.targets.length) throw new ReferenceError("At least one APNS2 target should be provided");
            var n = [];
            e.targets.forEach(function (e) {
              n.push(t._objectFromAPNSTarget(e));
            });
            var r = e.collapseId,
              i = e.expirationDate,
              o = {
                auth_method: "token",
                targets: n,
                version: "v2"
              };
            return r && r.length && (o.collapse_id = r), i && (o.expiration = i.toISOString()), o;
          }
        }, {
          key: "_objectFromAPNSTarget",
          value: function value(e) {
            if (!e.topic || !e.topic.length) throw new TypeError("Target 'topic' undefined.");
            var t = e.topic,
              n = e.environment,
              r = void 0 === n ? "development" : n,
              i = e.excludedDevices,
              o = void 0 === i ? [] : i,
              a = {
                topic: t,
                environment: r
              };
            return o.length && (a.excluded_devices = o), a;
          }
        }]), n;
      }(g);
    t.APNSNotificationPayload = v;
    var b = function (e) {
      (0, a.default)(n, e);
      var t = y(n);
      function n() {
        var e;
        (0, c.default)(this, n);
        for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
          i[a] = arguments[a];
        }
        return e = t.call.apply(t, [this].concat(i)), (0, f.default)((0, o.default)(e), "_backContent", void 0), (0, f.default)((0, o.default)(e), "_backTitle", void 0), (0, f.default)((0, o.default)(e), "_count", void 0), (0, f.default)((0, o.default)(e), "_type", void 0), e;
      }
      return (0, l.default)(n, [{
        key: "backContent",
        get: function get() {
          return this._backContent;
        },
        set: function set(e) {
          e && e.length && (this._payload.back_content = e, this._backContent = e);
        }
      }, {
        key: "backTitle",
        get: function get() {
          return this._backTitle;
        },
        set: function set(e) {
          e && e.length && (this._payload.back_title = e, this._backTitle = e);
        }
      }, {
        key: "count",
        get: function get() {
          return this._count;
        },
        set: function set(e) {
          null != e && (this._payload.count = e, this._count = e);
        }
      }, {
        key: "title",
        get: function get() {
          return this._title;
        },
        set: function set(e) {
          e && e.length && (this._payload.title = e, this._title = e);
        }
      }, {
        key: "type",
        get: function get() {
          return this._type;
        },
        set: function set(e) {
          e && e.length && (this._payload.type = e, this._type = e);
        }
      }, {
        key: "subtitle",
        get: function get() {
          return this.backTitle;
        },
        set: function set(e) {
          this.backTitle = e;
        }
      }, {
        key: "body",
        get: function get() {
          return this.backContent;
        },
        set: function set(e) {
          this.backContent = e;
        }
      }, {
        key: "badge",
        get: function get() {
          return this.count;
        },
        set: function set(e) {
          this.count = e;
        }
      }, {
        key: "toObject",
        value: function value() {
          return Object.keys(this._payload).length ? h({}, this._payload) : null;
        }
      }]), n;
    }(g);
    t.MPNSNotificationPayload = b;
    var m = function (e) {
      (0, a.default)(n, e);
      var t = y(n);
      function n() {
        var e;
        (0, c.default)(this, n);
        for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
          i[a] = arguments[a];
        }
        return e = t.call.apply(t, [this].concat(i)), (0, f.default)((0, o.default)(e), "_isSilent", void 0), (0, f.default)((0, o.default)(e), "_icon", void 0), (0, f.default)((0, o.default)(e), "_tag", void 0), e;
      }
      return (0, l.default)(n, [{
        key: "notification",
        get: function get() {
          return this._payload.notification;
        }
      }, {
        key: "data",
        get: function get() {
          return this._payload.data;
        }
      }, {
        key: "title",
        get: function get() {
          return this._title;
        },
        set: function set(e) {
          e && e.length && (this._payload.notification.title = e, this._title = e);
        }
      }, {
        key: "body",
        get: function get() {
          return this._body;
        },
        set: function set(e) {
          e && e.length && (this._payload.notification.body = e, this._body = e);
        }
      }, {
        key: "sound",
        get: function get() {
          return this._sound;
        },
        set: function set(e) {
          e && e.length && (this._payload.notification.sound = e, this._sound = e);
        }
      }, {
        key: "icon",
        get: function get() {
          return this._icon;
        },
        set: function set(e) {
          e && e.length && (this._payload.notification.icon = e, this._icon = e);
        }
      }, {
        key: "tag",
        get: function get() {
          return this._tag;
        },
        set: function set(e) {
          e && e.length && (this._payload.notification.tag = e, this._tag = e);
        }
      }, {
        key: "silent",
        set: function set(e) {
          this._isSilent = e;
        }
      }, {
        key: "_setDefaultPayloadStructure",
        value: function value() {
          this._payload.notification = {}, this._payload.data = {};
        }
      }, {
        key: "toObject",
        value: function value() {
          var e = h({}, this._payload.data),
            t = null,
            n = {};
          if (Object.keys(this._payload).length > 2) {
            var r = this._payload,
              o = (r.notification, r.data, (0, i.default)(r, d));
            e = h(h({}, e), o);
          }
          return this._isSilent ? e.notification = this._payload.notification : t = this._payload.notification, Object.keys(e).length && (n.data = e), t && Object.keys(t).length && (n.notification = t), Object.keys(n).length ? n : null;
        }
      }]), n;
    }(g);
    t.FCMNotificationPayload = m;
    var _ = function () {
      function e(t, n) {
        (0, c.default)(this, e), (0, f.default)(this, "_payload", void 0), (0, f.default)(this, "_debugging", void 0), (0, f.default)(this, "_subtitle", void 0), (0, f.default)(this, "_badge", void 0), (0, f.default)(this, "_sound", void 0), (0, f.default)(this, "_title", void 0), (0, f.default)(this, "_body", void 0), (0, f.default)(this, "apns", void 0), (0, f.default)(this, "mpns", void 0), (0, f.default)(this, "fcm", void 0), this._payload = {
          apns: {},
          mpns: {},
          fcm: {}
        }, this._title = t, this._body = n, this.apns = new v(this._payload.apns, t, n), this.mpns = new b(this._payload.mpns, t, n), this.fcm = new m(this._payload.fcm, t, n);
      }
      return (0, l.default)(e, [{
        key: "debugging",
        set: function set(e) {
          this._debugging = e;
        }
      }, {
        key: "title",
        get: function get() {
          return this._title;
        }
      }, {
        key: "body",
        get: function get() {
          return this._body;
        }
      }, {
        key: "subtitle",
        get: function get() {
          return this._subtitle;
        },
        set: function set(e) {
          this._subtitle = e, this.apns.subtitle = e, this.mpns.subtitle = e, this.fcm.subtitle = e;
        }
      }, {
        key: "badge",
        get: function get() {
          return this._badge;
        },
        set: function set(e) {
          this._badge = e, this.apns.badge = e, this.mpns.badge = e, this.fcm.badge = e;
        }
      }, {
        key: "sound",
        get: function get() {
          return this._sound;
        },
        set: function set(e) {
          this._sound = e, this.apns.sound = e, this.mpns.sound = e, this.fcm.sound = e;
        }
      }, {
        key: "buildPayload",
        value: function value(e) {
          var t = {};
          if (e.includes("apns") || e.includes("apns2")) {
            this.apns._apnsPushType = e.includes("apns") ? "apns" : "apns2";
            var n = this.apns.toObject();
            n && Object.keys(n).length && (t.pn_apns = n);
          }
          if (e.includes("mpns")) {
            var r = this.mpns.toObject();
            r && Object.keys(r).length && (t.pn_mpns = r);
          }
          if (e.includes("fcm")) {
            var i = this.fcm.toObject();
            i && Object.keys(i).length && (t.pn_gcm = i);
          }
          return Object.keys(t).length && this._debugging && (t.pn_debug = !0), t;
        }
      }]), e;
    }();
    t.default = _;
  }, function (e, t, n) {
    var r = n(46);
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
        i,
        o = r(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (i = 0; i < a.length; i++) {
          n = a[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
        }
      }
      return o;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) {
        n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
      }
      return i;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(6)),
      a = r(n(4)),
      u = (r(n(8)), n(2), function () {
        function e(t, n) {
          (0, i.default)(this, e), (0, a.default)(this, "_config", void 0), (0, a.default)(this, "_cbor", void 0), (0, a.default)(this, "_token", void 0), this._config = t, this._cbor = n;
        }
        return (0, o.default)(e, [{
          key: "setToken",
          value: function value(e) {
            e && e.length > 0 ? this._token = e : this._token = void 0;
          }
        }, {
          key: "getToken",
          value: function value() {
            return this._token;
          }
        }, {
          key: "extractPermissions",
          value: function value(e) {
            var t = {
              read: !1,
              write: !1,
              manage: !1,
              delete: !1,
              get: !1,
              update: !1,
              join: !1
            };
            return 128 == (128 & e) && (t.join = !0), 64 == (64 & e) && (t.update = !0), 32 == (32 & e) && (t.get = !0), 8 == (8 & e) && (t.delete = !0), 4 == (4 & e) && (t.manage = !0), 2 == (2 & e) && (t.write = !0), 1 == (1 & e) && (t.read = !0), t;
          }
        }, {
          key: "parseToken",
          value: function value(e) {
            var t = this,
              n = this._cbor.decodeToken(e);
            if (void 0 !== n) {
              var r = n.res.uuid ? Object.keys(n.res.uuid) : [],
                i = Object.keys(n.res.chan),
                o = Object.keys(n.res.grp),
                a = n.pat.uuid ? Object.keys(n.pat.uuid) : [],
                u = Object.keys(n.pat.chan),
                s = Object.keys(n.pat.grp),
                c = {
                  version: n.v,
                  timestamp: n.t,
                  ttl: n.ttl,
                  authorized_uuid: n.uuid
                },
                l = r.length > 0,
                f = i.length > 0,
                d = o.length > 0;
              (l || f || d) && (c.resources = {}, l && (c.resources.uuids = {}, r.forEach(function (e) {
                c.resources.uuids[e] = t.extractPermissions(n.res.uuid[e]);
              })), f && (c.resources.channels = {}, i.forEach(function (e) {
                c.resources.channels[e] = t.extractPermissions(n.res.chan[e]);
              })), d && (c.resources.groups = {}, o.forEach(function (e) {
                c.resources.groups[e] = t.extractPermissions(n.res.grp[e]);
              })));
              var p = a.length > 0,
                h = u.length > 0,
                y = s.length > 0;
              return (p || h || y) && (c.patterns = {}, p && (c.patterns.uuids = {}, a.forEach(function (e) {
                c.patterns.uuids[e] = t.extractPermissions(n.pat.uuid[e]);
              })), h && (c.patterns.channels = {}, u.forEach(function (e) {
                c.patterns.channels[e] = t.extractPermissions(n.pat.chan[e]);
              })), y && (c.patterns.groups = {}, s.forEach(function (e) {
                c.patterns.groups[e] = t.extractPermissions(n.pat.grp[e]);
              }))), Object.keys(n.meta).length > 0 && (c.meta = n.meta), c.signature = n.sig, c;
            }
          }
        }]), e;
      }());
    t.default = u, e.exports = t.default;
  }, function (e, t, n) {
    var r = n(13),
      i = n(15),
      o = n(49),
      a = n(50);
    function u(t) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return e.exports = u = function u(e) {
        if (null === e || !o(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== n) {
          if (n.has(e)) return n.get(e);
          n.set(e, t);
        }
        function t() {
          return a(e, arguments, r(this).constructor);
        }
        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), i(t, e);
      }, e.exports.default = e.exports, e.exports.__esModule = !0, u(t);
    }
    e.exports = u, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e) {
      return -1 !== Function.toString.call(e).indexOf("[native code]");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(15),
      i = n(51);
    function o(t, n, a) {
      return i() ? (e.exports = o = Reflect.construct, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = o = function o(e, t, n) {
        var i = [null];
        i.push.apply(i, t);
        var o = new (Function.bind.apply(e, i))();
        return n && r(o, n.prototype), o;
      }, e.exports.default = e.exports, e.exports.__esModule = !0), o.apply(null, arguments);
    }
    e.exports = o, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNAddChannelsToGroupOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(o.default.encodeString(n));
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.channels;
      return {
        add: (void 0 === n ? [] : n).join(",")
      };
    }, t.validateParams = function (e, t) {
      var n = t.channels,
        r = t.channelGroup,
        i = e.config;
      if (!r) return "Missing Channel Group";
      if (!n || 0 === n.length) return "Missing Channels";
      if (!i.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNRemoveChannelsFromGroupOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(o.default.encodeString(n));
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.channels;
      return {
        remove: (void 0 === n ? [] : n).join(",")
      };
    }, t.validateParams = function (e, t) {
      var n = t.channels,
        r = t.channelGroup,
        i = e.config;
      if (!r) return "Missing Channel Group";
      if (!n || 0 === n.length) return "Missing Channels";
      if (!i.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNRemoveGroupOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(o.default.encodeString(n), "/remove");
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.validateParams = function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      if (!n) return "Missing Channel Group";
      if (!r.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNChannelGroupsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e) {
      var t = e.config;
      return "/v1/channel-registration/sub-key/".concat(t.subscribeKey, "/channel-group");
    }, t.handleResponse = function (e, t) {
      return {
        groups: t.payload.groups
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNChannelsForGroupOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      return "/v1/channel-registration/sub-key/".concat(r.subscribeKey, "/channel-group/").concat(o.default.encodeString(n));
    }, t.handleResponse = function (e, t) {
      return {
        channels: t.payload.channels
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.validateParams = function (e, t) {
      var n = t.channelGroup,
        r = e.config;
      if (!n) return "Missing Channel Group";
      if (!r.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNPushNotificationEnabledChannelsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = e.config;
      if ("apns2" === r) return "/v2/push/sub-key/".concat(i.subscribeKey, "/devices-apns2/").concat(n);
      return "/v1/push/sub-key/".concat(i.subscribeKey, "/devices/").concat(n);
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.pushGateway,
        r = t.channels,
        i = void 0 === r ? [] : r,
        o = t.environment,
        a = void 0 === o ? "development" : o,
        u = t.topic,
        s = {
          type: n,
          add: i.join(",")
        };
      "apns2" === n && delete (s = Object.assign({}, s, {
        environment: a,
        topic: u
      })).type;
      return s;
    }, t.validateParams = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = t.channels,
        o = t.topic,
        a = e.config;
      if (!n) return "Missing Device ID (device)";
      if (!r) return "Missing GW Type (pushGateway: gcm, apns or apns2)";
      if ("apns2" === r && !o) return "Missing APNS2 topic";
      if (!i || 0 === i.length) return "Missing Channels";
      if (!a.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNPushNotificationEnabledChannelsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = e.config;
      if ("apns2" === r) return "/v2/push/sub-key/".concat(i.subscribeKey, "/devices-apns2/").concat(n);
      return "/v1/push/sub-key/".concat(i.subscribeKey, "/devices/").concat(n);
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.pushGateway,
        r = t.channels,
        i = void 0 === r ? [] : r,
        o = t.environment,
        a = void 0 === o ? "development" : o,
        u = t.topic,
        s = {
          type: n,
          remove: i.join(",")
        };
      "apns2" === n && delete (s = Object.assign({}, s, {
        environment: a,
        topic: u
      })).type;
      return s;
    }, t.validateParams = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = t.channels,
        o = t.topic,
        a = e.config;
      if (!n) return "Missing Device ID (device)";
      if (!r) return "Missing GW Type (pushGateway: gcm, apns or apns2)";
      if ("apns2" === r && !o) return "Missing APNS2 topic";
      if (!i || 0 === i.length) return "Missing Channels";
      if (!a.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNPushNotificationEnabledChannelsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = e.config;
      if ("apns2" === r) return "/v2/push/sub-key/".concat(i.subscribeKey, "/devices-apns2/").concat(n);
      return "/v1/push/sub-key/".concat(i.subscribeKey, "/devices/").concat(n);
    }, t.handleResponse = function (e, t) {
      return {
        channels: t
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.pushGateway,
        r = t.environment,
        i = void 0 === r ? "development" : r,
        o = t.topic,
        a = {
          type: n
        };
      "apns2" === n && delete (a = Object.assign({}, a, {
        environment: i,
        topic: o
      })).type;
      return a;
    }, t.validateParams = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = t.topic,
        o = e.config;
      if (!n) return "Missing Device ID (device)";
      if (!r) return "Missing GW Type (pushGateway: gcm, apns or apns2)";
      if ("apns2" === r && !i) return "Missing APNS2 topic";
      if (!o.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNRemoveAllPushNotificationsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = e.config;
      if ("apns2" === r) return "/v2/push/sub-key/".concat(i.subscribeKey, "/devices-apns2/").concat(n, "/remove");
      return "/v1/push/sub-key/".concat(i.subscribeKey, "/devices/").concat(n, "/remove");
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.pushGateway,
        r = t.environment,
        i = void 0 === r ? "development" : r,
        o = t.topic,
        a = {
          type: n
        };
      "apns2" === n && delete (a = Object.assign({}, a, {
        environment: i,
        topic: o
      })).type;
      return a;
    }, t.validateParams = function (e, t) {
      var n = t.device,
        r = t.pushGateway,
        i = t.topic,
        o = e.config;
      if (!n) return "Missing Device ID (device)";
      if (!r) return "Missing GW Type (pushGateway: gcm, apns or apns2)";
      if ("apns2" === r && !i) return "Missing APNS2 topic";
      if (!o.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUnsubscribeOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channels,
        i = void 0 === r ? [] : r,
        a = i.length > 0 ? i.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(o.default.encodeString(a), "/leave");
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.channelGroups,
        r = void 0 === n ? [] : n,
        i = {};
      r.length > 0 && (i["channel-group"] = r.join(","));
      return i;
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNWhereNowOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.uuid,
        i = void 0 === r ? n.UUID : r;
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/uuid/").concat(o.default.encodeString(i));
    }, t.handleResponse = function (e, t) {
      if (!t.payload) return {
        channels: []
      };
      return {
        channels: t.payload.channels
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNHeartbeatOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channels,
        i = void 0 === r ? [] : r,
        a = i.length > 0 ? i.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(o.default.encodeString(a), "/heartbeat");
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.channelGroups,
        r = void 0 === n ? [] : n,
        i = t.state,
        o = void 0 === i ? {} : i,
        a = e.config,
        u = {};
      r.length > 0 && (u["channel-group"] = r.join(","));
      return u.state = JSON.stringify(o), u.heartbeat = a.getPresenceTimeout(), u;
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetStateOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.uuid,
        i = void 0 === r ? n.UUID : r,
        a = t.channels,
        u = void 0 === a ? [] : a,
        s = u.length > 0 ? u.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(o.default.encodeString(s), "/uuid/").concat(i);
    }, t.handleResponse = function (e, t, n) {
      var r = n.channels,
        i = void 0 === r ? [] : r,
        o = n.channelGroups,
        a = void 0 === o ? [] : o,
        u = {};
      1 === i.length && 0 === a.length ? u[i[0]] = t.payload : u = t.payload;
      return {
        channels: u
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.channelGroups,
        r = void 0 === n ? [] : n,
        i = {};
      r.length > 0 && (i["channel-group"] = r.join(","));
      return i;
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNSetStateOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channels,
        i = void 0 === r ? [] : r,
        a = i.length > 0 ? i.join(",") : ",";
      return "/v2/presence/sub-key/".concat(n.subscribeKey, "/channel/").concat(o.default.encodeString(a), "/uuid/").concat(o.default.encodeString(n.UUID), "/data");
    }, t.handleResponse = function (e, t) {
      return {
        state: t.payload
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.state,
        r = t.channelGroups,
        i = void 0 === r ? [] : r,
        o = {};
      o.state = JSON.stringify(n), i.length > 0 && (o["channel-group"] = i.join(","));
      return o;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.state,
        i = t.channels,
        o = void 0 === i ? [] : i,
        a = t.channelGroups,
        u = void 0 === a ? [] : a;
      if (!r) return "Missing State";
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (0 === o.length && 0 === u.length) return "Please provide a list of channels and/or channel-groups";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return o.default.PNHereNowOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channels,
        i = void 0 === r ? [] : r,
        o = t.channelGroups,
        u = void 0 === o ? [] : o,
        s = "/v2/presence/sub-key/".concat(n.subscribeKey);
      if (i.length > 0 || u.length > 0) {
        var c = i.length > 0 ? i.join(",") : ",";
        s += "/channel/".concat(a.default.encodeString(c));
      }
      return s;
    }, t.handleError = function (e, t, n) {
      402 !== n.statusCode || this.getURL(e, t).includes("channel") || (n.errorData.message = "You have tried to perform a Global Here Now operation, your keyset configuration does not support that. Please provide a channel, or enable the Global Here Now feature from the Portal.");
    }, t.handleResponse = function (e, t, n) {
      var r,
        i = n.channels,
        o = void 0 === i ? [] : i,
        a = n.channelGroups,
        u = void 0 === a ? [] : a,
        s = n.includeUUIDs,
        c = void 0 === s || s,
        l = n.includeState,
        f = void 0 !== l && l;
      r = o.length > 1 || u.length > 0 || 0 === u.length && 0 === o.length ? function () {
        var e = {};
        return e.totalChannels = t.payload.total_channels, e.totalOccupancy = t.payload.total_occupancy, e.channels = {}, Object.keys(t.payload.channels).forEach(function (n) {
          var r = t.payload.channels[n],
            i = [];
          return e.channels[n] = {
            occupants: i,
            name: n,
            occupancy: r.occupancy
          }, c && r.uuids.forEach(function (e) {
            f ? i.push({
              state: e.state,
              uuid: e.uuid
            }) : i.push({
              state: null,
              uuid: e
            });
          }), e;
        }), e;
      }() : function () {
        var e = {},
          n = [];
        return e.totalChannels = 1, e.totalOccupancy = t.occupancy, e.channels = {}, e.channels[o[0]] = {
          occupants: n,
          name: o[0],
          occupancy: t.occupancy
        }, c && t.uuids && t.uuids.forEach(function (e) {
          f ? n.push({
            state: e.state,
            uuid: e.uuid
          }) : n.push({
            state: null,
            uuid: e
          });
        }), e;
      }();
      return r;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.channelGroups,
        r = void 0 === n ? [] : n,
        i = t.includeUUIDs,
        o = void 0 === i || i,
        a = t.includeState,
        u = void 0 !== a && a,
        c = t.queryParameters,
        l = void 0 === c ? {} : c,
        f = {};
      o || (f.disable_uuids = 1);
      u && (f.state = 1);
      r.length > 0 && (f["channel-group"] = r.join(","));
      return f = s(s({}, f), l);
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    var i = r(n(4)),
      o = (n(2), r(n(1))),
      a = r(n(3));
    function u(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function s(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? u(Object(n), !0).forEach(function (t) {
          (0, i.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNAddMessageActionOperation;
    }, t.getRequestHeaders = function () {
      return {
        "Content-Type": "application/json"
      };
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.handleResponse = function (e, t) {
      return {
        data: t.data
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.postPayload = function (e, t) {
      return t.action;
    }, t.postURL = function (e, t) {
      var n = e.config,
        r = t.channel,
        i = t.messageTimetoken;
      return "/v1/message-actions/".concat(n.subscribeKey, "/channel/").concat(o.default.encodeString(r), "/message/").concat(i);
    }, t.prepareParams = function () {
      return {};
    }, t.usePost = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.action,
        i = t.channel;
      if (!t.messageTimetoken) return "Missing message timetoken";
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (!i) return "Missing message channel";
      if (!r) return "Missing Action";
      if (!r.value) return "Missing Action.value";
      if (!r.type) return "Missing Action.type";
      if (r.type.length > 15) return "Action.type value exceed maximum length of 15";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNRemoveMessageActionOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channel,
        i = t.actionTimetoken,
        a = t.messageTimetoken;
      return "/v1/message-actions/".concat(n.subscribeKey, "/channel/").concat(o.default.encodeString(r), "/message/").concat(a, "/action/").concat(i);
    }, t.handleResponse = function (e, t) {
      return {
        data: t.data
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.useDelete = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.channel,
        i = t.actionTimetoken;
      if (!t.messageTimetoken) return "Missing message timetoken";
      if (!i) return "Missing action timetoken";
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (!r) return "Missing message channel";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetMessageActionsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channel;
      return "/v1/message-actions/".concat(n.subscribeKey, "/channel/").concat(o.default.encodeString(r));
    }, t.handleResponse = function (e, t) {
      var n = {
        data: t.data,
        start: null,
        end: null
      };
      n.data.length && (n.end = n.data[n.data.length - 1].actionTimetoken, n.start = n.data[0].actionTimetoken);
      return n;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.limit,
        r = t.start,
        i = t.end,
        o = {};
      n && (o.limit = n);
      r && (o.start = r);
      i && (o.end = i);
      return o;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.channel;
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (!r) return "Missing message channel";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNListFilesOperation;
        },
        validateParams: function validateParams(e, t) {
          if (null == t || !t.channel) return "channel can't be empty";
        },
        getURL: function getURL(e, t) {
          var n = e.config;
          return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(o.default.encodeString(t.channel), "/files");
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n = {};
          return t.limit && (n.limit = t.limit), t.next && (n.next = t.next), n;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            next: t.next,
            count: t.count
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNGenerateUploadUrlOperation;
        },
        validateParams: function validateParams(e, t) {
          return null != t && t.channel ? null != t && t.name ? void 0 : "name can't be empty" : "channel can't be empty";
        },
        usePost: function usePost() {
          return !0;
        },
        postURL: function postURL(e, t) {
          var n = e.config;
          return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(o.default.encodeString(t.channel), "/generate-upload-url");
        },
        postPayload: function postPayload(e, t) {
          return {
            name: t.name
          };
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams() {
          return {};
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            file_upload_request: t.file_upload_request
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(7)),
      o = r(n(1)),
      a = r(n(3)),
      u = {
        getOperation: function getOperation() {
          return o.default.PNPublishFileOperation;
        },
        validateParams: function validateParams(e, t) {
          return null != t && t.channel ? null != t && t.fileId ? null != t && t.fileName ? void 0 : "file name can't be empty" : "file id can't be empty" : "channel can't be empty";
        },
        getURL: function getURL(e, t) {
          var n = e.config,
            r = n.publishKey,
            i = n.subscribeKey,
            o = function (e, t) {
              var n = e.crypto,
                r = e.config,
                i = JSON.stringify(t);
              return r.cipherKey && (i = n.encrypt(i), i = JSON.stringify(i)), i || "";
            }(e, {
              message: t.message,
              file: {
                name: t.fileName,
                id: t.fileId
              }
            });
          return "/v1/files/publish-file/".concat(r, "/").concat(i, "/0/").concat(a.default.encodeString(t.channel), "/0/").concat(a.default.encodeString(o));
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n = {};
          return t.ttl && (n.ttl = t.ttl), void 0 !== t.storeInHistory && (n.store = t.storeInHistory ? "1" : "0"), t.meta && "object" === (0, i.default)(t.meta) && (n.meta = JSON.stringify(t.meta)), n;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            timetoken: t[2]
          };
        }
      };
    t.default = u, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(11)),
      o = r(n(12)),
      a = n(18),
      u = function u(e) {
        return new Promise(function (t) {
          var n = "";
          e.on("data", function (e) {
            n += e.toString("utf8");
          }), e.on("end", function () {
            t(n);
          });
        });
      };
    t.default = function (e) {
      var t,
        n,
        r,
        s,
        c,
        l,
        f,
        d,
        p,
        h = (r = (t = e).generateUploadUrl, s = t.publishFile, c = t.modules, l = c.PubNubFile, f = c.config, d = c.cryptography, p = c.networking, n = (0, o.default)(i.default.mark(function e(t) {
          var n, o, c, h, y, g, v, b, m, _, P, O, S, w, k, T, x, A, M, E, j, R;
          return i.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = t.channel, o = t.file, c = t.message, h = t.cipherKey, y = t.meta, g = t.ttl, v = t.storeInHistory, n) {
                    e.next = 3;
                    break;
                  }
                  throw new a.PubNubError("Validation failed, check status for details", (0, a.createValidationError)("channel can't be empty"));
                case 3:
                  if (o) {
                    e.next = 5;
                    break;
                  }
                  throw new a.PubNubError("Validation failed, check status for details", (0, a.createValidationError)("file can't be empty"));
                case 5:
                  return b = l.create(o), e.next = 8, r({
                    channel: n,
                    name: b.name
                  });
                case 8:
                  if (m = e.sent, _ = m.file_upload_request, P = _.url, O = _.form_fields, S = m.data, w = S.id, k = S.name, !l.supportsEncryptFile || !(null != h ? h : f.cipherKey)) {
                    e.next = 19;
                    break;
                  }
                  return e.next = 18, d.encryptFile(null != h ? h : f.cipherKey, b, l);
                case 18:
                  b = e.sent;
                case 19:
                  if (T = O, b.mimeType && (T = O.map(function (e) {
                    return "Content-Type" === e.key ? {
                      key: e.key,
                      value: b.mimeType
                    } : e;
                  })), e.prev = 21, !l.supportsFileUri || !o.uri) {
                    e.next = 34;
                    break;
                  }
                  return e.t0 = p, e.t1 = P, e.t2 = T, e.next = 28, b.toFileUri();
                case 28:
                  return e.t3 = e.sent, e.next = 31, e.t0.POSTFILE.call(e.t0, e.t1, e.t2, e.t3);
                case 31:
                  x = e.sent, e.next = 71;
                  break;
                case 34:
                  if (!l.supportsFile) {
                    e.next = 46;
                    break;
                  }
                  return e.t4 = p, e.t5 = P, e.t6 = T, e.next = 40, b.toFile();
                case 40:
                  return e.t7 = e.sent, e.next = 43, e.t4.POSTFILE.call(e.t4, e.t5, e.t6, e.t7);
                case 43:
                  x = e.sent, e.next = 71;
                  break;
                case 46:
                  if (!l.supportsBuffer) {
                    e.next = 58;
                    break;
                  }
                  return e.t8 = p, e.t9 = P, e.t10 = T, e.next = 52, b.toBuffer();
                case 52:
                  return e.t11 = e.sent, e.next = 55, e.t8.POSTFILE.call(e.t8, e.t9, e.t10, e.t11);
                case 55:
                  x = e.sent, e.next = 71;
                  break;
                case 58:
                  if (!l.supportsBlob) {
                    e.next = 70;
                    break;
                  }
                  return e.t12 = p, e.t13 = P, e.t14 = T, e.next = 64, b.toBlob();
                case 64:
                  return e.t15 = e.sent, e.next = 67, e.t12.POSTFILE.call(e.t12, e.t13, e.t14, e.t15);
                case 67:
                  x = e.sent, e.next = 71;
                  break;
                case 70:
                  throw new Error("Unsupported environment");
                case 71:
                  e.next = 80;
                  break;
                case 73:
                  return e.prev = 73, e.t16 = e.catch(21), e.next = 77, u(e.t16.response);
                case 77:
                  throw A = e.sent, M = /<Message>(.*)<\/Message>/gi.exec(A), new a.PubNubError(M ? "Upload to bucket failed: ".concat(M[1]) : "Upload to bucket failed.", e.t16);
                case 80:
                  if (204 === x.status) {
                    e.next = 82;
                    break;
                  }
                  throw new a.PubNubError("Upload to bucket was unsuccessful", x);
                case 82:
                  E = f.fileUploadPublishRetryLimit, j = !1, R = {
                    timetoken: "0"
                  };
                case 85:
                  return e.prev = 85, e.next = 88, s({
                    channel: n,
                    message: c,
                    fileId: w,
                    fileName: k,
                    meta: y,
                    storeInHistory: v,
                    ttl: g
                  });
                case 88:
                  R = e.sent, j = !0, e.next = 95;
                  break;
                case 92:
                  e.prev = 92, e.t17 = e.catch(85), E -= 1;
                case 95:
                  if (!j && E > 0) {
                    e.next = 85;
                    break;
                  }
                case 96:
                  if (j) {
                    e.next = 100;
                    break;
                  }
                  throw new a.PubNubError("Publish failed. You may want to execute that operation manually using pubnub.publishFile", {
                    channel: n,
                    id: w,
                    name: k
                  });
                case 100:
                  return e.abrupt("return", {
                    timetoken: R.timetoken,
                    id: w,
                    name: k
                  });
                case 101:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[21, 73], [85, 92]]);
        })), function (e) {
          return n.apply(this, arguments);
        });
      return function (e, t) {
        var n = h(e);
        return "function" == typeof t ? (n.then(function (e) {
          return t(null, e);
        }).catch(function (e) {
          return t(e, null);
        }), n) : n;
      };
    }, e.exports = t.default;
  }, function (e, t, n) {
    var r = function (e) {
      "use strict";

      var t = Object.prototype,
        n = t.hasOwnProperty,
        r = "function" == typeof Symbol ? Symbol : {},
        i = r.iterator || "@@iterator",
        o = r.asyncIterator || "@@asyncIterator",
        a = r.toStringTag || "@@toStringTag";
      function u(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        u({}, "");
      } catch (e) {
        u = function u(e, t, n) {
          return e[t] = n;
        };
      }
      function s(e, t, n, r) {
        var i = t && t.prototype instanceof f ? t : f,
          o = Object.create(i.prototype),
          a = new S(r || []);
        return o._invoke = function (e, t, n) {
          var r = "suspendedStart";
          return function (i, o) {
            if ("executing" === r) throw new Error("Generator is already running");
            if ("completed" === r) {
              if ("throw" === i) throw o;
              return k();
            }
            for (n.method = i, n.arg = o;;) {
              var a = n.delegate;
              if (a) {
                var u = _(a, n);
                if (u) {
                  if (u === l) continue;
                  return u;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if ("suspendedStart" === r) throw r = "completed", n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = "executing";
              var s = c(e, t, n);
              if ("normal" === s.type) {
                if (r = n.done ? "completed" : "suspendedYield", s.arg === l) continue;
                return {
                  value: s.arg,
                  done: n.done
                };
              }
              "throw" === s.type && (r = "completed", n.method = "throw", n.arg = s.arg);
            }
          };
        }(e, n, a), o;
      }
      function c(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = s;
      var l = {};
      function f() {}
      function d() {}
      function p() {}
      var h = {};
      u(h, i, function () {
        return this;
      });
      var y = Object.getPrototypeOf,
        g = y && y(y(w([])));
      g && g !== t && n.call(g, i) && (h = g);
      var v = p.prototype = f.prototype = Object.create(h);
      function b(e) {
        ["next", "throw", "return"].forEach(function (t) {
          u(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function m(e, t) {
        var r;
        this._invoke = function (i, o) {
          function a() {
            return new t(function (r, a) {
              !function r(i, o, a, u) {
                var s = c(e[i], e, o);
                if ("throw" !== s.type) {
                  var l = s.arg,
                    f = l.value;
                  return f && "object" == typeof f && n.call(f, "__await") ? t.resolve(f.__await).then(function (e) {
                    r("next", e, a, u);
                  }, function (e) {
                    r("throw", e, a, u);
                  }) : t.resolve(f).then(function (e) {
                    l.value = e, a(l);
                  }, function (e) {
                    return r("throw", e, a, u);
                  });
                }
                u(s.arg);
              }(i, o, r, a);
            });
          }
          return r = r ? r.then(a, a) : a();
        };
      }
      function _(e, t) {
        var n = e.iterator[t.method];
        if (void 0 === n) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, _(e, t), "throw" === t.method)) return l;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return l;
        }
        var r = c(n, e.iterator, t.arg);
        if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, l;
        var i = r.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, l) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, l);
      }
      function P(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function O(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(P, this), this.reset(!0);
      }
      function w(e) {
        if (e) {
          var t = e[i];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var r = -1,
              o = function t() {
                for (; ++r < e.length;) {
                  if (n.call(e, r)) return t.value = e[r], t.done = !1, t;
                }
                return t.value = void 0, t.done = !0, t;
              };
            return o.next = o;
          }
        }
        return {
          next: k
        };
      }
      function k() {
        return {
          value: void 0,
          done: !0
        };
      }
      return d.prototype = p, u(v, "constructor", p), u(p, "constructor", d), d.displayName = u(p, a, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, u(e, a, "GeneratorFunction")), e.prototype = Object.create(v), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, b(m.prototype), u(m.prototype, o, function () {
        return this;
      }), e.AsyncIterator = m, e.async = function (t, n, r, i, o) {
        void 0 === o && (o = Promise);
        var a = new m(s(t, n, r, i), o);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, b(v), u(v, a, "Generator"), u(v, i, function () {
        return this;
      }), u(v, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (e) {
        var t = [];
        for (var n in e) {
          t.push(n);
        }
        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, e.values = w, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !e) for (var t in this) {
            "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;
          function r(n, r) {
            return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var o = this.tryEntries[i],
              a = o.completion;
            if ("root" === o.tryLoc) return r("end");
            if (o.tryLoc <= this.prev) {
              var u = n.call(o, "catchLoc"),
                s = n.call(o, "finallyLoc");
              if (u && s) {
                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
              } else if (u) {
                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var i = this.tryEntries[r];
            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }
          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, l) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), l;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), O(n), l;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var i = r.arg;
                O(n);
              }
              return i;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: w(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = void 0), l;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = r;
    } catch (e) {
      "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = n(18),
      o = r(n(3));
    t.default = function (e, t) {
      var n = t.channel,
        r = t.id,
        a = t.name,
        u = e.config,
        s = e.networking;
      if (!n) throw new i.PubNubError("Validation failed, check status for details", (0, i.createValidationError)("channel can't be empty"));
      if (!r) throw new i.PubNubError("Validation failed, check status for details", (0, i.createValidationError)("file id can't be empty"));
      if (!a) throw new i.PubNubError("Validation failed, check status for details", (0, i.createValidationError)("file name can't be empty"));
      var c = "/v1/files/".concat(u.subscribeKey, "/channels/").concat(o.default.encodeString(n), "/files/").concat(r, "/").concat(a),
        l = {};
      l.uuid = u.getUUID(), l.pnsdk = (0, i.generatePNSDK)(u), u.getAuthKey() && (l.auth = u.getAuthKey()), u.secretKey && (0, i.signRequest)(e, c, l, {}, {
        getOperation: function getOperation() {
          return "PubNubGetFileUrlOperation";
        }
      });
      var f = Object.keys(l).map(function (e) {
        return "".concat(encodeURIComponent(e), "=").concat(encodeURIComponent(l[e]));
      }).join("&");
      return "" !== f ? "".concat(s.getStandardOrigin()).concat(c, "?").concat(f) : "".concat(s.getStandardOrigin()).concat(c);
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i,
      o = r(n(11)),
      a = r(n(12)),
      u = r(n(1)),
      s = r(n(3)),
      c = {
        getOperation: function getOperation() {
          return u.default.PNDownloadFileOperation;
        },
        validateParams: function validateParams(e, t) {
          return null != t && t.channel ? null != t && t.name ? null != t && t.id ? void 0 : "id can't be empty" : "name can't be empty" : "channel can't be empty";
        },
        useGetFile: function useGetFile() {
          return !0;
        },
        getFileURL: function getFileURL(e, t) {
          var n = e.config;
          return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(s.default.encodeString(t.channel), "/files/").concat(t.id, "/").concat(t.name);
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        ignoreBody: function ignoreBody() {
          return !0;
        },
        forceBuffered: function forceBuffered() {
          return !0;
        },
        prepareParams: function prepareParams() {
          return {};
        },
        handleResponse: (i = (0, a.default)(o.default.mark(function e(t, n, r) {
          var i, a, u, s, c, l, f;
          return o.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (u = t.PubNubFile, s = t.config, c = t.cryptography, l = n.response.body, !u.supportsEncryptFile || !(null !== (i = r.cipherKey) && void 0 !== i ? i : s.cipherKey)) {
                    e.next = 6;
                    break;
                  }
                  return e.next = 5, c.decrypt(null !== (f = r.cipherKey) && void 0 !== f ? f : s.cipherKey, l);
                case 5:
                  l = e.sent;
                case 6:
                  return e.abrupt("return", u.create({
                    data: l,
                    name: null !== (a = n.response.name) && void 0 !== a ? a : r.name,
                    mimeType: n.response.type
                  }));
                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function (e, t, n) {
          return i.apply(this, arguments);
        })
      };
    t.default = c, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNListFilesOperation;
        },
        validateParams: function validateParams(e, t) {
          return null != t && t.channel ? null != t && t.id ? null != t && t.name ? void 0 : "file name can't be empty" : "file id can't be empty" : "channel can't be empty";
        },
        useDelete: function useDelete() {
          return !0;
        },
        getURL: function getURL(e, t) {
          var n = e.config;
          return "/v1/files/".concat(n.subscribeKey, "/channels/").concat(o.default.encodeString(t.channel), "/files/").concat(t.id, "/").concat(t.name);
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams() {
          return {};
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(9)),
      o = r(n(1)),
      a = {
        getOperation: function getOperation() {
          return o.default.PNGetAllUUIDMetadataOperation;
        },
        validateParams: function validateParams() {},
        getURL: function getURL(e) {
          var t = e.config;
          return "/v2/objects/".concat(t.subscribeKey, "/uuids");
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            o,
            a,
            u,
            s,
            c,
            l,
            f,
            d = {};
          (null != t && null !== (n = t.include) && void 0 !== n && n.customFields && (d.include = "custom"), null != t && null !== (r = t.include) && void 0 !== r && r.totalCount) && (d.count = null === (s = t.include) || void 0 === s ? void 0 : s.totalCount);
          null != t && null !== (o = t.page) && void 0 !== o && o.next && (d.start = null === (c = t.page) || void 0 === c ? void 0 : c.next);
          null != t && null !== (a = t.page) && void 0 !== a && a.prev && (d.end = null === (l = t.page) || void 0 === l ? void 0 : l.prev);
          (null != t && t.filter && (d.filter = t.filter), d.limit = null !== (u = null == t ? void 0 : t.limit) && void 0 !== u ? u : 100, null != t && t.sort) && (d.sort = Object.entries(null !== (f = t.sort) && void 0 !== f ? f : {}).map(function (e) {
            var t = (0, i.default)(e, 2),
              n = t[0],
              r = t[1];
            return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
          }));
          return d;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            totalCount: t.totalCount,
            next: t.next,
            prev: t.prev
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != n) {
        var r,
          i,
          o = [],
          a = !0,
          u = !1;
        try {
          for (n = n.call(e); !(a = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); a = !0) {
            ;
          }
        } catch (e) {
          u = !0, i = e;
        } finally {
          try {
            a || null == n.return || n.return();
          } finally {
            if (u) throw i;
          }
        }
        return o;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    var r = n(83);
    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return r(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
      }
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }
      return r;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNGetUUIDMetadataOperation;
        },
        validateParams: function validateParams() {},
        getURL: function getURL(e, t) {
          var n,
            r = e.config;
          return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(o.default.encodeString(null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()));
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            i,
            o = e.config;
          return {
            uuid: null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : o.getUUID(),
            include: (null === (r = null == t || null === (i = t.include) || void 0 === i ? void 0 : i.customFields) || void 0 === r || r) && "custom"
          };
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNSetUUIDMetadataOperation;
        },
        validateParams: function validateParams(e, t) {
          if (null == t || !t.data) return "Data cannot be empty";
        },
        usePatch: function usePatch() {
          return !0;
        },
        patchURL: function patchURL(e, t) {
          var n,
            r = e.config;
          return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(o.default.encodeString(null !== (n = t.uuid) && void 0 !== n ? n : r.getUUID()));
        },
        patchPayload: function patchPayload(e, t) {
          return t.data;
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            i,
            o = e.config;
          return {
            uuid: null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : o.getUUID(),
            include: (null === (r = null == t || null === (i = t.include) || void 0 === i ? void 0 : i.customFields) || void 0 === r || r) && "custom"
          };
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNRemoveUUIDMetadataOperation;
        },
        validateParams: function validateParams() {},
        getURL: function getURL(e, t) {
          var n,
            r = e.config;
          return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(o.default.encodeString(null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()));
        },
        useDelete: function useDelete() {
          return !0;
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r = e.config;
          return {
            uuid: null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()
          };
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(9)),
      o = r(n(1)),
      a = {
        getOperation: function getOperation() {
          return o.default.PNGetAllChannelMetadataOperation;
        },
        validateParams: function validateParams() {},
        getURL: function getURL(e) {
          var t = e.config;
          return "/v2/objects/".concat(t.subscribeKey, "/channels");
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            o,
            a,
            u,
            s,
            c,
            l,
            f,
            d = {};
          (null != t && null !== (n = t.include) && void 0 !== n && n.customFields && (d.include = "custom"), null != t && null !== (r = t.include) && void 0 !== r && r.totalCount) && (d.count = null === (s = t.include) || void 0 === s ? void 0 : s.totalCount);
          null != t && null !== (o = t.page) && void 0 !== o && o.next && (d.start = null === (c = t.page) || void 0 === c ? void 0 : c.next);
          null != t && null !== (a = t.page) && void 0 !== a && a.prev && (d.end = null === (l = t.page) || void 0 === l ? void 0 : l.prev);
          (null != t && t.filter && (d.filter = t.filter), d.limit = null !== (u = null == t ? void 0 : t.limit) && void 0 !== u ? u : 100, null != t && t.sort) && (d.sort = Object.entries(null !== (f = t.sort) && void 0 !== f ? f : {}).map(function (e) {
            var t = (0, i.default)(e, 2),
              n = t[0],
              r = t[1];
            return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
          }));
          return d;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            totalCount: t.totalCount,
            prev: t.prev,
            next: t.next
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNGetChannelMetadataOperation;
        },
        validateParams: function validateParams(e, t) {
          if (null == t || !t.channel) return "Channel cannot be empty";
        },
        getURL: function getURL(e, t) {
          var n = e.config;
          return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(o.default.encodeString(t.channel));
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n, r;
          return {
            include: (null === (n = null == t || null === (r = t.include) || void 0 === r ? void 0 : r.customFields) || void 0 === n || n) && "custom"
          };
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNSetChannelMetadataOperation;
        },
        validateParams: function validateParams(e, t) {
          return null != t && t.channel ? null != t && t.data ? void 0 : "Data cannot be empty" : "Channel cannot be empty";
        },
        usePatch: function usePatch() {
          return !0;
        },
        patchURL: function patchURL(e, t) {
          var n = e.config;
          return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(o.default.encodeString(t.channel));
        },
        patchPayload: function patchPayload(e, t) {
          return t.data;
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n, r;
          return {
            include: (null === (n = null == t || null === (r = t.include) || void 0 === r ? void 0 : r.customFields) || void 0 === n || n) && "custom"
          };
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNRemoveChannelMetadataOperation;
        },
        validateParams: function validateParams(e, t) {
          if (null == t || !t.channel) return "Channel cannot be empty";
        },
        getURL: function getURL(e, t) {
          var n = e.config;
          return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(o.default.encodeString(t.channel));
        },
        useDelete: function useDelete() {
          return !0;
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams() {
          return {};
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(9)),
      o = r(n(1)),
      a = r(n(3)),
      u = {
        getOperation: function getOperation() {
          return o.default.PNGetMembersOperation;
        },
        validateParams: function validateParams(e, t) {
          if (null == t || !t.channel) return "UUID cannot be empty";
        },
        getURL: function getURL(e, t) {
          var n = e.config;
          return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(a.default.encodeString(t.channel), "/uuids");
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            o,
            a,
            u,
            s,
            c,
            l,
            f,
            d,
            p,
            h,
            y = {};
          null != t && t.include && (y.include = [], null !== (u = t.include) && void 0 !== u && u.customFields && y.include.push("custom"), null !== (s = t.include) && void 0 !== s && s.customUUIDFields && y.include.push("uuid.custom"), (null === (c = null === (l = t.include) || void 0 === l ? void 0 : l.UUIDFields) || void 0 === c || c) && y.include.push("uuid"), y.include = y.include.join(","));
          null != t && null !== (n = t.include) && void 0 !== n && n.totalCount && (y.count = null === (f = t.include) || void 0 === f ? void 0 : f.totalCount);
          null != t && null !== (r = t.page) && void 0 !== r && r.next && (y.start = null === (d = t.page) || void 0 === d ? void 0 : d.next);
          null != t && null !== (o = t.page) && void 0 !== o && o.prev && (y.end = null === (p = t.page) || void 0 === p ? void 0 : p.prev);
          (null != t && t.filter && (y.filter = t.filter), y.limit = null !== (a = null == t ? void 0 : t.limit) && void 0 !== a ? a : 100, null != t && t.sort) && (y.sort = Object.entries(null !== (h = t.sort) && void 0 !== h ? h : {}).map(function (e) {
            var t = (0, i.default)(e, 2),
              n = t[0],
              r = t[1];
            return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
          }));
          return y;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            totalCount: t.totalCount,
            prev: t.prev,
            next: t.next
          };
        }
      };
    t.default = u, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(9)),
      o = r(n(4)),
      a = r(n(1)),
      u = r(n(3)),
      s = {
        getOperation: function getOperation() {
          return a.default.PNSetMembersOperation;
        },
        validateParams: function validateParams(e, t) {
          return null != t && t.channel ? null != t && t.uuids && 0 !== (null == t ? void 0 : t.uuids.length) ? void 0 : "UUIDs cannot be empty" : "Channel cannot be empty";
        },
        usePatch: function usePatch() {
          return !0;
        },
        patchURL: function patchURL(e, t) {
          var n = e.config;
          return "/v2/objects/".concat(n.subscribeKey, "/channels/").concat(u.default.encodeString(t.channel), "/uuids");
        },
        patchPayload: function patchPayload(e, t) {
          return (0, o.default)({
            set: [],
            remove: []
          }, t.type, t.uuids.map(function (e) {
            return "string" == typeof e ? {
              uuid: {
                id: e
              }
            } : {
              uuid: {
                id: e.id
              },
              custom: e.custom
            };
          }));
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            o,
            a,
            u,
            s,
            c,
            l,
            f,
            d = {};
          null != t && t.include && (d.include = [], null !== (a = t.include) && void 0 !== a && a.customFields && d.include.push("custom"), null !== (u = t.include) && void 0 !== u && u.customUUIDFields && d.include.push("uuid.custom"), null !== (s = t.include) && void 0 !== s && s.UUIDFields && d.include.push("uuid"), d.include = d.include.join(","));
          (null != t && null !== (n = t.include) && void 0 !== n && n.totalCount && (d.count = !0), null != t && null !== (r = t.page) && void 0 !== r && r.next) && (d.start = null === (c = t.page) || void 0 === c ? void 0 : c.next);
          null != t && null !== (o = t.page) && void 0 !== o && o.prev && (d.end = null === (l = t.page) || void 0 === l ? void 0 : l.prev);
          (null != t && t.filter && (d.filter = t.filter), null != t && t.limit && (d.limit = t.limit), null != t && t.sort) && (d.sort = Object.entries(null !== (f = t.sort) && void 0 !== f ? f : {}).map(function (e) {
            var t = (0, i.default)(e, 2),
              n = t[0],
              r = t[1];
            return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
          }));
          return d;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            totalCount: t.totalCount,
            prev: t.prev,
            next: t.next
          };
        }
      };
    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(9)),
      o = r(n(1)),
      a = r(n(3)),
      u = {
        getOperation: function getOperation() {
          return o.default.PNGetMembershipsOperation;
        },
        validateParams: function validateParams() {},
        getURL: function getURL(e, t) {
          var n,
            r = e.config;
          return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(a.default.encodeString(null !== (n = null == t ? void 0 : t.uuid) && void 0 !== n ? n : r.getUUID()), "/channels");
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            o,
            a,
            u,
            s,
            c,
            l,
            f,
            d,
            p,
            h = {};
          null != t && t.include && (h.include = [], null !== (u = t.include) && void 0 !== u && u.customFields && h.include.push("custom"), null !== (s = t.include) && void 0 !== s && s.customChannelFields && h.include.push("channel.custom"), null !== (c = t.include) && void 0 !== c && c.channelFields && h.include.push("channel"), h.include = h.include.join(","));
          null != t && null !== (n = t.include) && void 0 !== n && n.totalCount && (h.count = null === (l = t.include) || void 0 === l ? void 0 : l.totalCount);
          null != t && null !== (r = t.page) && void 0 !== r && r.next && (h.start = null === (f = t.page) || void 0 === f ? void 0 : f.next);
          null != t && null !== (o = t.page) && void 0 !== o && o.prev && (h.end = null === (d = t.page) || void 0 === d ? void 0 : d.prev);
          (null != t && t.filter && (h.filter = t.filter), h.limit = null !== (a = null == t ? void 0 : t.limit) && void 0 !== a ? a : 100, null != t && t.sort) && (h.sort = Object.entries(null !== (p = t.sort) && void 0 !== p ? p : {}).map(function (e) {
            var t = (0, i.default)(e, 2),
              n = t[0],
              r = t[1];
            return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
          }));
          return h;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            totalCount: t.totalCount,
            prev: t.prev,
            next: t.next
          };
        }
      };
    t.default = u, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(9)),
      o = r(n(4)),
      a = r(n(1)),
      u = r(n(3)),
      s = {
        getOperation: function getOperation() {
          return a.default.PNSetMembershipsOperation;
        },
        validateParams: function validateParams(e, t) {
          if (null == t || !t.channels || 0 === (null == t ? void 0 : t.channels.length)) return "Channels cannot be empty";
        },
        usePatch: function usePatch() {
          return !0;
        },
        patchURL: function patchURL(e, t) {
          var n,
            r = e.config;
          return "/v2/objects/".concat(r.subscribeKey, "/uuids/").concat(u.default.encodeString(null !== (n = t.uuid) && void 0 !== n ? n : r.getUUID()), "/channels");
        },
        patchPayload: function patchPayload(e, t) {
          return (0, o.default)({
            set: [],
            remove: []
          }, t.type, t.channels.map(function (e) {
            return "string" == typeof e ? {
              channel: {
                id: e
              }
            } : {
              channel: {
                id: e.id
              },
              custom: e.custom
            };
          }));
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !0;
        },
        prepareParams: function prepareParams(e, t) {
          var n,
            r,
            o,
            a,
            u,
            s,
            c,
            l,
            f,
            d = {};
          null != t && t.include && (d.include = [], null !== (a = t.include) && void 0 !== a && a.customFields && d.include.push("custom"), null !== (u = t.include) && void 0 !== u && u.customChannelFields && d.include.push("channel.custom"), null !== (s = t.include) && void 0 !== s && s.channelFields && d.include.push("channel"), d.include = d.include.join(","));
          (null != t && null !== (n = t.include) && void 0 !== n && n.totalCount && (d.count = !0), null != t && null !== (r = t.page) && void 0 !== r && r.next) && (d.start = null === (c = t.page) || void 0 === c ? void 0 : c.next);
          null != t && null !== (o = t.page) && void 0 !== o && o.prev && (d.end = null === (l = t.page) || void 0 === l ? void 0 : l.prev);
          (null != t && t.filter && (d.filter = t.filter), null != t && t.limit && (d.limit = t.limit), null != t && t.sort) && (d.sort = Object.entries(null !== (f = t.sort) && void 0 !== f ? f : {}).map(function (e) {
            var t = (0, i.default)(e, 2),
              n = t[0],
              r = t[1];
            return "asc" === r || "desc" === r ? "".concat(n, ":").concat(r) : n;
          }));
          return d;
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data,
            totalCount: t.totalCount,
            prev: t.prev,
            next: t.next
          };
        }
      };
    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNCreateUserOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e) {
      var t = e.config;
      return "/v1/objects/".concat(t.subscribeKey, "/users");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.postPayload = function (e, t) {
      return function (e, t) {
        return t;
      }(0, t);
    }, t.postURL = function (e) {
      var t = e.config;
      return "/v1/objects/".concat(t.subscribeKey, "/users");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = {};
      n ? void 0 === n.customFields && (n.customFields = !0) : n = {
        customFields: !0
      };
      if (n) {
        var i = [];
        n.customFields && i.push("custom");
        var o = i.join(",");
        o.length > 0 && (r.include = o);
      }
      return r;
    }, t.usePost = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.id,
        i = t.name,
        o = t.custom;
      if (!r) return "Missing User.id";
      if (!i) return "Missing User.name";
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (o && !Object.values(o).every(function (e) {
        return "string" == typeof e || "number" == typeof e || "boolean" == typeof e;
      })) return "Invalid custom type, only string, number and boolean values are allowed.";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateUserOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.id;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(r));
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        return t;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config,
        r = t.id;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(r));
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = {};
      n ? void 0 === n.customFields && (n.customFields = !0) : n = {
        customFields: !0
      };
      if (n) {
        var i = [];
        n.customFields && i.push("custom");
        var o = i.join(",");
        o.length > 0 && (r.include = o);
      }
      return r;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.id,
        i = t.name,
        o = t.custom;
      if (!r) return "Missing User.id";
      if (!i) return "Missing User.name";
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (o && !Object.values(o).every(function (e) {
        return "string" == typeof e || "number" == typeof e || "boolean" == typeof e;
      })) return "Invalid custom type, only string, number and boolean values are allowed.";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNDeleteUserOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t));
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.useDelete = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config;
      if (!t) return "Missing UserId";
      if (!n.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetUserOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId));
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = {};
      n ? void 0 === n.customFields && (n.customFields = !0) : n = {
        customFields: !0
      };
      if (n) {
        var i = [];
        n.customFields && i.push("custom");
        var o = i.join(",");
        o.length > 0 && (r.include = o);
      }
      return r;
    }, t.validateParams = function (e, t) {
      if (!t.userId) return "Missing userId";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetUsersOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e) {
      var t = e.config;
      return "/v1/objects/".concat(t.subscribeKey, "/users");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = t.filter,
        a = {};
      r && (a.limit = r);
      if (n) {
        var u = [];
        n.totalCount && (a.count = !0), n.customFields && u.push("custom");
        var s = u.join(",");
        s.length > 0 && (a.include = s);
      }
      i && (i.next && (a.start = i.next), i.prev && (a.end = i.prev));
      o && (a.filter = o);
      return a;
    }, t.validateParams = function () {};
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNCreateSpaceOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e) {
      var t = e.config;
      return "/v1/objects/".concat(t.subscribeKey, "/spaces");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.postPayload = function (e, t) {
      return function (e, t) {
        return t;
      }(0, t);
    }, t.postURL = function (e) {
      var t = e.config;
      return "/v1/objects/".concat(t.subscribeKey, "/spaces");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = {};
      n ? void 0 === n.customFields && (n.customFields = !0) : n = {
        customFields: !0
      };
      if (n) {
        var i = [];
        n.customFields && i.push("custom");
        var o = i.join(",");
        o.length > 0 && (r.include = o);
      }
      return r;
    }, t.usePost = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.id,
        i = t.name,
        o = t.custom;
      if (!r) return "Missing Space.id";
      if (!i) return "Missing Space.name";
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (o && !Object.values(o).every(function (e) {
        return "string" == typeof e || "number" == typeof e || "boolean" == typeof e;
      })) return "Invalid custom type, only string, number and boolean values are allowed.";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateSpaceOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.id;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(r));
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        return t;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config,
        r = t.id;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(r));
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = {};
      n ? void 0 === n.customFields && (n.customFields = !0) : n = {
        customFields: !0
      };
      if (n) {
        var i = [];
        n.customFields && i.push("custom");
        var o = i.join(",");
        o.length > 0 && (r.include = o);
      }
      return r;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.id,
        i = t.name,
        o = t.custom;
      if (!r) return "Missing Space.id";
      if (!i) return "Missing Space.name";
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (o && !Object.values(o).every(function (e) {
        return "string" == typeof e || "number" == typeof e || "boolean" == typeof e;
      })) return "Invalid custom type, only string, number and boolean values are allowed.";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNDeleteSpaceOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t));
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.useDelete = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config;
      if (!t) return "Missing SpaceId";
      if (!n.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetSpacesOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e) {
      var t = e.config;
      return "/v1/objects/".concat(t.subscribeKey, "/spaces");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = t.filter,
        a = {};
      r && (a.limit = r);
      if (n) {
        var u = [];
        n.totalCount && (a.count = !0), n.customFields && u.push("custom");
        var s = u.join(",");
        s.length > 0 && (a.include = s);
      }
      i && (i.next && (a.start = i.next), i.prev && (a.end = i.prev));
      o && (a.filter = o);
      return a;
    }, t.validateParams = function () {};
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetSpaceOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId));
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = {};
      n ? void 0 === n.customFields && (n.customFields = !0) : n = {
        customFields: !0
      };
      if (n) {
        var i = [];
        n.customFields && i.push("custom");
        var o = i.join(",");
        o.length > 0 && (r.include = o);
      }
      return r;
    }, t.validateParams = function (e, t) {
      if (!t.spaceId) return "Missing spaceId";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetMembersOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId), "/users");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = t.filter,
        a = {};
      r && (a.limit = r);
      if (n) {
        var u = [];
        n.totalCount && (a.count = !0), n.customFields && u.push("custom"), n.userFields && u.push("user"), n.customUserFields && u.push("user.custom");
        var s = u.join(",");
        s.length > 0 && (a.include = s);
      }
      i && (i.next && (a.start = i.next), i.prev && (a.end = i.prev));
      o && (a.filter = o);
      return a;
    }, t.validateParams = function (e, t) {
      if (!t.spaceId) return "Missing spaceId";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateMembersOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId), "/users");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        var n = t.users,
          r = {};
        n && n.length > 0 && (r.add = [], n.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), r.add.push(t);
        }));
        return r;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId), "/users");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = {};
      r && (o.limit = r);
      if (n) {
        var a = [];
        n.totalCount && (o.count = !0), n.customFields && a.push("custom"), n.spaceFields && a.push("space"), n.customSpaceFields && a.push("space.custom");
        var u = a.join(",");
        u.length > 0 && (o.include = u);
      }
      i && (i.next && (o.start = i.next), i.prev && (o.end = i.prev));
      return o;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = t.spaceId,
        r = t.users;
      if (!n) return "Missing spaceId";
      if (!r) return "Missing users";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateMembersOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId), "/users");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        var n = t.addMembers,
          r = t.updateMembers,
          i = t.removeMembers,
          o = t.users,
          a = {};
        n && n.length > 0 && (a.add = [], n.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), a.add.push(t);
        }));
        r && r.length > 0 && (a.update = [], r.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), a.update.push(t);
        }));
        o && o.length > 0 && (a.update = a.update || [], o.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), a.update.push(t);
        }));
        i && i.length > 0 && (a.remove = [], i.forEach(function (e) {
          a.remove.push({
            id: e
          });
        }));
        return a;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId), "/users");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = {};
      r && (o.limit = r);
      if (n) {
        var a = [];
        n.totalCount && (o.count = !0), n.customFields && a.push("custom"), n.spaceFields && a.push("space"), n.customSpaceFields && a.push("space.custom");
        var u = a.join(",");
        u.length > 0 && (o.include = u);
      }
      i && (i.next && (o.start = i.next), i.prev && (o.end = i.prev));
      return o;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = t.spaceId,
        r = t.users;
      if (!n) return "Missing spaceId";
      if (!r) return "Missing users";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateMembersOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId), "/users");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        var n = t.users,
          r = {};
        n && n.length > 0 && (r.remove = [], n.forEach(function (e) {
          r.remove.push({
            id: e
          });
        }));
        return r;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/spaces/").concat(o.default.encodeString(t.spaceId), "/users");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = {};
      r && (o.limit = r);
      if (n) {
        var a = [];
        n.totalCount && (o.count = !0), n.customFields && a.push("custom"), n.spaceFields && a.push("space"), n.customSpaceFields && a.push("space.custom");
        var u = a.join(",");
        u.length > 0 && (o.include = u);
      }
      i && (i.next && (o.start = i.next), i.prev && (o.end = i.prev));
      return o;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = t.spaceId,
        r = t.users;
      if (!n) return "Missing spaceId";
      if (!r) return "Missing users";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNGetMembershipsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId), "/spaces");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = t.filter,
        a = {};
      r && (a.limit = r);
      if (n) {
        var u = [];
        n.totalCount && (a.count = !0), n.customFields && u.push("custom"), n.spaceFields && u.push("space"), n.customSpaceFields && u.push("space.custom");
        var s = u.join(",");
        s.length > 0 && (a.include = s);
      }
      i && (i.next && (a.start = i.next), i.prev && (a.end = i.prev));
      o && (a.filter = o);
      return a;
    }, t.validateParams = function (e, t) {
      if (!t.userId) return "Missing userId";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateMembershipsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId), "/spaces");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        var n = t.addMemberships,
          r = t.updateMemberships,
          i = t.removeMemberships,
          o = t.spaces,
          a = {};
        n && n.length > 0 && (a.add = [], n.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), a.add.push(t);
        }));
        r && r.length > 0 && (a.update = [], r.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), a.update.push(t);
        }));
        o && o.length > 0 && (a.update = a.update || [], o.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), a.update.push(t);
        }));
        i && i.length > 0 && (a.remove = [], i.forEach(function (e) {
          a.remove.push({
            id: e
          });
        }));
        return a;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId), "/spaces");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = {};
      r && (o.limit = r);
      if (n) {
        var a = [];
        n.totalCount && (o.count = !0), n.customFields && a.push("custom"), n.spaceFields && a.push("space"), n.customSpaceFields && a.push("space.custom");
        var u = a.join(",");
        u.length > 0 && (o.include = u);
      }
      i && (i.next && (o.start = i.next), i.prev && (o.end = i.prev));
      return o;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = t.userId,
        r = t.spaces;
      if (!n) return "Missing userId";
      if (!r) return "Missing spaces";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateMembershipsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId), "/spaces");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        var n = t.spaces,
          r = {};
        n && n.length > 0 && (r.add = [], n.forEach(function (e) {
          var t = {
            id: e.id
          };
          e.custom && (t.custom = e.custom), r.add.push(t);
        }));
        return r;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId), "/spaces");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = {};
      r && (o.limit = r);
      if (n) {
        var a = [];
        n.totalCount && (o.count = !0), n.customFields && a.push("custom"), n.spaceFields && a.push("space"), n.customSpaceFields && a.push("space.custom");
        var u = a.join(",");
        u.length > 0 && (o.include = u);
      }
      i && (i.next && (o.start = i.next), i.prev && (o.end = i.prev));
      return o;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = t.userId,
        r = t.spaces;
      if (!n) return "Missing userId";
      if (!r) return "Missing spaces";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNUpdateMembershipsOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId), "/spaces");
    }, t.handleResponse = function (e, t) {
      return t;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.patchPayload = function (e, t) {
      return function (e, t) {
        var n = t.spaces,
          r = {};
        n && n.length > 0 && (r.remove = [], n.forEach(function (e) {
          r.remove.push({
            id: e
          });
        }));
        return r;
      }(0, t);
    }, t.patchURL = function (e, t) {
      var n = e.config;
      return "/v1/objects/".concat(n.subscribeKey, "/users/").concat(o.default.encodeString(t.userId), "/spaces");
    }, t.prepareParams = function (e, t) {
      var n = t.include,
        r = t.limit,
        i = t.page,
        o = {};
      r && (o.limit = r);
      if (n) {
        var a = [];
        n.totalCount && (o.count = !0), n.customFields && a.push("custom"), n.spaceFields && a.push("space"), n.customSpaceFields && a.push("space.custom");
        var u = a.join(",");
        u.length > 0 && (o.include = u);
      }
      i && (i.next && (o.start = i.next), i.prev && (o.end = i.prev));
      return o;
    }, t.usePatch = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = t.userId,
        r = t.spaces;
      if (!n) return "Missing userId";
      if (!r) return "Missing spaces";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNAccessManagerAudit;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e) {
      var t = e.config;
      return "/v2/auth/audit/sub-key/".concat(t.subscribeKey);
    }, t.handleResponse = function (e, t) {
      return t.payload;
    }, t.isAuthSupported = function () {
      return !1;
    }, t.prepareParams = function (e, t) {
      var n = t.channel,
        r = t.channelGroup,
        i = t.authKeys,
        o = void 0 === i ? [] : i,
        a = {};
      n && (a.channel = n);
      r && (a["channel-group"] = r);
      o.length > 0 && (a.auth = o.join(","));
      return a;
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNAccessManagerGrant;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e) {
      var t = e.config;
      return "/v2/auth/grant/sub-key/".concat(t.subscribeKey);
    }, t.handleResponse = function () {
      return {};
    }, t.isAuthSupported = function () {
      return !1;
    }, t.prepareParams = function (e, t) {
      var n = t.channels,
        r = void 0 === n ? [] : n,
        i = t.channelGroups,
        o = void 0 === i ? [] : i,
        a = t.uuids,
        u = void 0 === a ? [] : a,
        s = t.ttl,
        c = t.read,
        l = void 0 !== c && c,
        f = t.write,
        d = void 0 !== f && f,
        p = t.manage,
        h = void 0 !== p && p,
        y = t.get,
        g = void 0 !== y && y,
        v = t.join,
        b = void 0 !== v && v,
        m = t.update,
        _ = void 0 !== m && m,
        P = t.authKeys,
        O = void 0 === P ? [] : P,
        S = t.delete,
        w = {};
      w.r = l ? "1" : "0", w.w = d ? "1" : "0", w.m = h ? "1" : "0", w.d = S ? "1" : "0", w.g = g ? "1" : "0", w.j = b ? "1" : "0", w.u = _ ? "1" : "0", r.length > 0 && (w.channel = r.join(","));
      o.length > 0 && (w["channel-group"] = o.join(","));
      O.length > 0 && (w.auth = O.join(","));
      u.length > 0 && (w["target-uuid"] = u.join(","));
      (s || 0 === s) && (w.ttl = s);
      return w;
    }, t.validateParams = function (e, t) {
      var n = e.config;
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (!n.publishKey) return "Missing Publish Key";
      if (!n.secretKey) return "Missing Secret Key";
      if (null != t.uuids && !t.authKeys) return "authKeys are required for grant request on uuids";
      if (null != t.uuids && (null != t.channels || null != t.channelGroups)) return "Both channel/channelgroup and uuid cannot be used in the same request";
    };
    n(2);
    var i = r(n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.extractPermissions = o, t.getOperation = function () {
      return i.default.PNAccessManagerGrantToken;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.handleResponse = function (e, t) {
      return t.data.token;
    }, t.isAuthSupported = function () {
      return !1;
    }, t.postPayload = function (e, t) {
      return function (e, t) {
        var n = t.ttl,
          r = t.resources,
          i = t.patterns,
          a = t.meta,
          u = t.authorized_uuid,
          s = {
            ttl: 0,
            permissions: {
              resources: {
                channels: {},
                groups: {},
                uuids: {},
                users: {},
                spaces: {}
              },
              patterns: {
                channels: {},
                groups: {},
                uuids: {},
                users: {},
                spaces: {}
              },
              meta: {}
            }
          };
        if (r) {
          var c = r.uuids,
            l = r.channels,
            f = r.groups;
          c && Object.keys(c).forEach(function (e) {
            s.permissions.resources.uuids[e] = o(c[e]);
          }), l && Object.keys(l).forEach(function (e) {
            s.permissions.resources.channels[e] = o(l[e]);
          }), f && Object.keys(f).forEach(function (e) {
            s.permissions.resources.groups[e] = o(f[e]);
          });
        }
        if (i) {
          var d = i.uuids,
            p = i.channels,
            h = i.groups;
          d && Object.keys(d).forEach(function (e) {
            s.permissions.patterns.uuids[e] = o(d[e]);
          }), p && Object.keys(p).forEach(function (e) {
            s.permissions.patterns.channels[e] = o(p[e]);
          }), h && Object.keys(h).forEach(function (e) {
            s.permissions.patterns.groups[e] = o(h[e]);
          });
        }
        (n || 0 === n) && (s.ttl = n);
        a && (s.permissions.meta = a);
        u && (s.permissions.uuid = "".concat(u));
        return s;
      }(0, t);
    }, t.postURL = function (e) {
      var t = e.config;
      return "/v3/pam/".concat(t.subscribeKey, "/grant");
    }, t.prepareParams = function () {
      return {};
    }, t.usePost = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = e.config;
      if (!n.subscribeKey) return "Missing Subscribe Key";
      if (!n.publishKey) return "Missing Publish Key";
      if (!n.secretKey) return "Missing Secret Key";
      if (!t.resources && !t.patterns) return "Missing either Resources or Patterns.";
      if (t.resources && (!t.resources.uuids || 0 === Object.keys(t.resources.uuids).length) && (!t.resources.channels || 0 === Object.keys(t.resources.channels).length) && (!t.resources.groups || 0 === Object.keys(t.resources.groups).length) || t.patterns && (!t.patterns.uuids || 0 === Object.keys(t.patterns.uuids).length) && (!t.patterns.channels || 0 === Object.keys(t.patterns.channels).length) && (!t.patterns.groups || 0 === Object.keys(t.patterns.groups).length)) return "Missing values for either Resources or Patterns.";
    };
    n(2);
    var i = r(n(1));
    function o(e) {
      var t = 0;
      return e.join && (t |= 128), e.update && (t |= 64), e.get && (t |= 32), e.delete && (t |= 8), e.manage && (t |= 4), e.write && (t |= 2), e.read && (t |= 1), t;
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(1)),
      o = r(n(3)),
      a = {
        getOperation: function getOperation() {
          return i.default.PNAccessManagerRevokeToken;
        },
        validateParams: function validateParams(e, t) {
          return e.config.secretKey ? t ? void 0 : "token can't be empty" : "Missing Secret Key";
        },
        getURL: function getURL(e, t) {
          var n = e.config;
          return "/v3/pam/".concat(n.subscribeKey, "/grant/").concat(o.default.encodeString(t));
        },
        useDelete: function useDelete() {
          return !0;
        },
        getRequestTimeout: function getRequestTimeout(e) {
          return e.config.getTransactionTimeout();
        },
        isAuthSupported: function isAuthSupported() {
          return !1;
        },
        prepareParams: function prepareParams(e) {
          return {
            uuid: e.config.getUUID()
          };
        },
        handleResponse: function handleResponse(e, t) {
          return {
            status: t.status,
            data: t.data
          };
        }
      };
    t.default = a, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return o.default.PNPublishOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channel,
        i = t.message,
        o = u(e, i);
      return "/publish/".concat(n.publishKey, "/").concat(n.subscribeKey, "/0/").concat(a.default.encodeString(r), "/0/").concat(a.default.encodeString(o));
    }, t.handleResponse = function (e, t) {
      return {
        timetoken: t[2]
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.postPayload = function (e, t) {
      var n = t.message;
      return u(e, n);
    }, t.postURL = function (e, t) {
      var n = e.config,
        r = t.channel;
      return "/publish/".concat(n.publishKey, "/").concat(n.subscribeKey, "/0/").concat(a.default.encodeString(r), "/0");
    }, t.prepareParams = function (e, t) {
      var n = t.meta,
        r = t.replicate,
        o = void 0 === r || r,
        a = t.storeInHistory,
        u = t.ttl,
        s = {};
      null != a && (s.store = a ? "1" : "0");
      u && (s.ttl = u);
      !1 === o && (s.norep = "true");
      n && "object" === (0, i.default)(n) && (s.meta = JSON.stringify(n));
      return s;
    }, t.usePost = function (e, t) {
      var n = t.sendByPost;
      return void 0 !== n && n;
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.message;
      if (!t.channel) return "Missing Channel";
      if (!r) return "Missing Message";
      if (!n.subscribeKey) return "Missing Subscribe Key";
    };
    var i = r(n(7)),
      o = (n(2), r(n(1))),
      a = r(n(3));
    function u(e, t) {
      var n = e.crypto,
        r = e.config,
        i = JSON.stringify(t);
      return r.cipherKey && (i = n.encrypt(i), i = JSON.stringify(i)), i;
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNSignalOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channel,
        i = t.message,
        a = (u = i, JSON.stringify(u));
      var u;
      return "/signal/".concat(n.publishKey, "/").concat(n.subscribeKey, "/0/").concat(o.default.encodeString(r), "/0/").concat(o.default.encodeString(a));
    }, t.handleResponse = function (e, t) {
      return {
        timetoken: t[2]
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function () {
      return {};
    }, t.validateParams = function (e, t) {
      var n = e.config,
        r = t.message;
      if (!t.channel) return "Missing Channel";
      if (!r) return "Missing Message";
      if (!n.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNHistoryOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channel,
        r = e.config;
      return "/v2/history/sub-key/".concat(r.subscribeKey, "/channel/").concat(o.default.encodeString(n));
    }, t.handleResponse = function (e, t) {
      var n = {
        messages: [],
        startTimeToken: t[1],
        endTimeToken: t[2]
      };
      Array.isArray(t[0]) && t[0].forEach(function (t) {
        var r = {
          timetoken: t.timetoken,
          entry: a(e, t.message)
        };
        t.meta && (r.meta = t.meta), n.messages.push(r);
      });
      return n;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.start,
        r = t.end,
        i = t.reverse,
        o = t.count,
        a = void 0 === o ? 100 : o,
        u = t.stringifiedTimeToken,
        s = void 0 !== u && u,
        c = t.includeMeta,
        l = void 0 !== c && c,
        f = {
          include_token: "true"
        };
      f.count = a, n && (f.start = n);
      r && (f.end = r);
      s && (f.string_message_token = "true");
      null != i && (f.reverse = i.toString());
      l && (f.include_meta = "true");
      return f;
    }, t.validateParams = function (e, t) {
      var n = t.channel,
        r = e.config;
      if (!n) return "Missing channel";
      if (!r.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
    function a(e, t) {
      var n = e.config,
        r = e.crypto;
      if (!n.cipherKey) return t;
      try {
        return r.decrypt(t);
      } catch (e) {
        return t;
      }
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNDeleteMessagesOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channel,
        r = e.config;
      return "/v3/history/sub-key/".concat(r.subscribeKey, "/channel/").concat(o.default.encodeString(n));
    }, t.handleResponse = function (e, t) {
      return t.payload;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.start,
        r = t.end,
        i = {};
      n && (i.start = n);
      r && (i.end = r);
      return i;
    }, t.useDelete = function () {
      return !0;
    }, t.validateParams = function (e, t) {
      var n = t.channel,
        r = e.config;
      if (!n) return "Missing channel";
      if (!r.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return o.default.PNMessageCounts;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channels,
        r = e.config,
        i = n.join(",");
      return "/v3/history/sub-key/".concat(r.subscribeKey, "/message-counts/").concat(a.default.encodeString(i));
    }, t.handleResponse = function (e, t) {
      return {
        channels: t.channels
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.timetoken,
        r = t.channelTimetokens,
        o = {};
      if (r && 1 === r.length) {
        var a = (0, i.default)(r, 1)[0];
        o.timetoken = a;
      } else r ? o.channelsTimetoken = r.join(",") : n && (o.timetoken = n);
      return o;
    }, t.validateParams = function (e, t) {
      var n = t.channels,
        r = t.timetoken,
        i = t.channelTimetokens,
        o = e.config;
      if (!n) return "Missing channel";
      if (r && i) return "timetoken and channelTimetokens are incompatible together";
      if (r && i && i.length > 1 && n.length !== i.length) return "Length of channelTimetokens and channels do not match";
      if (!o.subscribeKey) return "Missing Subscribe Key";
    };
    var i = r(n(9)),
      o = r(n(1)),
      a = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNFetchMessagesOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getTransactionTimeout();
    }, t.getURL = function (e, t) {
      var n = t.channels,
        r = void 0 === n ? [] : n,
        i = t.includeMessageActions,
        a = void 0 !== i && i,
        u = e.config,
        s = a ? "history-with-actions" : "history",
        c = r.length > 0 ? r.join(",") : ",";
      return "/v3/".concat(s, "/sub-key/").concat(u.subscribeKey, "/channel/").concat(o.default.encodeString(c));
    }, t.handleResponse = function (e, t) {
      var n = {
        channels: {}
      };
      Object.keys(t.channels || {}).forEach(function (r) {
        n.channels[r] = [], (t.channels[r] || []).forEach(function (t) {
          var i = {};
          i.channel = r, i.timetoken = t.timetoken, i.message = function (e, t) {
            var n = e.config,
              r = e.crypto;
            if (!n.cipherKey) return t;
            try {
              return r.decrypt(t);
            } catch (e) {
              return t;
            }
          }(e, t.message), i.messageType = t.message_type, i.uuid = t.uuid, t.actions && (i.actions = t.actions, i.data = t.actions), t.meta && (i.meta = t.meta), n.channels[r].push(i);
        });
      }), t.more && (n.more = t.more);
      return n;
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = t.channels,
        r = t.start,
        i = t.end,
        o = t.includeMessageActions,
        a = t.count,
        u = t.stringifiedTimeToken,
        s = void 0 !== u && u,
        c = t.includeMeta,
        l = void 0 !== c && c,
        f = t.includeUuid,
        d = t.includeUUID,
        p = void 0 === d || d,
        h = t.includeMessageType,
        y = void 0 === h || h,
        g = {};
      g.max = a || (n.length > 1 || !0 === o ? 25 : 100);
      r && (g.start = r);
      i && (g.end = i);
      s && (g.string_message_token = "true");
      l && (g.include_meta = "true");
      p && !1 !== f && (g.include_uuid = "true");
      y && (g.include_message_type = "true");
      return g;
    }, t.validateParams = function (e, t) {
      var n = t.channels,
        r = t.includeMessageActions,
        i = void 0 !== r && r,
        o = e.config;
      if (!n || 0 === n.length) return "Missing channels";
      if (!o.subscribeKey) return "Missing Subscribe Key";
      if (i && n.length > 1) throw new TypeError("History can return actions data for a single channel only. Either pass a single channel or disable the includeMessageActions flag.");
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getOperation = function () {
      return i.default.PNSubscribeOperation;
    }, t.getRequestTimeout = function (e) {
      return e.config.getSubscribeTimeout();
    }, t.getURL = function (e, t) {
      var n = e.config,
        r = t.channels,
        i = void 0 === r ? [] : r,
        a = i.length > 0 ? i.join(",") : ",";
      return "/v2/subscribe/".concat(n.subscribeKey, "/").concat(o.default.encodeString(a), "/0");
    }, t.handleResponse = function (e, t) {
      var n = [];
      t.m.forEach(function (e) {
        var t = {
            publishTimetoken: e.p.t,
            region: e.p.r
          },
          r = {
            shard: parseInt(e.a, 10),
            subscriptionMatch: e.b,
            channel: e.c,
            messageType: e.e,
            payload: e.d,
            flags: e.f,
            issuingClientId: e.i,
            subscribeKey: e.k,
            originationTimetoken: e.o,
            userMetadata: e.u,
            publishMetaData: t
          };
        n.push(r);
      });
      var r = {
        timetoken: t.t.t,
        region: t.t.r
      };
      return {
        messages: n,
        metadata: r
      };
    }, t.isAuthSupported = function () {
      return !0;
    }, t.prepareParams = function (e, t) {
      var n = e.config,
        r = t.state,
        i = t.channelGroups,
        o = void 0 === i ? [] : i,
        a = t.timetoken,
        u = t.filterExpression,
        s = t.region,
        c = {
          heartbeat: n.getPresenceTimeout()
        };
      o.length > 0 && (c["channel-group"] = o.join(","));
      u && u.length > 0 && (c["filter-expr"] = u);
      Object.keys(r).length && (c.state = JSON.stringify(r));
      a && (c.tt = a);
      s && (c.tr = s);
      return c;
    }, t.validateParams = function (e) {
      if (!e.config.subscribeKey) return "Missing Subscribe Key";
    };
    n(2);
    var i = r(n(1)),
      o = r(n(3));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(5)),
      o = r(n(6)),
      a = r(n(4)),
      u = (r(n(8)), r(n(10))),
      s = (n(2), function () {
        function e(t) {
          var n = this;
          (0, i.default)(this, e), (0, a.default)(this, "_modules", void 0), (0, a.default)(this, "_config", void 0), (0, a.default)(this, "_currentSubDomain", void 0), (0, a.default)(this, "_standardOrigin", void 0), (0, a.default)(this, "_subscribeOrigin", void 0), (0, a.default)(this, "_requestTimeout", void 0), (0, a.default)(this, "_coreParams", void 0), this._modules = {}, Object.keys(t).forEach(function (e) {
            n._modules[e] = t[e].bind(n);
          });
        }
        return (0, o.default)(e, [{
          key: "init",
          value: function value(e) {
            this._config = e, Array.isArray(this._config.origin) ? this._currentSubDomain = Math.floor(Math.random() * this._config.origin.length) : this._currentSubDomain = 0, this._coreParams = {}, this.shiftStandardOrigin();
          }
        }, {
          key: "nextOrigin",
          value: function value() {
            var e = this._config.secure ? "https://" : "http://";
            if ("string" == typeof this._config.origin) return "".concat(e).concat(this._config.origin);
            this._currentSubDomain += 1, this._currentSubDomain >= this._config.origin.length && (this._currentSubDomain = 0);
            var t = this._config.origin[this._currentSubDomain];
            return "".concat(e).concat(t);
          }
        }, {
          key: "hasModule",
          value: function value(e) {
            return e in this._modules;
          }
        }, {
          key: "shiftStandardOrigin",
          value: function value() {
            return this._standardOrigin = this.nextOrigin(), this._standardOrigin;
          }
        }, {
          key: "getStandardOrigin",
          value: function value() {
            return this._standardOrigin;
          }
        }, {
          key: "POSTFILE",
          value: function value(e, t, n) {
            return this._modules.postfile(e, t, n);
          }
        }, {
          key: "GETFILE",
          value: function value(e, t, n) {
            return this._modules.getfile(e, t, n);
          }
        }, {
          key: "POST",
          value: function value(e, t, n, r) {
            return this._modules.post(e, t, n, r);
          }
        }, {
          key: "PATCH",
          value: function value(e, t, n, r) {
            return this._modules.patch(e, t, n, r);
          }
        }, {
          key: "GET",
          value: function value(e, t, n) {
            return this._modules.get(e, t, n);
          }
        }, {
          key: "DELETE",
          value: function value(e, t, n) {
            return this._modules.del(e, t, n);
          }
        }, {
          key: "_detectErrorCategory",
          value: function value(e) {
            if ("ENOTFOUND" === e.code) return u.default.PNNetworkIssuesCategory;
            if ("ECONNREFUSED" === e.code) return u.default.PNNetworkIssuesCategory;
            if ("ECONNRESET" === e.code) return u.default.PNNetworkIssuesCategory;
            if ("EAI_AGAIN" === e.code) return u.default.PNNetworkIssuesCategory;
            if (0 === e.status || e.hasOwnProperty("status") && void 0 === e.status) return u.default.PNNetworkIssuesCategory;
            if (e.timeout) return u.default.PNTimeoutCategory;
            if ("ETIMEDOUT" === e.code) return u.default.PNNetworkIssuesCategory;
            if (e.response) {
              if (e.response.badRequest) return u.default.PNBadRequestCategory;
              if (e.response.forbidden) return u.default.PNAccessDeniedCategory;
            }
            return u.default.PNUnknownCategory;
          }
        }]), e;
      }());
    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = {
      get: function get(e) {
        try {
          return localStorage.getItem(e);
        } catch (e) {
          return null;
        }
      },
      set: function set(e, t) {
        try {
          return localStorage.setItem(e, t);
        } catch (e) {
          return null;
        }
      }
    };
    t.default = r, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = r(n(7)),
      o = r(n(5)),
      a = r(n(6)),
      u = r(n(4)),
      s = function () {
        function e(t, n) {
          (0, o.default)(this, e), (0, u.default)(this, "_base64ToBinary", void 0), (0, u.default)(this, "_cborReader", void 0), this._base64ToBinary = n, this._decode = t;
        }
        return (0, a.default)(e, [{
          key: "decodeToken",
          value: function value(e) {
            var t = "";
            e.length % 4 == 3 ? t = "=" : e.length % 4 == 2 && (t = "==");
            var n = e.replace(/-/gi, "+").replace(/_/gi, "/") + t,
              r = this._decode(this._base64ToBinary(n));
            if ("object" === (0, i.default)(r)) return r;
          }
        }]), e;
      }();
    t.default = s, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.del = function (e, t, n) {
      var r = a.default.delete(this.getStandardOrigin() + t.url).set(t.headers).query(e);
      return s.call(this, r, t, n);
    }, t.get = function (e, t, n) {
      var r = a.default.get(this.getStandardOrigin() + t.url).set(t.headers).query(e);
      return s.call(this, r, t, n);
    }, t.getfile = function (e, t, n) {
      var r = a.default.get(this.getStandardOrigin() + t.url).set(t.headers).query(e);
      return s.call(this, r, t, n);
    }, t.patch = function (e, t, n, r) {
      var i = a.default.patch(this.getStandardOrigin() + n.url).query(e).set(n.headers).send(t);
      return s.call(this, i, n, r);
    }, t.post = function (e, t, n, r) {
      var i = a.default.post(this.getStandardOrigin() + n.url).query(e).set(n.headers).send(t);
      return s.call(this, i, n, r);
    }, t.postfile = function (e, t, n) {
      return c.apply(this, arguments);
    };
    var i = r(n(11)),
      o = r(n(12)),
      a = r(n(129));
    n(2);
    function u(e) {
      var t = new Date().getTime(),
        n = new Date().toISOString(),
        r = console && console.log ? console : window && window.console && window.console.log ? window.console : console;
      r.log("<<<<<"), r.log("[".concat(n, "]"), "\n", e.url, "\n", e.qs), r.log("-----"), e.on("response", function (n) {
        var i = new Date().getTime() - t,
          o = new Date().toISOString();
        r.log(">>>>>>"), r.log("[".concat(o, " / ").concat(i, "]"), "\n", e.url, "\n", e.qs, "\n", n.text), r.log("-----");
      });
    }
    function s(e, t, n) {
      var r = this;
      this._config.logVerbosity && (e = e.use(u)), this._config.proxy && this._modules.proxy && (e = this._modules.proxy.call(this, e)), this._config.keepAlive && this._modules.keepAlive && (e = this._modules.keepAlive(e));
      var i = e;
      return !0 === t.forceBuffered ? i = "undefined" == typeof Blob ? i.buffer().responseType("arraybuffer") : i.responseType("arraybuffer") : !1 === t.forceBuffered && (i = i.buffer(!1)), (i = i.timeout(t.timeout)).end(function (e, i) {
        var o,
          a = {};
        if (a.error = null !== e, a.operation = t.operation, i && i.status && (a.statusCode = i.status), e) {
          if (e.response && e.response.text && !r._config.logVerbosity) try {
            a.errorData = JSON.parse(e.response.text);
          } catch (t) {
            a.errorData = e;
          } else a.errorData = e;
          return a.category = r._detectErrorCategory(e), n(a, null);
        }
        if (t.ignoreBody) o = {
          headers: i.headers,
          redirects: i.redirects,
          response: i
        };else try {
          o = JSON.parse(i.text);
        } catch (e) {
          return a.errorData = i, a.error = !0, n(a, null);
        }
        return o.error && 1 === o.error && o.status && o.message && o.service ? (a.errorData = o, a.statusCode = o.status, a.error = !0, a.category = r._detectErrorCategory(a), n(a, null)) : (o.error && o.error.message && (a.errorData = o.error), n(a, o));
      }), i;
    }
    function c() {
      return (c = (0, o.default)(i.default.mark(function e(t, n, r) {
        var o, u;
        return i.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return o = a.default.post(t), n.forEach(function (e) {
                  var t = e.key,
                    n = e.value;
                  o = o.field(t, n);
                }), o.attach("file", r, {
                  contentType: "application/octet-stream"
                }), e.next = 5, o;
              case 5:
                return u = e.sent, e.abrupt("return", u);
              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))).apply(this, arguments);
    }
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    var i;
    "undefined" != typeof window ? i = window : "undefined" == typeof self ? (console.warn("Using browser-only version of superagent in non-browser environment"), i = void 0) : i = self;
    var o = n(130),
      a = n(131),
      u = n(132),
      s = n(144),
      c = n(30),
      l = n(145),
      f = n(147);
    function d() {}
    e.exports = function (e, n) {
      return "function" == typeof n ? new t.Request("GET", e).end(n) : 1 === arguments.length ? new t.Request("GET", e) : new t.Request(e, n);
    };
    var p = t = e.exports;
    t.Request = _, p.getXHR = function () {
      if (i.XMLHttpRequest && (!i.location || "file:" !== i.location.protocol || !i.ActiveXObject)) return new XMLHttpRequest();
      try {
        return new ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {}
      try {
        return new ActiveXObject("Msxml2.XMLHTTP.6.0");
      } catch (e) {}
      try {
        return new ActiveXObject("Msxml2.XMLHTTP.3.0");
      } catch (e) {}
      try {
        return new ActiveXObject("Msxml2.XMLHTTP");
      } catch (e) {}
      throw new Error("Browser-only version of superagent could not find XHR");
    };
    var h = "".trim ? function (e) {
      return e.trim();
    } : function (e) {
      return e.replace(/(^\s*|\s*$)/g, "");
    };
    function y(e) {
      if (!c(e)) return e;
      var t = [];
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && g(t, n, e[n]);
      }
      return t.join("&");
    }
    function g(e, t, n) {
      if (void 0 !== n) if (null !== n) {
        if (Array.isArray(n)) n.forEach(function (n) {
          g(e, t, n);
        });else if (c(n)) for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && g(e, "".concat(t, "[").concat(r, "]"), n[r]);
        } else e.push(encodeURI(t) + "=" + encodeURIComponent(n));
      } else e.push(encodeURI(t));
    }
    function v(e) {
      for (var t, n, r = {}, i = e.split("&"), o = 0, a = i.length; o < a; ++o) {
        -1 === (n = (t = i[o]).indexOf("=")) ? r[decodeURIComponent(t)] = "" : r[decodeURIComponent(t.slice(0, n))] = decodeURIComponent(t.slice(n + 1));
      }
      return r;
    }
    function b(e) {
      return /[/+]json($|[^-\w])/i.test(e);
    }
    function m(e) {
      this.req = e, this.xhr = this.req.xhr, this.text = "HEAD" !== this.req.method && ("" === this.xhr.responseType || "text" === this.xhr.responseType) || void 0 === this.xhr.responseType ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText;
      var t = this.xhr.status;
      1223 === t && (t = 204), this._setStatusProperties(t), this.headers = function (e) {
        for (var t, n, r, i, o = e.split(/\r?\n/), a = {}, u = 0, s = o.length; u < s; ++u) {
          -1 !== (t = (n = o[u]).indexOf(":")) && (r = n.slice(0, t).toLowerCase(), i = h(n.slice(t + 1)), a[r] = i);
        }
        return a;
      }(this.xhr.getAllResponseHeaders()), this.header = this.headers, this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this._setHeaderProperties(this.header), null === this.text && e._responseType ? this.body = this.xhr.response : this.body = "HEAD" === this.req.method ? null : this._parseBody(this.text ? this.text : this.xhr.response);
    }
    function _(e, t) {
      var n = this;
      this._query = this._query || [], this.method = e, this.url = t, this.header = {}, this._header = {}, this.on("end", function () {
        var e,
          t = null,
          r = null;
        try {
          r = new m(n);
        } catch (e) {
          return (t = new Error("Parser is unable to parse the response")).parse = !0, t.original = e, n.xhr ? (t.rawResponse = void 0 === n.xhr.responseType ? n.xhr.responseText : n.xhr.response, t.status = n.xhr.status ? n.xhr.status : null, t.statusCode = t.status) : (t.rawResponse = null, t.status = null), n.callback(t);
        }
        n.emit("response", r);
        try {
          n._isResponseOK(r) || (e = new Error(r.statusText || r.text || "Unsuccessful HTTP response"));
        } catch (t) {
          e = t;
        }
        e ? (e.original = t, e.response = r, e.status = r.status, n.callback(e, r)) : n.callback(null, r);
      });
    }
    function P(e, t, n) {
      var r = p("DELETE", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }
    p.serializeObject = y, p.parseString = v, p.types = {
      html: "text/html",
      json: "application/json",
      xml: "text/xml",
      urlencoded: "application/x-www-form-urlencoded",
      form: "application/x-www-form-urlencoded",
      "form-data": "application/x-www-form-urlencoded"
    }, p.serialize = {
      "application/x-www-form-urlencoded": u.stringify,
      "application/json": a
    }, p.parse = {
      "application/x-www-form-urlencoded": v,
      "application/json": JSON.parse
    }, l(m.prototype), m.prototype._parseBody = function (e) {
      var t = p.parse[this.type];
      return this.req._parser ? this.req._parser(this, e) : (!t && b(this.type) && (t = p.parse["application/json"]), t && e && (e.length > 0 || e instanceof Object) ? t(e) : null);
    }, m.prototype.toError = function () {
      var e = this.req,
        t = e.method,
        n = e.url,
        r = "cannot ".concat(t, " ").concat(n, " (").concat(this.status, ")"),
        i = new Error(r);
      return i.status = this.status, i.method = t, i.url = n, i;
    }, p.Response = m, o(_.prototype), s(_.prototype), _.prototype.type = function (e) {
      return this.set("Content-Type", p.types[e] || e), this;
    }, _.prototype.accept = function (e) {
      return this.set("Accept", p.types[e] || e), this;
    }, _.prototype.auth = function (e, t, n) {
      1 === arguments.length && (t = ""), "object" === r(t) && null !== t && (n = t, t = ""), n || (n = {
        type: "function" == typeof btoa ? "basic" : "auto"
      });
      var i = function i(e) {
        if ("function" == typeof btoa) return btoa(e);
        throw new Error("Cannot use basic auth, btoa is not a function");
      };
      return this._auth(e, t, n, i);
    }, _.prototype.query = function (e) {
      return "string" != typeof e && (e = y(e)), e && this._query.push(e), this;
    }, _.prototype.attach = function (e, t, n) {
      if (t) {
        if (this._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(e, t, n || t.name);
      }
      return this;
    }, _.prototype._getFormData = function () {
      return this._formData || (this._formData = new i.FormData()), this._formData;
    }, _.prototype.callback = function (e, t) {
      if (this._shouldRetry(e, t)) return this._retry();
      var n = this._callback;
      this.clearTimeout(), e && (this._maxRetries && (e.retries = this._retries - 1), this.emit("error", e)), n(e, t);
    }, _.prototype.crossDomainError = function () {
      var e = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
      e.crossDomain = !0, e.status = this.status, e.method = this.method, e.url = this.url, this.callback(e);
    }, _.prototype.agent = function () {
      return console.warn("This is not supported in browser version of superagent"), this;
    }, _.prototype.ca = _.prototype.agent, _.prototype.buffer = _.prototype.ca, _.prototype.write = function () {
      throw new Error("Streaming is not supported in browser version of superagent");
    }, _.prototype.pipe = _.prototype.write, _.prototype._isHost = function (e) {
      return e && "object" === r(e) && !Array.isArray(e) && "[object Object]" !== Object.prototype.toString.call(e);
    }, _.prototype.end = function (e) {
      this._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), this._endCalled = !0, this._callback = e || d, this._finalizeQueryString(), this._end();
    }, _.prototype._setUploadTimeout = function () {
      var e = this;
      this._uploadTimeout && !this._uploadTimeoutTimer && (this._uploadTimeoutTimer = setTimeout(function () {
        e._timeoutError("Upload timeout of ", e._uploadTimeout, "ETIMEDOUT");
      }, this._uploadTimeout));
    }, _.prototype._end = function () {
      if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
      var e = this;
      this.xhr = p.getXHR();
      var t = this.xhr,
        n = this._formData || this._data;
      this._setTimeouts(), t.onreadystatechange = function () {
        var n = t.readyState;
        if (n >= 2 && e._responseTimeoutTimer && clearTimeout(e._responseTimeoutTimer), 4 === n) {
          var r;
          try {
            r = t.status;
          } catch (e) {
            r = 0;
          }
          if (!r) {
            if (e.timedout || e._aborted) return;
            return e.crossDomainError();
          }
          e.emit("end");
        }
      };
      var r = function r(t, n) {
        n.total > 0 && (n.percent = n.loaded / n.total * 100, 100 === n.percent && clearTimeout(e._uploadTimeoutTimer)), n.direction = t, e.emit("progress", n);
      };
      if (this.hasListeners("progress")) try {
        t.addEventListener("progress", r.bind(null, "download")), t.upload && t.upload.addEventListener("progress", r.bind(null, "upload"));
      } catch (e) {}
      t.upload && this._setUploadTimeout();
      try {
        this.username && this.password ? t.open(this.method, this.url, !0, this.username, this.password) : t.open(this.method, this.url, !0);
      } catch (e) {
        return this.callback(e);
      }
      if (this._withCredentials && (t.withCredentials = !0), !this._formData && "GET" !== this.method && "HEAD" !== this.method && "string" != typeof n && !this._isHost(n)) {
        var i = this._header["content-type"],
          o = this._serializer || p.serialize[i ? i.split(";")[0] : ""];
        !o && b(i) && (o = p.serialize["application/json"]), o && (n = o(n));
      }
      for (var a in this.header) {
        null !== this.header[a] && Object.prototype.hasOwnProperty.call(this.header, a) && t.setRequestHeader(a, this.header[a]);
      }
      this._responseType && (t.responseType = this._responseType), this.emit("request", this), t.send(void 0 === n ? null : n);
    }, p.agent = function () {
      return new f();
    }, ["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function (e) {
      f.prototype[e.toLowerCase()] = function (t, n) {
        var r = new p.Request(e, t);
        return this._setDefaults(r), n && r.end(n), r;
      };
    }), f.prototype.del = f.prototype.delete, p.get = function (e, t, n) {
      var r = p("GET", e);
      return "function" == typeof t && (n = t, t = null), t && r.query(t), n && r.end(n), r;
    }, p.head = function (e, t, n) {
      var r = p("HEAD", e);
      return "function" == typeof t && (n = t, t = null), t && r.query(t), n && r.end(n), r;
    }, p.options = function (e, t, n) {
      var r = p("OPTIONS", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }, p.del = P, p.delete = P, p.patch = function (e, t, n) {
      var r = p("PATCH", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }, p.post = function (e, t, n) {
      var r = p("POST", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    }, p.put = function (e, t, n) {
      var r = p("PUT", e);
      return "function" == typeof t && (n = t, t = null), t && r.send(t), n && r.end(n), r;
    };
  }, function (e, t, n) {
    function r(e) {
      if (e) return function (e) {
        for (var t in r.prototype) {
          e[t] = r.prototype[t];
        }
        return e;
      }(e);
    }
    e.exports = r, r.prototype.on = r.prototype.addEventListener = function (e, t) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
    }, r.prototype.once = function (e, t) {
      function n() {
        this.off(e, n), t.apply(this, arguments);
      }
      return n.fn = t, this.on(e, n), this;
    }, r.prototype.off = r.prototype.removeListener = r.prototype.removeAllListeners = r.prototype.removeEventListener = function (e, t) {
      if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
      var n,
        r = this._callbacks["$" + e];
      if (!r) return this;
      if (1 == arguments.length) return delete this._callbacks["$" + e], this;
      for (var i = 0; i < r.length; i++) {
        if ((n = r[i]) === t || n.fn === t) {
          r.splice(i, 1);
          break;
        }
      }
      return 0 === r.length && delete this._callbacks["$" + e], this;
    }, r.prototype.emit = function (e) {
      this._callbacks = this._callbacks || {};
      for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }
      if (n) {
        r = 0;
        for (var i = (n = n.slice(0)).length; r < i; ++r) {
          n[r].apply(this, t);
        }
      }
      return this;
    }, r.prototype.listeners = function (e) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
    }, r.prototype.hasListeners = function (e) {
      return !!this.listeners(e).length;
    };
  }, function (e, t) {
    e.exports = o, o.default = o, o.stable = s, o.stableStringify = s;
    var n = [],
      r = [];
    function i() {
      return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
      };
    }
    function o(e, t, o, u) {
      var s;
      void 0 === u && (u = i()), function e(t, n, r, i, o, u, s) {
        var c;
        if (u += 1, "object" == typeof t && null !== t) {
          for (c = 0; c < i.length; c++) {
            if (i[c] === t) return void a("[Circular]", t, n, o);
          }
          if (void 0 !== s.depthLimit && u > s.depthLimit) return void a("[...]", t, n, o);
          if (void 0 !== s.edgesLimit && r + 1 > s.edgesLimit) return void a("[...]", t, n, o);
          if (i.push(t), Array.isArray(t)) for (c = 0; c < t.length; c++) {
            e(t[c], c, c, i, t, u, s);
          } else {
            var l = Object.keys(t);
            for (c = 0; c < l.length; c++) {
              var f = l[c];
              e(t[f], f, c, i, t, u, s);
            }
          }
          i.pop();
        }
      }(e, "", 0, [], void 0, 0, u);
      try {
        s = 0 === r.length ? JSON.stringify(e, t, o) : JSON.stringify(e, c(t), o);
      } catch (e) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
      } finally {
        for (; 0 !== n.length;) {
          var l = n.pop();
          4 === l.length ? Object.defineProperty(l[0], l[1], l[3]) : l[0][l[1]] = l[2];
        }
      }
      return s;
    }
    function a(e, t, i, o) {
      var a = Object.getOwnPropertyDescriptor(o, i);
      void 0 !== a.get ? a.configurable ? (Object.defineProperty(o, i, {
        value: e
      }), n.push([o, i, t, a])) : r.push([t, i, e]) : (o[i] = e, n.push([o, i, t]));
    }
    function u(e, t) {
      return e < t ? -1 : e > t ? 1 : 0;
    }
    function s(e, t, o, s) {
      void 0 === s && (s = i());
      var l,
        f = function e(t, r, i, o, s, c, l) {
          var f;
          if (c += 1, "object" == typeof t && null !== t) {
            for (f = 0; f < o.length; f++) {
              if (o[f] === t) return void a("[Circular]", t, r, s);
            }
            try {
              if ("function" == typeof t.toJSON) return;
            } catch (e) {
              return;
            }
            if (void 0 !== l.depthLimit && c > l.depthLimit) return void a("[...]", t, r, s);
            if (void 0 !== l.edgesLimit && i + 1 > l.edgesLimit) return void a("[...]", t, r, s);
            if (o.push(t), Array.isArray(t)) for (f = 0; f < t.length; f++) {
              e(t[f], f, f, o, t, c, l);
            } else {
              var d = {},
                p = Object.keys(t).sort(u);
              for (f = 0; f < p.length; f++) {
                var h = p[f];
                e(t[h], h, f, o, t, c, l), d[h] = t[h];
              }
              if (void 0 === s) return d;
              n.push([s, r, t]), s[r] = d;
            }
            o.pop();
          }
        }(e, "", 0, [], void 0, 0, s) || e;
      try {
        l = 0 === r.length ? JSON.stringify(f, t, o) : JSON.stringify(f, c(t), o);
      } catch (e) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
      } finally {
        for (; 0 !== n.length;) {
          var d = n.pop();
          4 === d.length ? Object.defineProperty(d[0], d[1], d[3]) : d[0][d[1]] = d[2];
        }
      }
      return l;
    }
    function c(e) {
      return e = void 0 !== e ? e : function (e, t) {
        return t;
      }, function (t, n) {
        if (r.length > 0) for (var i = 0; i < r.length; i++) {
          var o = r[i];
          if (o[1] === t && o[0] === n) {
            n = o[2], r.splice(i, 1);
            break;
          }
        }
        return e.call(this, t, n);
      };
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(133),
      i = n(143),
      o = n(21);
    e.exports = {
      formats: o,
      parse: i,
      stringify: r
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(134),
      i = n(29),
      o = n(21),
      a = Object.prototype.hasOwnProperty,
      u = {
        brackets: function brackets(e) {
          return e + "[]";
        },
        comma: "comma",
        indices: function indices(e, t) {
          return e + "[" + t + "]";
        },
        repeat: function repeat(e) {
          return e;
        }
      },
      s = Array.isArray,
      c = String.prototype.split,
      l = Array.prototype.push,
      f = function f(e, t) {
        l.apply(e, s(t) ? t : [t]);
      },
      d = Date.prototype.toISOString,
      p = o.default,
      h = {
        addQueryPrefix: !1,
        allowDots: !1,
        charset: "utf-8",
        charsetSentinel: !1,
        delimiter: "&",
        encode: !0,
        encoder: i.encode,
        encodeValuesOnly: !1,
        format: p,
        formatter: o.formatters[p],
        indices: !1,
        serializeDate: function serializeDate(e) {
          return d.call(e);
        },
        skipNulls: !1,
        strictNullHandling: !1
      },
      y = {},
      g = function e(t, n, o, a, u, l, d, p, g, v, b, m, _, P, O) {
        for (var S, w = t, k = O, T = 0, x = !1; void 0 !== (k = k.get(y)) && !x;) {
          var A = k.get(t);
          if (T += 1, void 0 !== A) {
            if (A === T) throw new RangeError("Cyclic object value");
            x = !0;
          }
          void 0 === k.get(y) && (T = 0);
        }
        if ("function" == typeof d ? w = d(n, w) : w instanceof Date ? w = v(w) : "comma" === o && s(w) && (w = i.maybeMap(w, function (e) {
          return e instanceof Date ? v(e) : e;
        })), null === w) {
          if (a) return l && !_ ? l(n, h.encoder, P, "key", b) : n;
          w = "";
        }
        if ("string" == typeof (S = w) || "number" == typeof S || "boolean" == typeof S || "symbol" == typeof S || "bigint" == typeof S || i.isBuffer(w)) {
          if (l) {
            var M = _ ? n : l(n, h.encoder, P, "key", b);
            if ("comma" === o && _) {
              for (var E = c.call(String(w), ","), j = "", R = 0; R < E.length; ++R) {
                j += (0 === R ? "" : ",") + m(l(E[R], h.encoder, P, "value", b));
              }
              return [m(M) + "=" + j];
            }
            return [m(M) + "=" + m(l(w, h.encoder, P, "value", b))];
          }
          return [m(n) + "=" + m(String(w))];
        }
        var N,
          C = [];
        if (void 0 === w) return C;
        if ("comma" === o && s(w)) N = [{
          value: w.length > 0 ? w.join(",") || null : void 0
        }];else if (s(d)) N = d;else {
          var U = Object.keys(w);
          N = p ? U.sort(p) : U;
        }
        for (var I = 0; I < N.length; ++I) {
          var D = N[I],
            F = "object" == typeof D && void 0 !== D.value ? D.value : w[D];
          if (!u || null !== F) {
            var L = s(w) ? "function" == typeof o ? o(n, D) : n : n + (g ? "." + D : "[" + D + "]");
            O.set(t, T);
            var K = r();
            K.set(y, O), f(C, e(F, L, o, a, u, l, d, p, g, v, b, m, _, P, K));
          }
        }
        return C;
      };
    e.exports = function (e, t) {
      var n,
        i = e,
        c = function (e) {
          if (!e) return h;
          if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
          var t = e.charset || h.charset;
          if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
          var n = o.default;
          if (void 0 !== e.format) {
            if (!a.call(o.formatters, e.format)) throw new TypeError("Unknown format option provided.");
            n = e.format;
          }
          var r = o.formatters[n],
            i = h.filter;
          return ("function" == typeof e.filter || s(e.filter)) && (i = e.filter), {
            addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : h.addQueryPrefix,
            allowDots: void 0 === e.allowDots ? h.allowDots : !!e.allowDots,
            charset: t,
            charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : h.charsetSentinel,
            delimiter: void 0 === e.delimiter ? h.delimiter : e.delimiter,
            encode: "boolean" == typeof e.encode ? e.encode : h.encode,
            encoder: "function" == typeof e.encoder ? e.encoder : h.encoder,
            encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : h.encodeValuesOnly,
            filter: i,
            format: n,
            formatter: r,
            serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : h.serializeDate,
            skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : h.skipNulls,
            sort: "function" == typeof e.sort ? e.sort : null,
            strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : h.strictNullHandling
          };
        }(t);
      "function" == typeof c.filter ? i = (0, c.filter)("", i) : s(c.filter) && (n = c.filter);
      var l,
        d = [];
      if ("object" != typeof i || null === i) return "";
      l = t && t.arrayFormat in u ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices";
      var p = u[l];
      n || (n = Object.keys(i)), c.sort && n.sort(c.sort);
      for (var y = r(), v = 0; v < n.length; ++v) {
        var b = n[v];
        c.skipNulls && null === i[b] || f(d, g(i[b], b, p, c.strictNullHandling, c.skipNulls, c.encode ? c.encoder : null, c.filter, c.sort, c.allowDots, c.serializeDate, c.format, c.formatter, c.encodeValuesOnly, c.charset, y));
      }
      var m = d.join(c.delimiter),
        _ = !0 === c.addQueryPrefix ? "?" : "";
      return c.charsetSentinel && ("iso-8859-1" === c.charset ? _ += "utf8=%26%2310003%3B&" : _ += "utf8=%E2%9C%93&"), m.length > 0 ? _ + m : "";
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(19),
      i = n(139),
      o = n(141),
      a = r("%TypeError%"),
      u = r("%WeakMap%", !0),
      s = r("%Map%", !0),
      c = i("WeakMap.prototype.get", !0),
      l = i("WeakMap.prototype.set", !0),
      f = i("WeakMap.prototype.has", !0),
      d = i("Map.prototype.get", !0),
      p = i("Map.prototype.set", !0),
      h = i("Map.prototype.has", !0),
      y = function y(e, t) {
        for (var n, r = e; null !== (n = r.next); r = n) {
          if (n.key === t) return r.next = n.next, n.next = e.next, e.next = n, n;
        }
      };
    e.exports = function () {
      var e,
        t,
        n,
        r = {
          assert: function assert(e) {
            if (!r.has(e)) throw new a("Side channel does not contain " + o(e));
          },
          get: function get(r) {
            if (u && r && ("object" == typeof r || "function" == typeof r)) {
              if (e) return c(e, r);
            } else if (s) {
              if (t) return d(t, r);
            } else if (n) return function (e, t) {
              var n = y(e, t);
              return n && n.value;
            }(n, r);
          },
          has: function has(r) {
            if (u && r && ("object" == typeof r || "function" == typeof r)) {
              if (e) return f(e, r);
            } else if (s) {
              if (t) return h(t, r);
            } else if (n) return function (e, t) {
              return !!y(e, t);
            }(n, r);
            return !1;
          },
          set: function set(r, i) {
            u && r && ("object" == typeof r || "function" == typeof r) ? (e || (e = new u()), l(e, r, i)) : s ? (t || (t = new s()), p(t, r, i)) : (n || (n = {
              key: {},
              next: null
            }), function (e, t, n) {
              var r = y(e, t);
              r ? r.value = n : e.next = {
                key: t,
                next: e.next,
                value: n
              };
            }(n, r, i));
          }
        };
      return r;
    };
  }, function (e, t, n) {
    "use strict";

    var r = "undefined" != typeof Symbol && Symbol,
      i = n(136);
    e.exports = function () {
      return "function" == typeof r && "function" == typeof Symbol && "symbol" == typeof r("foo") && "symbol" == typeof Symbol("bar") && i();
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function () {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" == typeof Symbol.iterator) return !0;
      var e = {},
        t = Symbol("test"),
        n = Object(t);
      if ("string" == typeof t) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
      for (t in e[t] = 42, e) {
        return !1;
      }
      if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
      if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
      var r = Object.getOwnPropertySymbols(e);
      if (1 !== r.length || r[0] !== t) return !1;
      if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var i = Object.getOwnPropertyDescriptor(e, t);
        if (42 !== i.value || !0 !== i.enumerable) return !1;
      }
      return !0;
    };
  }, function (e, t, n) {
    "use strict";

    var r = "Function.prototype.bind called on incompatible ",
      i = Array.prototype.slice,
      o = Object.prototype.toString;
    e.exports = function (e) {
      var t = this;
      if ("function" != typeof t || "[object Function]" !== o.call(t)) throw new TypeError(r + t);
      for (var n, a = i.call(arguments, 1), u = function u() {
          if (this instanceof n) {
            var r = t.apply(this, a.concat(i.call(arguments)));
            return Object(r) === r ? r : this;
          }
          return t.apply(e, a.concat(i.call(arguments)));
        }, s = Math.max(0, t.length - a.length), c = [], l = 0; l < s; l++) {
        c.push("$" + l);
      }
      if (n = Function("binder", "return function (" + c.join(",") + "){ return binder.apply(this,arguments); }")(u), t.prototype) {
        var f = function f() {};
        f.prototype = t.prototype, n.prototype = new f(), f.prototype = null;
      }
      return n;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(20);
    e.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
  }, function (e, t, n) {
    "use strict";

    var r = n(19),
      i = n(140),
      o = i(r("String.prototype.indexOf"));
    e.exports = function (e, t) {
      var n = r(e, !!t);
      return "function" == typeof n && o(e, ".prototype.") > -1 ? i(n) : n;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(20),
      i = n(19),
      o = i("%Function.prototype.apply%"),
      a = i("%Function.prototype.call%"),
      u = i("%Reflect.apply%", !0) || r.call(a, o),
      s = i("%Object.getOwnPropertyDescriptor%", !0),
      c = i("%Object.defineProperty%", !0),
      l = i("%Math.max%");
    if (c) try {
      c({}, "a", {
        value: 1
      });
    } catch (e) {
      c = null;
    }
    e.exports = function (e) {
      var t = u(r, a, arguments);
      if (s && c) {
        var n = s(t, "length");
        n.configurable && c(t, "length", {
          value: 1 + l(0, e.length - (arguments.length - 1))
        });
      }
      return t;
    };
    var f = function f() {
      return u(r, o, arguments);
    };
    c ? c(e.exports, "apply", {
      value: f
    }) : e.exports.apply = f;
  }, function (e, t, n) {
    var r = "function" == typeof Map && Map.prototype,
      i = Object.getOwnPropertyDescriptor && r ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
      o = r && i && "function" == typeof i.get ? i.get : null,
      a = r && Map.prototype.forEach,
      u = "function" == typeof Set && Set.prototype,
      s = Object.getOwnPropertyDescriptor && u ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
      c = u && s && "function" == typeof s.get ? s.get : null,
      l = u && Set.prototype.forEach,
      f = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
      d = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
      p = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
      h = Boolean.prototype.valueOf,
      y = Object.prototype.toString,
      g = Function.prototype.toString,
      v = String.prototype.match,
      b = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
      m = Object.getOwnPropertySymbols,
      _ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null,
      P = "function" == typeof Symbol && "object" == typeof Symbol.iterator,
      O = "function" == typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === P || "symbol") ? Symbol.toStringTag : null,
      S = Object.prototype.propertyIsEnumerable,
      w = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (e) {
        return e.__proto__;
      } : null),
      k = n(142).custom,
      T = k && E(k) ? k : null;
    function x(e, t, n) {
      var r = "double" === (n.quoteStyle || t) ? '"' : "'";
      return r + e + r;
    }
    function A(e) {
      return String(e).replace(/"/g, "&quot;");
    }
    function M(e) {
      return !("[object Array]" !== N(e) || O && "object" == typeof e && O in e);
    }
    function E(e) {
      if (P) return e && "object" == typeof e && e instanceof Symbol;
      if ("symbol" == typeof e) return !0;
      if (!e || "object" != typeof e || !_) return !1;
      try {
        return _.call(e), !0;
      } catch (e) {}
      return !1;
    }
    e.exports = function e(t, n, r, i) {
      var u = n || {};
      if (R(u, "quoteStyle") && "single" !== u.quoteStyle && "double" !== u.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
      if (R(u, "maxStringLength") && ("number" == typeof u.maxStringLength ? u.maxStringLength < 0 && u.maxStringLength !== 1 / 0 : null !== u.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
      var s = !R(u, "customInspect") || u.customInspect;
      if ("boolean" != typeof s && "symbol" !== s) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
      if (R(u, "indent") && null !== u.indent && "\t" !== u.indent && !(parseInt(u.indent, 10) === u.indent && u.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
      if (void 0 === t) return "undefined";
      if (null === t) return "null";
      if ("boolean" == typeof t) return t ? "true" : "false";
      if ("string" == typeof t) return function e(t, n) {
        if (t.length > n.maxStringLength) {
          var r = t.length - n.maxStringLength,
            i = "... " + r + " more character" + (r > 1 ? "s" : "");
          return e(t.slice(0, n.maxStringLength), n) + i;
        }
        return x(t.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, U), "single", n);
      }(t, u);
      if ("number" == typeof t) return 0 === t ? 1 / 0 / t > 0 ? "0" : "-0" : String(t);
      if ("bigint" == typeof t) return String(t) + "n";
      var y = void 0 === u.depth ? 5 : u.depth;
      if (void 0 === r && (r = 0), r >= y && y > 0 && "object" == typeof t) return M(t) ? "[Array]" : "[Object]";
      var m = function (e, t) {
        var n;
        if ("\t" === e.indent) n = "\t";else {
          if (!("number" == typeof e.indent && e.indent > 0)) return null;
          n = Array(e.indent + 1).join(" ");
        }
        return {
          base: n,
          prev: Array(t + 1).join(n)
        };
      }(u, r);
      if (void 0 === i) i = [];else if (C(i, t) >= 0) return "[Circular]";
      function S(t, n, o) {
        if (n && (i = i.slice()).push(n), o) {
          var a = {
            depth: u.depth
          };
          return R(u, "quoteStyle") && (a.quoteStyle = u.quoteStyle), e(t, a, r + 1, i);
        }
        return e(t, u, r + 1, i);
      }
      if ("function" == typeof t) {
        var k = function (e) {
            if (e.name) return e.name;
            var t = v.call(g.call(e), /^function\s*([\w$]+)/);
            if (t) return t[1];
            return null;
          }(t),
          j = K(t, S);
        return "[Function" + (k ? ": " + k : " (anonymous)") + "]" + (j.length > 0 ? " { " + j.join(", ") + " }" : "");
      }
      if (E(t)) {
        var B = P ? String(t).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : _.call(t);
        return "object" != typeof t || P ? B : I(B);
      }
      if (function (e) {
        if (!e || "object" != typeof e) return !1;
        if ("undefined" != typeof HTMLElement && e instanceof HTMLElement) return !0;
        return "string" == typeof e.nodeName && "function" == typeof e.getAttribute;
      }(t)) {
        for (var G = "<" + String(t.nodeName).toLowerCase(), q = t.attributes || [], H = 0; H < q.length; H++) {
          G += " " + q[H].name + "=" + x(A(q[H].value), "double", u);
        }
        return G += ">", t.childNodes && t.childNodes.length && (G += "..."), G += "</" + String(t.nodeName).toLowerCase() + ">";
      }
      if (M(t)) {
        if (0 === t.length) return "[]";
        var z = K(t, S);
        return m && !function (e) {
          for (var t = 0; t < e.length; t++) {
            if (C(e[t], "\n") >= 0) return !1;
          }
          return !0;
        }(z) ? "[" + L(z, m) + "]" : "[ " + z.join(", ") + " ]";
      }
      if (function (e) {
        return !("[object Error]" !== N(e) || O && "object" == typeof e && O in e);
      }(t)) {
        var W = K(t, S);
        return 0 === W.length ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + W.join(", ") + " }";
      }
      if ("object" == typeof t && s) {
        if (T && "function" == typeof t[T]) return t[T]();
        if ("symbol" !== s && "function" == typeof t.inspect) return t.inspect();
      }
      if (function (e) {
        if (!o || !e || "object" != typeof e) return !1;
        try {
          o.call(e);
          try {
            c.call(e);
          } catch (e) {
            return !0;
          }
          return e instanceof Map;
        } catch (e) {}
        return !1;
      }(t)) {
        var V = [];
        return a.call(t, function (e, n) {
          V.push(S(n, t, !0) + " => " + S(e, t));
        }), F("Map", o.call(t), V, m);
      }
      if (function (e) {
        if (!c || !e || "object" != typeof e) return !1;
        try {
          c.call(e);
          try {
            o.call(e);
          } catch (e) {
            return !0;
          }
          return e instanceof Set;
        } catch (e) {}
        return !1;
      }(t)) {
        var Y = [];
        return l.call(t, function (e) {
          Y.push(S(e, t));
        }), F("Set", c.call(t), Y, m);
      }
      if (function (e) {
        if (!f || !e || "object" != typeof e) return !1;
        try {
          f.call(e, f);
          try {
            d.call(e, d);
          } catch (e) {
            return !0;
          }
          return e instanceof WeakMap;
        } catch (e) {}
        return !1;
      }(t)) return D("WeakMap");
      if (function (e) {
        if (!d || !e || "object" != typeof e) return !1;
        try {
          d.call(e, d);
          try {
            f.call(e, f);
          } catch (e) {
            return !0;
          }
          return e instanceof WeakSet;
        } catch (e) {}
        return !1;
      }(t)) return D("WeakSet");
      if (function (e) {
        if (!p || !e || "object" != typeof e) return !1;
        try {
          return p.call(e), !0;
        } catch (e) {}
        return !1;
      }(t)) return D("WeakRef");
      if (function (e) {
        return !("[object Number]" !== N(e) || O && "object" == typeof e && O in e);
      }(t)) return I(S(Number(t)));
      if (function (e) {
        if (!e || "object" != typeof e || !b) return !1;
        try {
          return b.call(e), !0;
        } catch (e) {}
        return !1;
      }(t)) return I(S(b.call(t)));
      if (function (e) {
        return !("[object Boolean]" !== N(e) || O && "object" == typeof e && O in e);
      }(t)) return I(h.call(t));
      if (function (e) {
        return !("[object String]" !== N(e) || O && "object" == typeof e && O in e);
      }(t)) return I(S(String(t)));
      if (!function (e) {
        return !("[object Date]" !== N(e) || O && "object" == typeof e && O in e);
      }(t) && !function (e) {
        return !("[object RegExp]" !== N(e) || O && "object" == typeof e && O in e);
      }(t)) {
        var J = K(t, S),
          $ = w ? w(t) === Object.prototype : t instanceof Object || t.constructor === Object,
          X = t instanceof Object ? "" : "null prototype",
          Q = !$ && O && Object(t) === t && O in t ? N(t).slice(8, -1) : X ? "Object" : "",
          Z = ($ || "function" != typeof t.constructor ? "" : t.constructor.name ? t.constructor.name + " " : "") + (Q || X ? "[" + [].concat(Q || [], X || []).join(": ") + "] " : "");
        return 0 === J.length ? Z + "{}" : m ? Z + "{" + L(J, m) + "}" : Z + "{ " + J.join(", ") + " }";
      }
      return String(t);
    };
    var j = Object.prototype.hasOwnProperty || function (e) {
      return e in this;
    };
    function R(e, t) {
      return j.call(e, t);
    }
    function N(e) {
      return y.call(e);
    }
    function C(e, t) {
      if (e.indexOf) return e.indexOf(t);
      for (var n = 0, r = e.length; n < r; n++) {
        if (e[n] === t) return n;
      }
      return -1;
    }
    function U(e) {
      var t = e.charCodeAt(0),
        n = {
          8: "b",
          9: "t",
          10: "n",
          12: "f",
          13: "r"
        }[t];
      return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + t.toString(16).toUpperCase();
    }
    function I(e) {
      return "Object(" + e + ")";
    }
    function D(e) {
      return e + " { ? }";
    }
    function F(e, t, n, r) {
      return e + " (" + t + ") {" + (r ? L(n, r) : n.join(", ")) + "}";
    }
    function L(e, t) {
      if (0 === e.length) return "";
      var n = "\n" + t.prev + t.base;
      return n + e.join("," + n) + "\n" + t.prev;
    }
    function K(e, t) {
      var n = M(e),
        r = [];
      if (n) {
        r.length = e.length;
        for (var i = 0; i < e.length; i++) {
          r[i] = R(e, i) ? t(e[i], e) : "";
        }
      }
      var o,
        a = "function" == typeof m ? m(e) : [];
      if (P) {
        o = {};
        for (var u = 0; u < a.length; u++) {
          o["$" + a[u]] = a[u];
        }
      }
      for (var s in e) {
        R(e, s) && (n && String(Number(s)) === s && s < e.length || P && o["$" + s] instanceof Symbol || (/[^\w$]/.test(s) ? r.push(t(s, e) + ": " + t(e[s], e)) : r.push(s + ": " + t(e[s], e))));
      }
      if ("function" == typeof m) for (var c = 0; c < a.length; c++) {
        S.call(e, a[c]) && r.push("[" + t(a[c]) + "]: " + t(e[a[c]], e));
      }
      return r;
    }
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    var r = n(29),
      i = Object.prototype.hasOwnProperty,
      o = Array.isArray,
      a = {
        allowDots: !1,
        allowPrototypes: !1,
        allowSparse: !1,
        arrayLimit: 20,
        charset: "utf-8",
        charsetSentinel: !1,
        comma: !1,
        decoder: r.decode,
        delimiter: "&",
        depth: 5,
        ignoreQueryPrefix: !1,
        interpretNumericEntities: !1,
        parameterLimit: 1e3,
        parseArrays: !0,
        plainObjects: !1,
        strictNullHandling: !1
      },
      u = function u(e) {
        return e.replace(/&#(\d+);/g, function (e, t) {
          return String.fromCharCode(parseInt(t, 10));
        });
      },
      s = function s(e, t) {
        return e && "string" == typeof e && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
      },
      c = function c(e, t, n, r) {
        if (e) {
          var o = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
            a = /(\[[^[\]]*])/g,
            u = n.depth > 0 && /(\[[^[\]]*])/.exec(o),
            c = u ? o.slice(0, u.index) : o,
            l = [];
          if (c) {
            if (!n.plainObjects && i.call(Object.prototype, c) && !n.allowPrototypes) return;
            l.push(c);
          }
          for (var f = 0; n.depth > 0 && null !== (u = a.exec(o)) && f < n.depth;) {
            if (f += 1, !n.plainObjects && i.call(Object.prototype, u[1].slice(1, -1)) && !n.allowPrototypes) return;
            l.push(u[1]);
          }
          return u && l.push("[" + o.slice(u.index) + "]"), function (e, t, n, r) {
            for (var i = r ? t : s(t, n), o = e.length - 1; o >= 0; --o) {
              var a,
                u = e[o];
              if ("[]" === u && n.parseArrays) a = [].concat(i);else {
                a = n.plainObjects ? Object.create(null) : {};
                var c = "[" === u.charAt(0) && "]" === u.charAt(u.length - 1) ? u.slice(1, -1) : u,
                  l = parseInt(c, 10);
                n.parseArrays || "" !== c ? !isNaN(l) && u !== c && String(l) === c && l >= 0 && n.parseArrays && l <= n.arrayLimit ? (a = [])[l] = i : a[c] = i : a = {
                  0: i
                };
              }
              i = a;
            }
            return i;
          }(l, t, n, r);
        }
      };
    e.exports = function (e, t) {
      var n = function (e) {
        if (!e) return a;
        if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
        if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var t = void 0 === e.charset ? a.charset : e.charset;
        return {
          allowDots: void 0 === e.allowDots ? a.allowDots : !!e.allowDots,
          allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : a.allowPrototypes,
          allowSparse: "boolean" == typeof e.allowSparse ? e.allowSparse : a.allowSparse,
          arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : a.arrayLimit,
          charset: t,
          charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : a.charsetSentinel,
          comma: "boolean" == typeof e.comma ? e.comma : a.comma,
          decoder: "function" == typeof e.decoder ? e.decoder : a.decoder,
          delimiter: "string" == typeof e.delimiter || r.isRegExp(e.delimiter) ? e.delimiter : a.delimiter,
          depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : a.depth,
          ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
          interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : a.interpretNumericEntities,
          parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : a.parameterLimit,
          parseArrays: !1 !== e.parseArrays,
          plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : a.plainObjects,
          strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : a.strictNullHandling
        };
      }(t);
      if ("" === e || null == e) return n.plainObjects ? Object.create(null) : {};
      for (var l = "string" == typeof e ? function (e, t) {
          var n,
            c = {},
            l = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
            f = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
            d = l.split(t.delimiter, f),
            p = -1,
            h = t.charset;
          if (t.charsetSentinel) for (n = 0; n < d.length; ++n) {
            0 === d[n].indexOf("utf8=") && ("utf8=%E2%9C%93" === d[n] ? h = "utf-8" : "utf8=%26%2310003%3B" === d[n] && (h = "iso-8859-1"), p = n, n = d.length);
          }
          for (n = 0; n < d.length; ++n) {
            if (n !== p) {
              var y,
                g,
                v = d[n],
                b = v.indexOf("]="),
                m = -1 === b ? v.indexOf("=") : b + 1;
              -1 === m ? (y = t.decoder(v, a.decoder, h, "key"), g = t.strictNullHandling ? null : "") : (y = t.decoder(v.slice(0, m), a.decoder, h, "key"), g = r.maybeMap(s(v.slice(m + 1), t), function (e) {
                return t.decoder(e, a.decoder, h, "value");
              })), g && t.interpretNumericEntities && "iso-8859-1" === h && (g = u(g)), v.indexOf("[]=") > -1 && (g = o(g) ? [g] : g), i.call(c, y) ? c[y] = r.combine(c[y], g) : c[y] = g;
            }
          }
          return c;
        }(e, n) : e, f = n.plainObjects ? Object.create(null) : {}, d = Object.keys(l), p = 0; p < d.length; ++p) {
        var h = d[p],
          y = c(h, l[h], n, "string" == typeof e);
        f = r.merge(f, y, n);
      }
      return !0 === n.allowSparse ? f : r.compact(f);
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    var i = n(30);
    function o(e) {
      if (e) return function (e) {
        for (var t in o.prototype) {
          Object.prototype.hasOwnProperty.call(o.prototype, t) && (e[t] = o.prototype[t]);
        }
        return e;
      }(e);
    }
    e.exports = o, o.prototype.clearTimeout = function () {
      return clearTimeout(this._timer), clearTimeout(this._responseTimeoutTimer), clearTimeout(this._uploadTimeoutTimer), delete this._timer, delete this._responseTimeoutTimer, delete this._uploadTimeoutTimer, this;
    }, o.prototype.parse = function (e) {
      return this._parser = e, this;
    }, o.prototype.responseType = function (e) {
      return this._responseType = e, this;
    }, o.prototype.serialize = function (e) {
      return this._serializer = e, this;
    }, o.prototype.timeout = function (e) {
      if (!e || "object" !== r(e)) return this._timeout = e, this._responseTimeout = 0, this._uploadTimeout = 0, this;
      for (var t in e) {
        if (Object.prototype.hasOwnProperty.call(e, t)) switch (t) {
          case "deadline":
            this._timeout = e.deadline;
            break;
          case "response":
            this._responseTimeout = e.response;
            break;
          case "upload":
            this._uploadTimeout = e.upload;
            break;
          default:
            console.warn("Unknown timeout option", t);
        }
      }
      return this;
    }, o.prototype.retry = function (e, t) {
      return 0 !== arguments.length && !0 !== e || (e = 1), e <= 0 && (e = 0), this._maxRetries = e, this._retries = 0, this._retryCallback = t, this;
    };
    var a = new Set(["ETIMEDOUT", "ECONNRESET", "EADDRINUSE", "ECONNREFUSED", "EPIPE", "ENOTFOUND", "ENETUNREACH", "EAI_AGAIN"]),
      u = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]);
    o.prototype._shouldRetry = function (e, t) {
      if (!this._maxRetries || this._retries++ >= this._maxRetries) return !1;
      if (this._retryCallback) try {
        var n = this._retryCallback(e, t);
        if (!0 === n) return !0;
        if (!1 === n) return !1;
      } catch (e) {
        console.error(e);
      }
      if (t && t.status && u.has(t.status)) return !0;
      if (e) {
        if (e.code && a.has(e.code)) return !0;
        if (e.timeout && "ECONNABORTED" === e.code) return !0;
        if (e.crossDomain) return !0;
      }
      return !1;
    }, o.prototype._retry = function () {
      return this.clearTimeout(), this.req && (this.req = null, this.req = this.request()), this._aborted = !1, this.timedout = !1, this.timedoutError = null, this._end();
    }, o.prototype.then = function (e, t) {
      var n = this;
      if (!this._fullfilledPromise) {
        var r = this;
        this._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), this._fullfilledPromise = new Promise(function (e, t) {
          r.on("abort", function () {
            if (!(n._maxRetries && n._maxRetries > n._retries)) if (n.timedout && n.timedoutError) t(n.timedoutError);else {
              var e = new Error("Aborted");
              e.code = "ABORTED", e.status = n.status, e.method = n.method, e.url = n.url, t(e);
            }
          }), r.end(function (n, r) {
            n ? t(n) : e(r);
          });
        });
      }
      return this._fullfilledPromise.then(e, t);
    }, o.prototype.catch = function (e) {
      return this.then(void 0, e);
    }, o.prototype.use = function (e) {
      return e(this), this;
    }, o.prototype.ok = function (e) {
      if ("function" != typeof e) throw new Error("Callback required");
      return this._okCallback = e, this;
    }, o.prototype._isResponseOK = function (e) {
      return !!e && (this._okCallback ? this._okCallback(e) : e.status >= 200 && e.status < 300);
    }, o.prototype.get = function (e) {
      return this._header[e.toLowerCase()];
    }, o.prototype.getHeader = o.prototype.get, o.prototype.set = function (e, t) {
      if (i(e)) {
        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && this.set(n, e[n]);
        }
        return this;
      }
      return this._header[e.toLowerCase()] = t, this.header[e] = t, this;
    }, o.prototype.unset = function (e) {
      return delete this._header[e.toLowerCase()], delete this.header[e], this;
    }, o.prototype.field = function (e, t) {
      if (null == e) throw new Error(".field(name, val) name can not be empty");
      if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
      if (i(e)) {
        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && this.field(n, e[n]);
        }
        return this;
      }
      if (Array.isArray(t)) {
        for (var r in t) {
          Object.prototype.hasOwnProperty.call(t, r) && this.field(e, t[r]);
        }
        return this;
      }
      if (null == t) throw new Error(".field(name, val) val can not be empty");
      return "boolean" == typeof t && (t = String(t)), this._getFormData().append(e, t), this;
    }, o.prototype.abort = function () {
      return this._aborted || (this._aborted = !0, this.xhr && this.xhr.abort(), this.req && this.req.abort(), this.clearTimeout(), this.emit("abort")), this;
    }, o.prototype._auth = function (e, t, n, r) {
      switch (n.type) {
        case "basic":
          this.set("Authorization", "Basic ".concat(r("".concat(e, ":").concat(t))));
          break;
        case "auto":
          this.username = e, this.password = t;
          break;
        case "bearer":
          this.set("Authorization", "Bearer ".concat(e));
      }
      return this;
    }, o.prototype.withCredentials = function (e) {
      return void 0 === e && (e = !0), this._withCredentials = e, this;
    }, o.prototype.redirects = function (e) {
      return this._maxRedirects = e, this;
    }, o.prototype.maxResponseSize = function (e) {
      if ("number" != typeof e) throw new TypeError("Invalid argument");
      return this._maxResponseSize = e, this;
    }, o.prototype.toJSON = function () {
      return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
      };
    }, o.prototype.send = function (e) {
      var t = i(e),
        n = this._header["content-type"];
      if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
      if (t && !this._data) Array.isArray(e) ? this._data = [] : this._isHost(e) || (this._data = {});else if (e && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
      if (t && i(this._data)) for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (this._data[r] = e[r]);
      } else "string" == typeof e ? (n || this.type("form"), (n = this._header["content-type"]) && (n = n.toLowerCase().trim()), this._data = "application/x-www-form-urlencoded" === n ? this._data ? "".concat(this._data, "&").concat(e) : e : (this._data || "") + e) : this._data = e;
      return !t || this._isHost(e) || n || this.type("json"), this;
    }, o.prototype.sortQuery = function (e) {
      return this._sort = void 0 === e || e, this;
    }, o.prototype._finalizeQueryString = function () {
      var e = this._query.join("&");
      if (e && (this.url += (this.url.includes("?") ? "&" : "?") + e), this._query.length = 0, this._sort) {
        var t = this.url.indexOf("?");
        if (t >= 0) {
          var n = this.url.slice(t + 1).split("&");
          "function" == typeof this._sort ? n.sort(this._sort) : n.sort(), this.url = this.url.slice(0, t) + "?" + n.join("&");
        }
      }
    }, o.prototype._appendQueryString = function () {
      console.warn("Unsupported");
    }, o.prototype._timeoutError = function (e, t, n) {
      if (!this._aborted) {
        var r = new Error("".concat(e + t, "ms exceeded"));
        r.timeout = t, r.code = "ECONNABORTED", r.errno = n, this.timedout = !0, this.timedoutError = r, this.abort(), this.callback(r);
      }
    }, o.prototype._setTimeouts = function () {
      var e = this;
      this._timeout && !this._timer && (this._timer = setTimeout(function () {
        e._timeoutError("Timeout of ", e._timeout, "ETIME");
      }, this._timeout)), this._responseTimeout && !this._responseTimeoutTimer && (this._responseTimeoutTimer = setTimeout(function () {
        e._timeoutError("Response timeout of ", e._responseTimeout, "ETIMEDOUT");
      }, this._responseTimeout));
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(146);
    function i(e) {
      if (e) return function (e) {
        for (var t in i.prototype) {
          Object.prototype.hasOwnProperty.call(i.prototype, t) && (e[t] = i.prototype[t]);
        }
        return e;
      }(e);
    }
    e.exports = i, i.prototype.get = function (e) {
      return this.header[e.toLowerCase()];
    }, i.prototype._setHeaderProperties = function (e) {
      var t = e["content-type"] || "";
      this.type = r.type(t);
      var n = r.params(t);
      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && (this[i] = n[i]);
      }
      this.links = {};
      try {
        e.link && (this.links = r.parseLinks(e.link));
      } catch (e) {}
    }, i.prototype._setStatusProperties = function (e) {
      var t = e / 100 | 0;
      this.statusCode = e, this.status = this.statusCode, this.statusType = t, this.info = 1 === t, this.ok = 2 === t, this.redirect = 3 === t, this.clientError = 4 === t, this.serverError = 5 === t, this.error = (4 === t || 5 === t) && this.toError(), this.created = 201 === e, this.accepted = 202 === e, this.noContent = 204 === e, this.badRequest = 400 === e, this.unauthorized = 401 === e, this.notAcceptable = 406 === e, this.forbidden = 403 === e, this.notFound = 404 === e, this.unprocessableEntity = 422 === e;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var _n;
      if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
        if (Array.isArray(e) || (_n = function (e, t) {
          if (!e) return;
          if ("string" == typeof e) return i(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === n && e.constructor && (n = e.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(e);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(e, t);
        }(e)) || t && e && "number" == typeof e.length) {
          _n && (e = _n);
          var r = 0,
            o = function o() {};
          return {
            s: o,
            n: function n() {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            },
            e: function e(_e2) {
              throw _e2;
            },
            f: o
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var a,
        u = !0,
        s = !1;
      return {
        s: function s() {
          _n = e[Symbol.iterator]();
        },
        n: function n() {
          var e = _n.next();
          return u = e.done, e;
        },
        e: function e(_e3) {
          s = !0, a = _e3;
        },
        f: function f() {
          try {
            u || null == _n.return || _n.return();
          } finally {
            if (s) throw a;
          }
        }
      };
    }
    function i(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }
      return r;
    }
    t.type = function (e) {
      return e.split(/ *; */).shift();
    }, t.params = function (e) {
      var t,
        n = {},
        i = r(e.split(/ *; */));
      try {
        for (i.s(); !(t = i.n()).done;) {
          var o = t.value.split(/ *= */),
            a = o.shift(),
            u = o.shift();
          a && u && (n[a] = u);
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
      return n;
    }, t.parseLinks = function (e) {
      var t,
        n = {},
        i = r(e.split(/ *, */));
      try {
        for (i.s(); !(t = i.n()).done;) {
          var o = t.value.split(/ *; */),
            a = o[0].slice(1, -1);
          n[o[1].split(/ *= */)[1].slice(1, -1)] = a;
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
      return n;
    }, t.cleanHeader = function (e, t) {
      return delete e["content-type"], delete e["content-length"], delete e["transfer-encoding"], delete e.host, t && (delete e.authorization, delete e.cookie), e;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function (e) {
        if (Array.isArray(e)) return i(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return i(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function i(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }
      return r;
    }
    function o() {
      this._defaults = [];
    }
    ["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert", "disableTLSCerts"].forEach(function (e) {
      o.prototype[e] = function () {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
          n[r] = arguments[r];
        }
        return this._defaults.push({
          fn: e,
          args: n
        }), this;
      };
    }), o.prototype._setDefaults = function (e) {
      this._defaults.forEach(function (t) {
        e[t.fn].apply(e, r(t.args));
      });
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    (function (r) {
      var i = n(0);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = i(n(11)),
        a = i(n(12)),
        u = i(n(5)),
        s = i(n(6)),
        c = i(n(4));
      function l(e, t) {
        var n = new Uint8Array(e.byteLength + t.byteLength);
        return n.set(new Uint8Array(e), 0), n.set(new Uint8Array(t), e.byteLength), n.buffer;
      }
      var f = function () {
        function e() {
          (0, u.default)(this, e);
        }
        var t, n, i, c, f, d, p, h, y;
        return (0, s.default)(e, [{
          key: "algo",
          get: function get() {
            return "aes-256-cbc";
          }
        }, {
          key: "encrypt",
          value: (y = (0, a.default)(o.default.mark(function e(t, n) {
            var r;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.getKey(t);
                  case 2:
                    if (r = e.sent, !(n instanceof ArrayBuffer)) {
                      e.next = 7;
                      break;
                    }
                    return e.abrupt("return", this.encryptArrayBuffer(r, n));
                  case 7:
                    if ("string" != typeof n) {
                      e.next = 11;
                      break;
                    }
                    return e.abrupt("return", this.encryptString(r, n));
                  case 11:
                    throw new Error("Cannot encrypt this file. In browsers file encryption supports only string or ArrayBuffer");
                  case 12:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (e, t) {
            return y.apply(this, arguments);
          })
        }, {
          key: "decrypt",
          value: (h = (0, a.default)(o.default.mark(function e(t, n) {
            var r;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.getKey(t);
                  case 2:
                    if (r = e.sent, !(n instanceof ArrayBuffer)) {
                      e.next = 7;
                      break;
                    }
                    return e.abrupt("return", this.decryptArrayBuffer(r, n));
                  case 7:
                    if ("string" != typeof n) {
                      e.next = 11;
                      break;
                    }
                    return e.abrupt("return", this.decryptString(r, n));
                  case 11:
                    throw new Error("Cannot decrypt this file. In browsers file decryption supports only string or ArrayBuffer");
                  case 12:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (e, t) {
            return h.apply(this, arguments);
          })
        }, {
          key: "encryptFile",
          value: (p = (0, a.default)(o.default.mark(function e(t, n, r) {
            var i, a, u;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.getKey(t);
                  case 2:
                    return i = e.sent, e.next = 5, n.toArrayBuffer();
                  case 5:
                    return a = e.sent, e.next = 8, this.encryptArrayBuffer(i, a);
                  case 8:
                    return u = e.sent, e.abrupt("return", r.create({
                      name: n.name,
                      mimeType: "application/octet-stream",
                      data: u
                    }));
                  case 10:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (e, t, n) {
            return p.apply(this, arguments);
          })
        }, {
          key: "decryptFile",
          value: (d = (0, a.default)(o.default.mark(function e(t, n, r) {
            var i, a, u;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.getKey(t);
                  case 2:
                    return i = e.sent, e.next = 5, n.toArrayBuffer();
                  case 5:
                    return a = e.sent, e.next = 8, this.decryptArrayBuffer(i, a);
                  case 8:
                    return u = e.sent, e.abrupt("return", r.create({
                      name: n.name,
                      data: u
                    }));
                  case 10:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function (e, t, n) {
            return d.apply(this, arguments);
          })
        }, {
          key: "getKey",
          value: (f = (0, a.default)(o.default.mark(function e(t) {
            var n, i, a;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = r.from(t), e.next = 3, crypto.subtle.digest("SHA-256", n.buffer);
                  case 3:
                    return i = e.sent, a = r.from(r.from(i).toString("hex").slice(0, 32), "utf8").buffer, e.abrupt("return", crypto.subtle.importKey("raw", a, "AES-CBC", !0, ["encrypt", "decrypt"]));
                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function (e) {
            return f.apply(this, arguments);
          })
        }, {
          key: "encryptArrayBuffer",
          value: (c = (0, a.default)(o.default.mark(function e(t, n) {
            var r;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return r = crypto.getRandomValues(new Uint8Array(16)), e.t0 = l, e.t1 = r.buffer, e.next = 5, crypto.subtle.encrypt({
                      name: "AES-CBC",
                      iv: r
                    }, t, n);
                  case 5:
                    return e.t2 = e.sent, e.abrupt("return", (0, e.t0)(e.t1, e.t2));
                  case 7:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function (e, t) {
            return c.apply(this, arguments);
          })
        }, {
          key: "decryptArrayBuffer",
          value: (i = (0, a.default)(o.default.mark(function e(t, n) {
            var r;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return r = n.slice(0, 16), e.abrupt("return", crypto.subtle.decrypt({
                      name: "AES-CBC",
                      iv: r
                    }, t, n.slice(16)));
                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function (e, t) {
            return i.apply(this, arguments);
          })
        }, {
          key: "encryptString",
          value: (n = (0, a.default)(o.default.mark(function e(t, n) {
            var i, a, u, s;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return i = crypto.getRandomValues(new Uint8Array(16)), a = r.from(n).buffer, e.next = 4, crypto.subtle.encrypt({
                      name: "AES-CBC",
                      iv: i
                    }, t, a);
                  case 4:
                    return u = e.sent, s = l(i.buffer, u), e.abrupt("return", r.from(s).toString("utf8"));
                  case 7:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function (e, t) {
            return n.apply(this, arguments);
          })
        }, {
          key: "decryptString",
          value: (t = (0, a.default)(o.default.mark(function e(t, n) {
            var i, a, u, s;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return i = r.from(n), a = i.slice(0, 16), u = i.slice(16), e.next = 5, crypto.subtle.decrypt({
                      name: "AES-CBC",
                      iv: a
                    }, t, u);
                  case 5:
                    return s = e.sent, e.abrupt("return", r.from(s).toString("utf8"));
                  case 7:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function (e, n) {
            return t.apply(this, arguments);
          })
        }]), e;
      }();
      t.default = f, (0, c.default)(f, "IV_LENGTH", 16), e.exports = t.default;
    }).call(this, n(24).Buffer);
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i,
      o,
      a = r(n(11)),
      u = r(n(12)),
      s = r(n(5)),
      c = r(n(6)),
      l = r(n(4)),
      f = (n(28), o = i = function () {
        function e(t) {
          if ((0, s.default)(this, e), (0, l.default)(this, "data", void 0), (0, l.default)(this, "name", void 0), (0, l.default)(this, "mimeType", void 0), t instanceof File) this.data = t, this.name = this.data.name, this.mimeType = this.data.type;else if (t.data) {
            var n = t.data;
            this.data = new File([n], t.name, {
              type: t.mimeType
            }), this.name = t.name, t.mimeType && (this.mimeType = t.mimeType);
          }
          if (void 0 === this.data) throw new Error("Couldn't construct a file out of supplied options.");
          if (void 0 === this.name) throw new Error("Couldn't guess filename out of the options. Please provide one.");
        }
        var t, n, r, i, o, f, d;
        return (0, c.default)(e, [{
          key: "toBuffer",
          value: (d = (0, u.default)(a.default.mark(function e() {
            return a.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    throw new Error("This feature is only supported in Node.js environments.");
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return d.apply(this, arguments);
          })
        }, {
          key: "toStream",
          value: (f = (0, u.default)(a.default.mark(function e() {
            return a.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    throw new Error("This feature is only supported in Node.js environments.");
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return f.apply(this, arguments);
          })
        }, {
          key: "toFileUri",
          value: (o = (0, u.default)(a.default.mark(function e() {
            return a.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    throw new Error("This feature is only supported in react native environments.");
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return o.apply(this, arguments);
          })
        }, {
          key: "toBlob",
          value: (i = (0, u.default)(a.default.mark(function e() {
            return a.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", this.data);
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function () {
            return i.apply(this, arguments);
          })
        }, {
          key: "toArrayBuffer",
          value: (r = (0, u.default)(a.default.mark(function e() {
            var t = this;
            return a.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", new Promise(function (e, n) {
                      var r = new FileReader();
                      r.addEventListener("load", function () {
                        if (r.result instanceof ArrayBuffer) return e(r.result);
                      }), r.addEventListener("error", function () {
                        n(r.error);
                      }), r.readAsArrayBuffer(t.data);
                    }));
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return r.apply(this, arguments);
          })
        }, {
          key: "toString",
          value: (n = (0, u.default)(a.default.mark(function e() {
            var t = this;
            return a.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", new Promise(function (e, n) {
                      var r = new FileReader();
                      r.addEventListener("load", function () {
                        if ("string" == typeof r.result) return e(r.result);
                      }), r.addEventListener("error", function () {
                        n(r.error);
                      }), r.readAsBinaryString(t.data);
                    }));
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return n.apply(this, arguments);
          })
        }, {
          key: "toFile",
          value: (t = (0, u.default)(a.default.mark(function e() {
            return a.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", this.data);
                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function () {
            return t.apply(this, arguments);
          })
        }], [{
          key: "create",
          value: function value(e) {
            return new this(e);
          }
        }]), e;
      }(), (0, l.default)(i, "supportsFile", "undefined" != typeof File), (0, l.default)(i, "supportsBlob", "undefined" != typeof Blob), (0, l.default)(i, "supportsArrayBuffer", "undefined" != typeof ArrayBuffer), (0, l.default)(i, "supportsBuffer", !1), (0, l.default)(i, "supportsStream", !1), (0, l.default)(i, "supportsString", !0), (0, l.default)(i, "supportsEncryptFile", !0), (0, l.default)(i, "supportsFileUri", !1), o);
    t.default = f, e.exports = t.default;
  }]);
});